module.exports = [{
  "id": 1, "n": "北京", "c": [{
    "id": 2, "n": "北京市", "c": [{
      "id": 3, "n": "东城区"
    }, {
      "id": 4, "n": "西城区"
    }, {
      "id": 5, "n": "朝阳区"
    }, {
      "id": 6, "n": "丰台区"
    }, {
      "id": 7, "n": "石景山区"
    }, {
      "id": 8, "n": "海淀区"
    }, {
      "id": 9, "n": "门头沟区"
    }, {
      "id": 10, "n": "房山区"
    }, {
      "id": 11, "n": "通州区"
    }, {
      "id": 12, "n": "顺义区"
    }, {
      "id": 13, "n": "昌平区"
    }, {
      "id": 14, "n": "大兴区"
    }, {
      "id": 15, "n": "怀柔区"
    }, {
      "id": 16, "n": "平谷区"
    }, {
      "id": 17, "n": "密云区"
    }, {
      "id": 18, "n": "延庆区"
    }]
  }]
}, {
  "id": 19, "n": "天津", "c": [{
    "id": 20, "n": "天津市", "c": [{
      "id": 21, "n": "和平区"
    }, {
      "id": 22, "n": "河东区"
    }, {
      "id": 23, "n": "河西区"
    }, {
      "id": 24, "n": "南开区"
    }, {
      "id": 25, "n": "河北区"
    }, {
      "id": 26, "n": "红桥区"
    }, {
      "id": 27, "n": "东丽区"
    }, {
      "id": 28, "n": "西青区"
    }, {
      "id": 29, "n": "津南区"
    }, {
      "id": 30, "n": "北辰区"
    }, {
      "id": 31, "n": "武清区"
    }, {
      "id": 32, "n": "宝坻区"
    }, {
      "id": 33, "n": "滨海新区"
    }, {
      "id": 34, "n": "宁河县"
    }, {
      "id": 35, "n": "静海县"
    }, {
      "id": 36, "n": "蓟县"
    }]
  }]
}, {
  "id": 37, "n": "河北省", "c": [{
    "id": 38, "n": "石家庄市", "c": [{
      "id": 39, "n": "长安区"
    }, {
      "id": 40, "n": "桥西区"
    }, {
      "id": 41, "n": "新华区"
    }, {
      "id": 42, "n": "井陉矿区"
    }, {
      "id": 43, "n": "裕华区"
    }, {
      "id": 44, "n": "藁城区"
    }, {
      "id": 45, "n": "鹿泉区"
    }, {
      "id": 46, "n": "栾城区"
    }, {
      "id": 47, "n": "井陉县"
    }, {
      "id": 48, "n": "正定县"
    }, {
      "id": 49, "n": "行唐县"
    }, {
      "id": 50, "n": "灵寿县"
    }, {
      "id": 51, "n": "高邑县"
    }, {
      "id": 52, "n": "深泽县"
    }, {
      "id": 53, "n": "赞皇县"
    }, {
      "id": 54, "n": "无极县"
    }, {
      "id": 55, "n": "平山县"
    }, {
      "id": 56, "n": "元氏县"
    }, {
      "id": 57, "n": "赵县"
    }, {
      "id": 58, "n": "辛集市"
    }, {
      "id": 59, "n": "晋州市"
    }, {
      "id": 60, "n": "新乐市"
    }]
  }, {
    "id": 61, "n": "唐山市", "c": [{
      "id": 62, "n": "路南区"
    }, {
      "id": 63, "n": "路北区"
    }, {
      "id": 64, "n": "古冶区"
    }, {
      "id": 65, "n": "开平区"
    }, {
      "id": 66, "n": "丰南区"
    }, {
      "id": 67, "n": "丰润区"
    }, {
      "id": 68, "n": "曹妃甸区"
    }, {
      "id": 69, "n": "滦县"
    }, {
      "id": 70, "n": "滦南县"
    }, {
      "id": 71, "n": "乐亭县"
    }, {
      "id": 72, "n": "迁西县"
    }, {
      "id": 73, "n": "玉田县"
    }, {
      "id": 74, "n": "遵化市"
    }, {
      "id": 75, "n": "迁安市"
    }]
  }, {
    "id": 76, "n": "秦皇岛市", "c": [{
      "id": 77, "n": "海港区"
    }, {
      "id": 78, "n": "山海关区"
    }, {
      "id": 79, "n": "北戴河区"
    }, {
      "id": 80, "n": "青龙满族自治县"
    }, {
      "id": 81, "n": "昌黎县"
    }, {
      "id": 82, "n": "抚宁县"
    }, {
      "id": 83, "n": "卢龙县"
    }]
  }, {
    "id": 84, "n": "邯郸市", "c": [{
      "id": 85, "n": "邯山区"
    }, {
      "id": 86, "n": "丛台区"
    }, {
      "id": 87, "n": "复兴区"
    }, {
      "id": 88, "n": "峰峰矿区"
    }, {
      "id": 89, "n": "邯郸县"
    }, {
      "id": 90, "n": "临漳县"
    }, {
      "id": 91, "n": "成安县"
    }, {
      "id": 92, "n": "大名县"
    }, {
      "id": 93, "n": "涉县"
    }, {
      "id": 94, "n": "磁县"
    }, {
      "id": 95, "n": "肥乡县"
    }, {
      "id": 96, "n": "永年县"
    }, {
      "id": 97, "n": "邱县"
    }, {
      "id": 98, "n": "鸡泽县"
    }, {
      "id": 99, "n": "广平县"
    }, {
      "id": 100, "n": "馆陶县"
    }, {
      "id": 101, "n": "魏县"
    }, {
      "id": 102, "n": "曲周县"
    }, {
      "id": 103, "n": "武安市"
    }]
  }, {
    "id": 104, "n": "邢台市", "c": [{
      "id": 105, "n": "桥东区"
    }, {
      "id": 106, "n": "桥西区"
    }, {
      "id": 107, "n": "邢台县"
    }, {
      "id": 108, "n": "临城县"
    }, {
      "id": 109, "n": "内丘县"
    }, {
      "id": 110, "n": "柏乡县"
    }, {
      "id": 111, "n": "隆尧县"
    }, {
      "id": 112, "n": "任县"
    }, {
      "id": 113, "n": "南和县"
    }, {
      "id": 114, "n": "宁晋县"
    }, {
      "id": 115, "n": "巨鹿县"
    }, {
      "id": 116, "n": "新河县"
    }, {
      "id": 117, "n": "广宗县"
    }, {
      "id": 118, "n": "平乡县"
    }, {
      "id": 119, "n": "威县"
    }, {
      "id": 120, "n": "清河县"
    }, {
      "id": 121, "n": "临西县"
    }, {
      "id": 122, "n": "南宫市"
    }, {
      "id": 123, "n": "沙河市"
    }]
  }, {
    "id": 124, "n": "保定市", "c": [{
      "id": 125, "n": "新市区"
    }, {
      "id": 126, "n": "北市区"
    }, {
      "id": 127, "n": "南市区"
    }, {
      "id": 128, "n": "满城县"
    }, {
      "id": 129, "n": "清苑县"
    }, {
      "id": 130, "n": "涞水县"
    }, {
      "id": 131, "n": "阜平县"
    }, {
      "id": 132, "n": "徐水县"
    }, {
      "id": 133, "n": "定兴县"
    }, {
      "id": 134, "n": "唐县"
    }, {
      "id": 135, "n": "高阳县"
    }, {
      "id": 136, "n": "容城县"
    }, {
      "id": 137, "n": "涞源县"
    }, {
      "id": 138, "n": "望都县"
    }, {
      "id": 139, "n": "安新县"
    }, {
      "id": 140, "n": "易县"
    }, {
      "id": 141, "n": "曲阳县"
    }, {
      "id": 142, "n": "蠡县"
    }, {
      "id": 143, "n": "顺平县"
    }, {
      "id": 144, "n": "博野县"
    }, {
      "id": 145, "n": "雄县"
    }, {
      "id": 146, "n": "涿州市"
    }, {
      "id": 147, "n": "定州市"
    }, {
      "id": 148, "n": "安国市"
    }, {
      "id": 149, "n": "高碑店市"
    }]
  }, {
    "id": 150, "n": "张家口市", "c": [{
      "id": 151, "n": "桥东区"
    }, {
      "id": 152, "n": "桥西区"
    }, {
      "id": 153, "n": "宣化区"
    }, {
      "id": 154, "n": "下花园区"
    }, {
      "id": 155, "n": "宣化县"
    }, {
      "id": 156, "n": "张北县"
    }, {
      "id": 157, "n": "康保县"
    }, {
      "id": 158, "n": "沽源县"
    }, {
      "id": 159, "n": "尚义县"
    }, {
      "id": 160, "n": "蔚县"
    }, {
      "id": 161, "n": "阳原县"
    }, {
      "id": 162, "n": "怀安县"
    }, {
      "id": 163, "n": "万全县"
    }, {
      "id": 164, "n": "怀来县"
    }, {
      "id": 165, "n": "涿鹿县"
    }, {
      "id": 166, "n": "赤城县"
    }, {
      "id": 167, "n": "崇礼县"
    }]
  }, {
    "id": 168, "n": "承德市", "c": [{
      "id": 169, "n": "双桥区"
    }, {
      "id": 170, "n": "双滦区"
    }, {
      "id": 171, "n": "鹰手营子矿区"
    }, {
      "id": 172, "n": "承德县"
    }, {
      "id": 173, "n": "兴隆县"
    }, {
      "id": 174, "n": "平泉县"
    }, {
      "id": 175, "n": "滦平县"
    }, {
      "id": 176, "n": "隆化县"
    }, {
      "id": 177, "n": "丰宁满族自治县"
    }, {
      "id": 178, "n": "宽城满族自治县"
    }, {
      "id": 179, "n": "围场满族蒙古族自治县"
    }]
  }, {
    "id": 180, "n": "沧州市", "c": [{
      "id": 181, "n": "新华区"
    }, {
      "id": 182, "n": "运河区"
    }, {
      "id": 183, "n": "沧县"
    }, {
      "id": 184, "n": "青县"
    }, {
      "id": 185, "n": "东光县"
    }, {
      "id": 186, "n": "海兴县"
    }, {
      "id": 187, "n": "盐山县"
    }, {
      "id": 188, "n": "肃宁县"
    }, {
      "id": 189, "n": "南皮县"
    }, {
      "id": 190, "n": "吴桥县"
    }, {
      "id": 191, "n": "献县"
    }, {
      "id": 192, "n": "孟村回族自治县"
    }, {
      "id": 193, "n": "泊头市"
    }, {
      "id": 194, "n": "任丘市"
    }, {
      "id": 195, "n": "黄骅市"
    }, {
      "id": 196, "n": "河间市"
    }]
  }, {
    "id": 197, "n": "廊坊市", "c": [{
      "id": 198, "n": "安次区"
    }, {
      "id": 199, "n": "广阳区"
    }, {
      "id": 200, "n": "固安县"
    }, {
      "id": 201, "n": "永清县"
    }, {
      "id": 202, "n": "香河县"
    }, {
      "id": 203, "n": "大城县"
    }, {
      "id": 204, "n": "文安县"
    }, {
      "id": 205, "n": "大厂回族自治县"
    }, {
      "id": 206, "n": "霸州市"
    }, {
      "id": 207, "n": "三河市"
    }]
  }, {
    "id": 208, "n": "衡水市", "c": [{
      "id": 209, "n": "桃城区"
    }, {
      "id": 210, "n": "枣强县"
    }, {
      "id": 211, "n": "武邑县"
    }, {
      "id": 212, "n": "武强县"
    }, {
      "id": 213, "n": "饶阳县"
    }, {
      "id": 214, "n": "安平县"
    }, {
      "id": 215, "n": "故城县"
    }, {
      "id": 216, "n": "景县"
    }, {
      "id": 217, "n": "阜城县"
    }, {
      "id": 218, "n": "冀州市"
    }, {
      "id": 219, "n": "深州市"
    }]
  }]
}, {
  "id": 220, "n": "山西省", "c": [{
    "id": 221, "n": "太原市", "c": [{
      "id": 222, "n": "小店区"
    }, {
      "id": 223, "n": "迎泽区"
    }, {
      "id": 224, "n": "杏花岭区"
    }, {
      "id": 225, "n": "尖草坪区"
    }, {
      "id": 226, "n": "万柏林区"
    }, {
      "id": 227, "n": "晋源区"
    }, {
      "id": 228, "n": "清徐县"
    }, {
      "id": 229, "n": "阳曲县"
    }, {
      "id": 230, "n": "娄烦县"
    }, {
      "id": 231, "n": "古交市"
    }]
  }, {
    "id": 232, "n": "大同市", "c": [{
      "id": 233, "n": "城区"
    }, {
      "id": 234, "n": "矿区"
    }, {
      "id": 235, "n": "南郊区"
    }, {
      "id": 236, "n": "新荣区"
    }, {
      "id": 237, "n": "阳高县"
    }, {
      "id": 238, "n": "天镇县"
    }, {
      "id": 239, "n": "广灵县"
    }, {
      "id": 240, "n": "灵丘县"
    }, {
      "id": 241, "n": "浑源县"
    }, {
      "id": 242, "n": "左云县"
    }, {
      "id": 243, "n": "大同县"
    }]
  }, {
    "id": 244, "n": "阳泉市", "c": [{
      "id": 245, "n": "城区"
    }, {
      "id": 246, "n": "矿区"
    }, {
      "id": 247, "n": "郊区"
    }, {
      "id": 248, "n": "平定县"
    }, {
      "id": 249, "n": "盂县"
    }]
  }, {
    "id": 250, "n": "长治市", "c": [{
      "id": 251, "n": "城区"
    }, {
      "id": 252, "n": "郊区"
    }, {
      "id": 253, "n": "长治县"
    }, {
      "id": 254, "n": "襄垣县"
    }, {
      "id": 255, "n": "屯留县"
    }, {
      "id": 256, "n": "平顺县"
    }, {
      "id": 257, "n": "黎城县"
    }, {
      "id": 258, "n": "壶关县"
    }, {
      "id": 259, "n": "长子县"
    }, {
      "id": 260, "n": "武乡县"
    }, {
      "id": 261, "n": "沁县"
    }, {
      "id": 262, "n": "沁源县"
    }, {
      "id": 263, "n": "潞城市"
    }]
  }, {
    "id": 264, "n": "晋城市", "c": [{
      "id": 265, "n": "城区"
    }, {
      "id": 266, "n": "沁水县"
    }, {
      "id": 267, "n": "阳城县"
    }, {
      "id": 268, "n": "陵川县"
    }, {
      "id": 269, "n": "泽州县"
    }, {
      "id": 270, "n": "高平市"
    }]
  }, {
    "id": 271, "n": "朔州市", "c": [{
      "id": 272, "n": "朔城区"
    }, {
      "id": 273, "n": "平鲁区"
    }, {
      "id": 274, "n": "山阴县"
    }, {
      "id": 275, "n": "应县"
    }, {
      "id": 276, "n": "右玉县"
    }, {
      "id": 277, "n": "怀仁县"
    }]
  }, {
    "id": 278, "n": "晋中市", "c": [{
      "id": 279, "n": "榆次区"
    }, {
      "id": 280, "n": "榆社县"
    }, {
      "id": 281, "n": "左权县"
    }, {
      "id": 282, "n": "和顺县"
    }, {
      "id": 283, "n": "昔阳县"
    }, {
      "id": 284, "n": "寿阳县"
    }, {
      "id": 285, "n": "太谷县"
    }, {
      "id": 286, "n": "祁县"
    }, {
      "id": 287, "n": "平遥县"
    }, {
      "id": 288, "n": "灵石县"
    }, {
      "id": 289, "n": "介休市"
    }]
  }, {
    "id": 290, "n": "运城市", "c": [{
      "id": 291, "n": "盐湖区"
    }, {
      "id": 292, "n": "临猗县"
    }, {
      "id": 293, "n": "万荣县"
    }, {
      "id": 294, "n": "闻喜县"
    }, {
      "id": 295, "n": "稷山县"
    }, {
      "id": 296, "n": "新绛县"
    }, {
      "id": 297, "n": "绛县"
    }, {
      "id": 298, "n": "垣曲县"
    }, {
      "id": 299, "n": "夏县"
    }, {
      "id": 300, "n": "平陆县"
    }, {
      "id": 301, "n": "芮城县"
    }, {
      "id": 302, "n": "永济市"
    }, {
      "id": 303, "n": "河津市"
    }]
  }, {
    "id": 304, "n": "忻州市", "c": [{
      "id": 305, "n": "忻府区"
    }, {
      "id": 306, "n": "定襄县"
    }, {
      "id": 307, "n": "五台县"
    }, {
      "id": 308, "n": "代县"
    }, {
      "id": 309, "n": "繁峙县"
    }, {
      "id": 310, "n": "宁武县"
    }, {
      "id": 311, "n": "静乐县"
    }, {
      "id": 312, "n": "神池县"
    }, {
      "id": 313, "n": "五寨县"
    }, {
      "id": 314, "n": "岢岚县"
    }, {
      "id": 315, "n": "河曲县"
    }, {
      "id": 316, "n": "保德县"
    }, {
      "id": 317, "n": "偏关县"
    }, {
      "id": 318, "n": "原平市"
    }]
  }, {
    "id": 319, "n": "临汾市", "c": [{
      "id": 320, "n": "尧都区"
    }, {
      "id": 321, "n": "曲沃县"
    }, {
      "id": 322, "n": "翼城县"
    }, {
      "id": 323, "n": "襄汾县"
    }, {
      "id": 324, "n": "洪洞县"
    }, {
      "id": 325, "n": "古县"
    }, {
      "id": 326, "n": "安泽县"
    }, {
      "id": 327, "n": "浮山县"
    }, {
      "id": 328, "n": "吉县"
    }, {
      "id": 329, "n": "乡宁县"
    }, {
      "id": 330, "n": "大宁县"
    }, {
      "id": 331, "n": "隰县"
    }, {
      "id": 332, "n": "永和县"
    }, {
      "id": 333, "n": "蒲县"
    }, {
      "id": 334, "n": "汾西县"
    }, {
      "id": 335, "n": "侯马市"
    }, {
      "id": 336, "n": "霍州市"
    }]
  }, {
    "id": 337, "n": "吕梁市", "c": [{
      "id": 338, "n": "离石区"
    }, {
      "id": 339, "n": "文水县"
    }, {
      "id": 340, "n": "交城县"
    }, {
      "id": 341, "n": "兴县"
    }, {
      "id": 342, "n": "临县"
    }, {
      "id": 343, "n": "柳林县"
    }, {
      "id": 344, "n": "石楼县"
    }, {
      "id": 345, "n": "岚县"
    }, {
      "id": 346, "n": "方山县"
    }, {
      "id": 347, "n": "中阳县"
    }, {
      "id": 348, "n": "交口县"
    }, {
      "id": 349, "n": "孝义市"
    }, {
      "id": 350, "n": "汾阳市"
    }]
  }]
}, {
  "id": 351, "n": "内蒙古自治区", "c": [{
    "id": 352, "n": "呼和浩特市", "c": [{
      "id": 353, "n": "新城区"
    }, {
      "id": 354, "n": "回民区"
    }, {
      "id": 355, "n": "玉泉区"
    }, {
      "id": 356, "n": "赛罕区"
    }, {
      "id": 357, "n": "土默特左旗"
    }, {
      "id": 358, "n": "托克托县"
    }, {
      "id": 359, "n": "和林格尔县"
    }, {
      "id": 360, "n": "清水河县"
    }, {
      "id": 361, "n": "武川县"
    }]
  }, {
    "id": 362, "n": "包头市", "c": [{
      "id": 363, "n": "东河区"
    }, {
      "id": 364, "n": "昆都仑区"
    }, {
      "id": 365, "n": "青山区"
    }, {
      "id": 366, "n": "石拐区"
    }, {
      "id": 367, "n": "白云鄂博矿区"
    }, {
      "id": 368, "n": "九原区"
    }, {
      "id": 369, "n": "土默特右旗"
    }, {
      "id": 370, "n": "固阳县"
    }, {
      "id": 371, "n": "达尔罕茂明安联合旗"
    }]
  }, {
    "id": 372, "n": "乌海市", "c": [{
      "id": 373, "n": "海勃湾区"
    }, {
      "id": 374, "n": "海南区"
    }, {
      "id": 375, "n": "乌达区"
    }]
  }, {
    "id": 376, "n": "赤峰市", "c": [{
      "id": 377, "n": "红山区"
    }, {
      "id": 378, "n": "元宝山区"
    }, {
      "id": 379, "n": "松山区"
    }, {
      "id": 380, "n": "阿鲁科尔沁旗"
    }, {
      "id": 381, "n": "巴林左旗"
    }, {
      "id": 382, "n": "巴林右旗"
    }, {
      "id": 383, "n": "林西县"
    }, {
      "id": 384, "n": "克什克腾旗"
    }, {
      "id": 385, "n": "翁牛特旗"
    }, {
      "id": 386, "n": "喀喇沁旗"
    }, {
      "id": 387, "n": "宁城县"
    }, {
      "id": 388, "n": "敖汉旗"
    }]
  }, {
    "id": 389, "n": "通辽市", "c": [{
      "id": 390, "n": "科尔沁区"
    }, {
      "id": 391, "n": "科尔沁左翼中旗"
    }, {
      "id": 392, "n": "科尔沁左翼后旗"
    }, {
      "id": 393, "n": "开鲁县"
    }, {
      "id": 394, "n": "库伦旗"
    }, {
      "id": 395, "n": "奈曼旗"
    }, {
      "id": 396, "n": "扎鲁特旗"
    }, {
      "id": 397, "n": "霍林郭勒市"
    }]
  }, {
    "id": 398, "n": "鄂尔多斯市", "c": [{
      "id": 399, "n": "东胜区"
    }, {
      "id": 400, "n": "达拉特旗"
    }, {
      "id": 401, "n": "准格尔旗"
    }, {
      "id": 402, "n": "鄂托克前旗"
    }, {
      "id": 403, "n": "鄂托克旗"
    }, {
      "id": 404, "n": "杭锦旗"
    }, {
      "id": 405, "n": "乌审旗"
    }, {
      "id": 406, "n": "伊金霍洛旗"
    }]
  }, {
    "id": 407, "n": "呼伦贝尔市", "c": [{
      "id": 408, "n": "海拉尔区"
    }, {
      "id": 409, "n": "扎赉诺尔区"
    }, {
      "id": 410, "n": "阿荣旗"
    }, {
      "id": 411, "n": "莫力达瓦达斡尔族自治旗"
    }, {
      "id": 412, "n": "鄂伦春自治旗"
    }, {
      "id": 413, "n": "鄂温克族自治旗"
    }, {
      "id": 414, "n": "陈巴尔虎旗"
    }, {
      "id": 415, "n": "新巴尔虎左旗"
    }, {
      "id": 416, "n": "新巴尔虎右旗"
    }, {
      "id": 417, "n": "满洲里市"
    }, {
      "id": 418, "n": "牙克石市"
    }, {
      "id": 419, "n": "扎兰屯市"
    }, {
      "id": 420, "n": "额尔古纳市"
    }, {
      "id": 421, "n": "根河市"
    }]
  }, {
    "id": 422, "n": "巴彦淖尔市", "c": [{
      "id": 423, "n": "临河区"
    }, {
      "id": 424, "n": "五原县"
    }, {
      "id": 425, "n": "磴口县"
    }, {
      "id": 426, "n": "乌拉特前旗"
    }, {
      "id": 427, "n": "乌拉特中旗"
    }, {
      "id": 428, "n": "乌拉特后旗"
    }, {
      "id": 429, "n": "杭锦后旗"
    }]
  }, {
    "id": 430, "n": "乌兰察布市", "c": [{
      "id": 431, "n": "集宁区"
    }, {
      "id": 432, "n": "卓资县"
    }, {
      "id": 433, "n": "化德县"
    }, {
      "id": 434, "n": "商都县"
    }, {
      "id": 435, "n": "兴和县"
    }, {
      "id": 436, "n": "凉城县"
    }, {
      "id": 437, "n": "察哈尔右翼前旗"
    }, {
      "id": 438, "n": "察哈尔右翼中旗"
    }, {
      "id": 439, "n": "察哈尔右翼后旗"
    }, {
      "id": 440, "n": "四子王旗"
    }, {
      "id": 441, "n": "丰镇市"
    }]
  }, {
    "id": 442, "n": "兴安盟", "c": [{
      "id": 443, "n": "乌兰浩特市"
    }, {
      "id": 444, "n": "阿尔山市"
    }, {
      "id": 445, "n": "科尔沁右翼前旗"
    }, {
      "id": 446, "n": "科尔沁右翼中旗"
    }, {
      "id": 447, "n": "扎赉特旗"
    }, {
      "id": 448, "n": "突泉县"
    }]
  }, {
    "id": 449, "n": "锡林郭勒盟", "c": [{
      "id": 450, "n": "二连浩特市"
    }, {
      "id": 451, "n": "锡林浩特市"
    }, {
      "id": 452, "n": "阿巴嘎旗"
    }, {
      "id": 453, "n": "苏尼特左旗"
    }, {
      "id": 454, "n": "苏尼特右旗"
    }, {
      "id": 455, "n": "东乌珠穆沁旗"
    }, {
      "id": 456, "n": "西乌珠穆沁旗"
    }, {
      "id": 457, "n": "太仆寺旗"
    }, {
      "id": 458, "n": "镶黄旗"
    }, {
      "id": 459, "n": "正镶白旗"
    }, {
      "id": 460, "n": "正蓝旗"
    }, {
      "id": 461, "n": "多伦县"
    }]
  }, {
    "id": 462, "n": "阿拉善盟", "c": [{
      "id": 463, "n": "阿拉善左旗"
    }, {
      "id": 464, "n": "阿拉善右旗"
    }, {
      "id": 465, "n": "额济纳旗"
    }]
  }]
}, {
  "id": 466, "n": "辽宁省", "c": [{
    "id": 467, "n": "沈阳市", "c": [{
      "id": 468, "n": "和平区"
    }, {
      "id": 469, "n": "沈河区"
    }, {
      "id": 470, "n": "大东区"
    }, {
      "id": 471, "n": "皇姑区"
    }, {
      "id": 472, "n": "铁西区"
    }, {
      "id": 473, "n": "苏家屯区"
    }, {
      "id": 474, "n": "浑南区"
    }, {
      "id": 475, "n": "沈北新区"
    }, {
      "id": 476, "n": "于洪区"
    }, {
      "id": 477, "n": "辽中县"
    }, {
      "id": 478, "n": "康平县"
    }, {
      "id": 479, "n": "法库县"
    }, {
      "id": 480, "n": "新民市"
    }]
  }, {
    "id": 481, "n": "大连市", "c": [{
      "id": 482, "n": "中山区"
    }, {
      "id": 483, "n": "西岗区"
    }, {
      "id": 484, "n": "沙河口区"
    }, {
      "id": 485, "n": "甘井子区"
    }, {
      "id": 486, "n": "旅顺口区"
    }, {
      "id": 487, "n": "金州区"
    }, {
      "id": 488, "n": "长海县"
    }, {
      "id": 489, "n": "瓦房店市"
    }, {
      "id": 490, "n": "普兰店市"
    }, {
      "id": 491, "n": "庄河市"
    }]
  }, {
    "id": 492, "n": "鞍山市", "c": [{
      "id": 493, "n": "铁东区"
    }, {
      "id": 494, "n": "铁西区"
    }, {
      "id": 495, "n": "立山区"
    }, {
      "id": 496, "n": "千山区"
    }, {
      "id": 497, "n": "台安县"
    }, {
      "id": 498, "n": "岫岩满族自治县"
    }, {
      "id": 499, "n": "海城市"
    }]
  }, {
    "id": 500, "n": "抚顺市", "c": [{
      "id": 501, "n": "新抚区"
    }, {
      "id": 502, "n": "东洲区"
    }, {
      "id": 503, "n": "望花区"
    }, {
      "id": 504, "n": "顺城区"
    }, {
      "id": 505, "n": "抚顺县"
    }, {
      "id": 506, "n": "新宾满族自治县"
    }, {
      "id": 507, "n": "清原满族自治县"
    }]
  }, {
    "id": 508, "n": "本溪市", "c": [{
      "id": 509, "n": "平山区"
    }, {
      "id": 510, "n": "溪湖区"
    }, {
      "id": 511, "n": "明山区"
    }, {
      "id": 512, "n": "南芬区"
    }, {
      "id": 513, "n": "本溪满族自治县"
    }, {
      "id": 514, "n": "桓仁满族自治县"
    }]
  }, {
    "id": 515, "n": "丹东市", "c": [{
      "id": 516, "n": "元宝区"
    }, {
      "id": 517, "n": "振兴区"
    }, {
      "id": 518, "n": "振安区"
    }, {
      "id": 519, "n": "宽甸满族自治县"
    }, {
      "id": 520, "n": "东港市"
    }, {
      "id": 521, "n": "凤城市"
    }]
  }, {
    "id": 522, "n": "锦州市", "c": [{
      "id": 523, "n": "古塔区"
    }, {
      "id": 524, "n": "凌河区"
    }, {
      "id": 525, "n": "太和区"
    }, {
      "id": 526, "n": "黑山县"
    }, {
      "id": 527, "n": "义县"
    }, {
      "id": 528, "n": "凌海市"
    }, {
      "id": 529, "n": "北镇市"
    }]
  }, {
    "id": 530, "n": "营口市", "c": [{
      "id": 531, "n": "站前区"
    }, {
      "id": 532, "n": "西市区"
    }, {
      "id": 533, "n": "鲅鱼圈区"
    }, {
      "id": 534, "n": "老边区"
    }, {
      "id": 535, "n": "盖州市"
    }, {
      "id": 536, "n": "大石桥市"
    }]
  }, {
    "id": 537, "n": "阜新市", "c": [{
      "id": 538, "n": "海州区"
    }, {
      "id": 539, "n": "新邱区"
    }, {
      "id": 540, "n": "太平区"
    }, {
      "id": 541, "n": "清河门区"
    }, {
      "id": 542, "n": "细河区"
    }, {
      "id": 543, "n": "阜新蒙古族自治县"
    }, {
      "id": 544, "n": "彰武县"
    }]
  }, {
    "id": 545, "n": "辽阳市", "c": [{
      "id": 546, "n": "白塔区"
    }, {
      "id": 547, "n": "文圣区"
    }, {
      "id": 548, "n": "宏伟区"
    }, {
      "id": 549, "n": "弓长岭区"
    }, {
      "id": 550, "n": "太子河区"
    }, {
      "id": 551, "n": "辽阳县"
    }, {
      "id": 552, "n": "灯塔市"
    }]
  }, {
    "id": 553, "n": "盘锦市", "c": [{
      "id": 554, "n": "双台子区"
    }, {
      "id": 555, "n": "兴隆台区"
    }, {
      "id": 556, "n": "大洼县"
    }, {
      "id": 557, "n": "盘山县"
    }]
  }, {
    "id": 558, "n": "铁岭市", "c": [{
      "id": 559, "n": "银州区"
    }, {
      "id": 560, "n": "清河区"
    }, {
      "id": 561, "n": "铁岭县"
    }, {
      "id": 562, "n": "西丰县"
    }, {
      "id": 563, "n": "昌图县"
    }, {
      "id": 564, "n": "调兵山市"
    }, {
      "id": 565, "n": "开原市"
    }]
  }, {
    "id": 566, "n": "朝阳市", "c": [{
      "id": 567, "n": "双塔区"
    }, {
      "id": 568, "n": "龙城区"
    }, {
      "id": 569, "n": "朝阳县"
    }, {
      "id": 570, "n": "建平县"
    }, {
      "id": 571, "n": "喀喇沁左翼蒙古族自治县"
    }, {
      "id": 572, "n": "北票市"
    }, {
      "id": 573, "n": "凌源市"
    }]
  }, {
    "id": 574, "n": "葫芦岛市", "c": [{
      "id": 575, "n": "连山区"
    }, {
      "id": 576, "n": "龙港区"
    }, {
      "id": 577, "n": "南票区"
    }, {
      "id": 578, "n": "绥中县"
    }, {
      "id": 579, "n": "建昌县"
    }, {
      "id": 580, "n": "兴城市"
    }]
  }, {
    "id": 581, "n": "金普新区", "c": [{
      "id": 582, "n": "金州新区"
    }, {
      "id": 583, "n": "普湾新区"
    }, {
      "id": 584, "n": "保税区"
    }]
  }]
}, {
  "id": 585, "n": "吉林省", "c": [{
    "id": 586, "n": "长春市", "c": [{
      "id": 587, "n": "南关区"
    }, {
      "id": 588, "n": "宽城区"
    }, {
      "id": 589, "n": "朝阳区"
    }, {
      "id": 590, "n": "二道区"
    }, {
      "id": 591, "n": "绿园区"
    }, {
      "id": 592, "n": "双阳区"
    }, {
      "id": 593, "n": "九台区"
    }, {
      "id": 594, "n": "农安县"
    }, {
      "id": 595, "n": "榆树市"
    }, {
      "id": 596, "n": "德惠市"
    }]
  }, {
    "id": 597, "n": "吉林市", "c": [{
      "id": 598, "n": "昌邑区"
    }, {
      "id": 599, "n": "龙潭区"
    }, {
      "id": 600, "n": "船营区"
    }, {
      "id": 601, "n": "丰满区"
    }, {
      "id": 602, "n": "永吉县"
    }, {
      "id": 603, "n": "蛟河市"
    }, {
      "id": 604, "n": "桦甸市"
    }, {
      "id": 605, "n": "舒兰市"
    }, {
      "id": 606, "n": "磐石市"
    }]
  }, {
    "id": 607, "n": "四平市", "c": [{
      "id": 608, "n": "铁西区"
    }, {
      "id": 609, "n": "铁东区"
    }, {
      "id": 610, "n": "梨树县"
    }, {
      "id": 611, "n": "伊通满族自治县"
    }, {
      "id": 612, "n": "公主岭市"
    }, {
      "id": 613, "n": "双辽市"
    }]
  }, {
    "id": 614, "n": "辽源市", "c": [{
      "id": 615, "n": "龙山区"
    }, {
      "id": 616, "n": "西安区"
    }, {
      "id": 617, "n": "东丰县"
    }, {
      "id": 618, "n": "东辽县"
    }]
  }, {
    "id": 619, "n": "通化市", "c": [{
      "id": 620, "n": "东昌区"
    }, {
      "id": 621, "n": "二道江区"
    }, {
      "id": 622, "n": "通化县"
    }, {
      "id": 623, "n": "辉南县"
    }, {
      "id": 624, "n": "柳河县"
    }, {
      "id": 625, "n": "梅河口市"
    }, {
      "id": 626, "n": "集安市"
    }]
  }, {
    "id": 627, "n": "白山市", "c": [{
      "id": 628, "n": "浑江区"
    }, {
      "id": 629, "n": "江源区"
    }, {
      "id": 630, "n": "抚松县"
    }, {
      "id": 631, "n": "靖宇县"
    }, {
      "id": 632, "n": "长白朝鲜族自治县"
    }, {
      "id": 633, "n": "临江市"
    }]
  }, {
    "id": 634, "n": "松原市", "c": [{
      "id": 635, "n": "宁江区"
    }, {
      "id": 636, "n": "前郭尔罗斯蒙古族自治县"
    }, {
      "id": 637, "n": "长岭县"
    }, {
      "id": 638, "n": "乾安县"
    }, {
      "id": 639, "n": "扶余市"
    }]
  }, {
    "id": 640, "n": "白城市", "c": [{
      "id": 641, "n": "洮北区"
    }, {
      "id": 642, "n": "镇赉县"
    }, {
      "id": 643, "n": "通榆县"
    }, {
      "id": 644, "n": "洮南市"
    }, {
      "id": 645, "n": "大安市"
    }]
  }, {
    "id": 646, "n": "延边朝鲜族自治州", "c": [{
      "id": 647, "n": "延吉市"
    }, {
      "id": 648, "n": "图们市"
    }, {
      "id": 649, "n": "敦化市"
    }, {
      "id": 650, "n": "珲春市"
    }, {
      "id": 651, "n": "龙井市"
    }, {
      "id": 652, "n": "和龙市"
    }, {
      "id": 653, "n": "汪清县"
    }, {
      "id": 654, "n": "安图县"
    }]
  }]
}, {
  "id": 655, "n": "黑龙江省", "c": [{
    "id": 656, "n": "哈尔滨市", "c": [{
      "id": 657, "n": "道里区"
    }, {
      "id": 658, "n": "南岗区"
    }, {
      "id": 659, "n": "道外区"
    }, {
      "id": 660, "n": "平房区"
    }, {
      "id": 661, "n": "松北区"
    }, {
      "id": 662, "n": "香坊区"
    }, {
      "id": 663, "n": "呼兰区"
    }, {
      "id": 664, "n": "阿城区"
    }, {
      "id": 665, "n": "双城区"
    }, {
      "id": 666, "n": "依兰县"
    }, {
      "id": 667, "n": "方正县"
    }, {
      "id": 668, "n": "宾县"
    }, {
      "id": 669, "n": "巴彦县"
    }, {
      "id": 670, "n": "木兰县"
    }, {
      "id": 671, "n": "通河县"
    }, {
      "id": 672, "n": "延寿县"
    }, {
      "id": 673, "n": "尚志市"
    }, {
      "id": 674, "n": "五常市"
    }]
  }, {
    "id": 675, "n": "齐齐哈尔市", "c": [{
      "id": 676, "n": "龙沙区"
    }, {
      "id": 677, "n": "建华区"
    }, {
      "id": 678, "n": "铁锋区"
    }, {
      "id": 679, "n": "昂昂溪区"
    }, {
      "id": 680, "n": "富拉尔基区"
    }, {
      "id": 681, "n": "碾子山区"
    }, {
      "id": 682, "n": "梅里斯达斡尔族区"
    }, {
      "id": 683, "n": "龙江县"
    }, {
      "id": 684, "n": "依安县"
    }, {
      "id": 685, "n": "泰来县"
    }, {
      "id": 686, "n": "甘南县"
    }, {
      "id": 687, "n": "富裕县"
    }, {
      "id": 688, "n": "克山县"
    }, {
      "id": 689, "n": "克东县"
    }, {
      "id": 690, "n": "拜泉县"
    }, {
      "id": 691, "n": "讷河市"
    }]
  }, {
    "id": 692, "n": "鸡西市", "c": [{
      "id": 693, "n": "鸡冠区"
    }, {
      "id": 694, "n": "恒山区"
    }, {
      "id": 695, "n": "滴道区"
    }, {
      "id": 696, "n": "梨树区"
    }, {
      "id": 697, "n": "城子河区"
    }, {
      "id": 698, "n": "麻山区"
    }, {
      "id": 699, "n": "鸡东县"
    }, {
      "id": 700, "n": "虎林市"
    }, {
      "id": 701, "n": "密山市"
    }]
  }, {
    "id": 702, "n": "鹤岗市", "c": [{
      "id": 703, "n": "向阳区"
    }, {
      "id": 704, "n": "工农区"
    }, {
      "id": 705, "n": "南山区"
    }, {
      "id": 706, "n": "兴安区"
    }, {
      "id": 707, "n": "东山区"
    }, {
      "id": 708, "n": "兴山区"
    }, {
      "id": 709, "n": "萝北县"
    }, {
      "id": 710, "n": "绥滨县"
    }]
  }, {
    "id": 711, "n": "双鸭山市", "c": [{
      "id": 712, "n": "尖山区"
    }, {
      "id": 713, "n": "岭东区"
    }, {
      "id": 714, "n": "四方台区"
    }, {
      "id": 715, "n": "宝山区"
    }, {
      "id": 716, "n": "集贤县"
    }, {
      "id": 717, "n": "友谊县"
    }, {
      "id": 718, "n": "宝清县"
    }, {
      "id": 719, "n": "饶河县"
    }]
  }, {
    "id": 720, "n": "大庆市", "c": [{
      "id": 721, "n": "萨尔图区"
    }, {
      "id": 722, "n": "龙凤区"
    }, {
      "id": 723, "n": "让胡路区"
    }, {
      "id": 724, "n": "红岗区"
    }, {
      "id": 725, "n": "大同区"
    }, {
      "id": 726, "n": "肇州县"
    }, {
      "id": 727, "n": "肇源县"
    }, {
      "id": 728, "n": "林甸县"
    }, {
      "id": 729, "n": "杜尔伯特蒙古族自治县"
    }]
  }, {
    "id": 730, "n": "伊春市", "c": [{
      "id": 731, "n": "伊春区"
    }, {
      "id": 732, "n": "南岔区"
    }, {
      "id": 733, "n": "友好区"
    }, {
      "id": 734, "n": "西林区"
    }, {
      "id": 735, "n": "翠峦区"
    }, {
      "id": 736, "n": "新青区"
    }, {
      "id": 737, "n": "美溪区"
    }, {
      "id": 738, "n": "金山屯区"
    }, {
      "id": 739, "n": "五营区"
    }, {
      "id": 740, "n": "乌马河区"
    }, {
      "id": 741, "n": "汤旺河区"
    }, {
      "id": 742, "n": "带岭区"
    }, {
      "id": 743, "n": "乌伊岭区"
    }, {
      "id": 744, "n": "红星区"
    }, {
      "id": 745, "n": "上甘岭区"
    }, {
      "id": 746, "n": "嘉荫县"
    }, {
      "id": 747, "n": "铁力市"
    }]
  }, {
    "id": 748, "n": "佳木斯市", "c": [{
      "id": 749, "n": "向阳区"
    }, {
      "id": 750, "n": "前进区"
    }, {
      "id": 751, "n": "东风区"
    }, {
      "id": 752, "n": "郊区"
    }, {
      "id": 753, "n": "桦南县"
    }, {
      "id": 754, "n": "桦川县"
    }, {
      "id": 755, "n": "汤原县"
    }, {
      "id": 756, "n": "抚远县"
    }, {
      "id": 757, "n": "同江市"
    }, {
      "id": 758, "n": "富锦市"
    }]
  }, {
    "id": 759, "n": "七台河市", "c": [{
      "id": 760, "n": "新兴区"
    }, {
      "id": 761, "n": "桃山区"
    }, {
      "id": 762, "n": "茄子河区"
    }, {
      "id": 763, "n": "勃利县"
    }]
  }, {
    "id": 764, "n": "牡丹江市", "c": [{
      "id": 765, "n": "东安区"
    }, {
      "id": 766, "n": "阳明区"
    }, {
      "id": 767, "n": "爱民区"
    }, {
      "id": 768, "n": "西安区"
    }, {
      "id": 769, "n": "东宁县"
    }, {
      "id": 770, "n": "林口县"
    }, {
      "id": 771, "n": "绥芬河市"
    }, {
      "id": 772, "n": "海林市"
    }, {
      "id": 773, "n": "宁安市"
    }, {
      "id": 774, "n": "穆棱市"
    }]
  }, {
    "id": 775, "n": "黑河市", "c": [{
      "id": 776, "n": "爱辉区"
    }, {
      "id": 777, "n": "嫩江县"
    }, {
      "id": 778, "n": "逊克县"
    }, {
      "id": 779, "n": "孙吴县"
    }, {
      "id": 780, "n": "北安市"
    }, {
      "id": 781, "n": "五大连池市"
    }]
  }, {
    "id": 782, "n": "绥化市", "c": [{
      "id": 783, "n": "北林区"
    }, {
      "id": 784, "n": "望奎县"
    }, {
      "id": 785, "n": "兰西县"
    }, {
      "id": 786, "n": "青冈县"
    }, {
      "id": 787, "n": "庆安县"
    }, {
      "id": 788, "n": "明水县"
    }, {
      "id": 789, "n": "绥棱县"
    }, {
      "id": 790, "n": "安达市"
    }, {
      "id": 791, "n": "肇东市"
    }, {
      "id": 792, "n": "海伦市"
    }]
  }, {
    "id": 793, "n": "大兴安岭地区", "c": [{
      "id": 794, "n": "加格达奇区"
    }, {
      "id": 795, "n": "新林区"
    }, {
      "id": 796, "n": "松岭区"
    }, {
      "id": 797, "n": "呼中区"
    }, {
      "id": 798, "n": "呼玛县"
    }, {
      "id": 799, "n": "塔河县"
    }, {
      "id": 800, "n": "漠河县"
    }]
  }]
}, {
  "id": 801, "n": "上海", "c": [{
    "id": 802, "n": "上海市", "c": [{
      "id": 803, "n": "黄浦区"
    }, {
      "id": 804, "n": "徐汇区"
    }, {
      "id": 805, "n": "长宁区"
    }, {
      "id": 806, "n": "静安区"
    }, {
      "id": 807, "n": "普陀区"
    }, {
      "id": 808, "n": "闸北区"
    }, {
      "id": 809, "n": "虹口区"
    }, {
      "id": 810, "n": "杨浦区"
    }, {
      "id": 811, "n": "闵行区"
    }, {
      "id": 812, "n": "宝山区"
    }, {
      "id": 813, "n": "嘉定区"
    }, {
      "id": 814, "n": "浦东新区"
    }, {
      "id": 815, "n": "金山区"
    }, {
      "id": 816, "n": "松江区"
    }, {
      "id": 817, "n": "青浦区"
    }, {
      "id": 818, "n": "奉贤区"
    }, {
      "id": 819, "n": "崇明县"
    }]
  }]
}, {
  "id": 820, "n": "江苏省", "c": [{
    "id": 821, "n": "南京市", "c": [{
      "id": 822, "n": "玄武区"
    }, {
      "id": 823, "n": "秦淮区"
    }, {
      "id": 824, "n": "建邺区"
    }, {
      "id": 825, "n": "鼓楼区"
    }, {
      "id": 826, "n": "浦口区"
    }, {
      "id": 827, "n": "栖霞区"
    }, {
      "id": 828, "n": "雨花台区"
    }, {
      "id": 829, "n": "江宁区"
    }, {
      "id": 830, "n": "六合区"
    }, {
      "id": 831, "n": "溧水区"
    }, {
      "id": 832, "n": "高淳区"
    }, {
      "id": 83201, "n": "江北新区"
    }]
  }, {
    "id": 833, "n": "无锡市", "c": [{
      "id": 834, "n": "崇安区"
    }, {
      "id": 835, "n": "南长区"
    }, {
      "id": 836, "n": "北塘区"
    }, {
      "id": 837, "n": "锡山区"
    }, {
      "id": 838, "n": "惠山区"
    }, {
      "id": 839, "n": "滨湖区"
    }, {
      "id": 840, "n": "江阴市"
    }, {
      "id": 841, "n": "宜兴市"
    }, {
      "id": 84101, "n": "梁溪区"
    }]
  }, {
    "id": 842, "n": "徐州市", "c": [{
      "id": 843, "n": "鼓楼区"
    }, {
      "id": 844, "n": "云龙区"
    }, {
      "id": 845, "n": "贾汪区"
    }, {
      "id": 846, "n": "泉山区"
    }, {
      "id": 847, "n": "铜山区"
    }, {
      "id": 848, "n": "丰县"
    }, {
      "id": 849, "n": "沛县"
    }, {
      "id": 850, "n": "睢宁县"
    }, {
      "id": 851, "n": "新沂市"
    }, {
      "id": 852, "n": "邳州市"
    }]
  }, {
    "id": 853, "n": "常州市", "c": [{
      "id": 854, "n": "天宁区"
    }, {
      "id": 855, "n": "钟楼区"
    }, {
      "id": 856, "n": "戚墅堰区"
    }, {
      "id": 857, "n": "新北区"
    }, {
      "id": 858, "n": "武进区"
    }, {
      "id": 859, "n": "溧阳市"
    }, {
      "id": 860, "n": "金坛市"
    }]
  }, {
    "id": 861, "n": "苏州市", "c": [{
      "id": 862, "n": "虎丘区"
    }, {
      "id": 863, "n": "吴中区"
    }, {
      "id": 864, "n": "相城区"
    }, {
      "id": 865, "n": "姑苏区"
    }, {
      "id": 866, "n": "吴江区"
    }, {
      "id": 867, "n": "常熟市"
    }, {
      "id": 868, "n": "张家港市"
    }, {
      "id": 869, "n": "昆山市"
    }, {
      "id": 870, "n": "太仓市"
    }, {
      "id": 87001, "n": "高新区"
    }]
  }, {
    "id": 871, "n": "南通市", "c": [{
      "id": 872, "n": "崇川区"
    }, {
      "id": 873, "n": "港闸区"
    }, {
      "id": 874, "n": "通州区"
    }, {
      "id": 875, "n": "海安县"
    }, {
      "id": 876, "n": "如东县"
    }, {
      "id": 877, "n": "启东市"
    }, {
      "id": 878, "n": "如皋市"
    }, {
      "id": 879, "n": "海门市"
    }]
  }, {
    "id": 880, "n": "连云港市", "c": [{
      "id": 881, "n": "连云区"
    }, {
      "id": 882, "n": "海州区"
    }, {
      "id": 883, "n": "赣榆区"
    }, {
      "id": 884, "n": "东海县"
    }, {
      "id": 885, "n": "灌云县"
    }, {
      "id": 886, "n": "灌南县"
    }, {
      "id": 887, "n": "徐圩新区"
    }]
  }, {
    "id": 887, "n": "淮安市", "c": [{
      "id": 888, "n": "清河区"
    }, {
      "id": 889, "n": "淮安区"
    }, {
      "id": 890, "n": "淮阴区"
    }, {
      "id": 891, "n": "清浦区"
    }, {
      "id": 892, "n": "涟水县"
    }, {
      "id": 893, "n": "洪泽县"
    }, {
      "id": 894, "n": "盱眙县"
    }, {
      "id": 895, "n": "金湖县"
    }]
  }, {
    "id": 896, "n": "盐城市", "c": [{
      "id": 897, "n": "亭湖区"
    }, {
      "id": 898, "n": "盐都区"
    }, {
      "id": 899, "n": "响水县"
    }, {
      "id": 900, "n": "滨海县"
    }, {
      "id": 901, "n": "阜宁县"
    }, {
      "id": 902, "n": "射阳县"
    }, {
      "id": 903, "n": "建湖县"
    }, {
      "id": 904, "n": "东台市"
    }, {
      "id": 905, "n": "大丰市"
    }, {
      "id": 90501, "n": "盐南新区"
    }]
  }, {
    "id": 906, "n": "扬州市", "c": [{
      "id": 907, "n": "广陵区"
    }, {
      "id": 908, "n": "邗江区"
    }, {
      "id": 909, "n": "江都区"
    }, {
      "id": 910, "n": "宝应县"
    }, {
      "id": 911, "n": "仪征市"
    }, {
      "id": 912, "n": "高邮市"
    }]
  }, {
    "id": 913, "n": "镇江市", "c": [{
      "id": 914, "n": "京口区"
    }, {
      "id": 915, "n": "润州区"
    }, {
      "id": 916, "n": "丹徒区"
    }, {
      "id": 917, "n": "丹阳市"
    }, {
      "id": 918, "n": "扬中市"
    }, {
      "id": 919, "n": "句容市"
    }]
  }, {
    "id": 920, "n": "泰州市", "c": [{
      "id": 921, "n": "海陵区"
    }, {
      "id": 922, "n": "高港区"
    }, {
      "id": 923, "n": "姜堰区"
    }, {
      "id": 924, "n": "兴化市"
    }, {
      "id": 925, "n": "靖江市"
    }, {
      "id": 926, "n": "泰兴市"
    }]
  }, {
    "id": 927, "n": "宿迁市", "c": [{
      "id": 928, "n": "宿城区"
    }, {
      "id": 929, "n": "宿豫区"
    }, {
      "id": 930, "n": "沭阳县"
    }, {
      "id": 931, "n": "泗阳县"
    }, {
      "id": 932, "n": "泗洪县"
    }]
  }]
}, {
  "id": 933, "n": "浙江省", "c": [{
    "id": 934, "n": "杭州市", "c": [{
      "id": 935, "n": "上城区"
    }, {
      "id": 936, "n": "下城区"
    }, {
      "id": 937, "n": "江干区"
    }, {
      "id": 938, "n": "拱墅区"
    }, {
      "id": 939, "n": "西湖区"
    }, {
      "id": 940, "n": "滨江区"
    }, {
      "id": 941, "n": "萧山区"
    }, {
      "id": 942, "n": "余杭区"
    }, {
      "id": 943, "n": "桐庐县"
    }, {
      "id": 944, "n": "淳安县"
    }, {
      "id": 945, "n": "建德市"
    }, {
      "id": 946, "n": "富阳区"
    }, {
      "id": 947, "n": "临安市"
    }]
  }, {
    "id": 948, "n": "宁波市", "c": [{
      "id": 949, "n": "海曙区"
    }, {
      "id": 950, "n": "江东区"
    }, {
      "id": 951, "n": "江北区"
    }, {
      "id": 952, "n": "北仑区"
    }, {
      "id": 953, "n": "镇海区"
    }, {
      "id": 954, "n": "鄞州区"
    }, {
      "id": 955, "n": "象山县"
    }, {
      "id": 956, "n": "宁海县"
    }, {
      "id": 957, "n": "余姚市"
    }, {
      "id": 958, "n": "慈溪市"
    }, {
      "id": 959, "n": "奉化市"
    }]
  }, {
    "id": 960, "n": "温州市", "c": [{
      "id": 961, "n": "鹿城区"
    }, {
      "id": 962, "n": "龙湾区"
    }, {
      "id": 963, "n": "瓯海区"
    }, {
      "id": 964, "n": "洞头县"
    }, {
      "id": 965, "n": "永嘉县"
    }, {
      "id": 966, "n": "平阳县"
    }, {
      "id": 967, "n": "苍南县"
    }, {
      "id": 968, "n": "文成县"
    }, {
      "id": 969, "n": "泰顺县"
    }, {
      "id": 970, "n": "瑞安市"
    }, {
      "id": 971, "n": "乐清市"
    }]
  }, {
    "id": 972, "n": "嘉兴市", "c": [{
      "id": 973, "n": "南湖区"
    }, {
      "id": 974, "n": "秀洲区"
    }, {
      "id": 975, "n": "嘉善县"
    }, {
      "id": 976, "n": "海盐县"
    }, {
      "id": 977, "n": "海宁市"
    }, {
      "id": 978, "n": "平湖市"
    }, {
      "id": 979, "n": "桐乡市"
    }]
  }, {
    "id": 980, "n": "湖州市", "c": [{
      "id": 981, "n": "吴兴区"
    }, {
      "id": 982, "n": "南浔区"
    }, {
      "id": 983, "n": "德清县"
    }, {
      "id": 984, "n": "长兴县"
    }, {
      "id": 985, "n": "安吉县"
    }]
  }, {
    "id": 986, "n": "绍兴市", "c": [{
      "id": 987, "n": "越城区"
    }, {
      "id": 988, "n": "柯桥区"
    }, {
      "id": 989, "n": "上虞区"
    }, {
      "id": 990, "n": "新昌县"
    }, {
      "id": 991, "n": "诸暨市"
    }, {
      "id": 992, "n": "嵊州市"
    }]
  }, {
    "id": 993, "n": "金华市", "c": [{
      "id": 994, "n": "婺城区"
    }, {
      "id": 995, "n": "金东区"
    }, {
      "id": 996, "n": "武义县"
    }, {
      "id": 997, "n": "浦江县"
    }, {
      "id": 998, "n": "磐安县"
    }, {
      "id": 999, "n": "兰溪市"
    }, {
      "id": 1000, "n": "义乌市"
    }, {
      "id": 1001, "n": "东阳市"
    }, {
      "id": 1002, "n": "永康市"
    }]
  }, {
    "id": 1003, "n": "衢州市", "c": [{
      "id": 1004, "n": "柯城区"
    }, {
      "id": 1005, "n": "衢江区"
    }, {
      "id": 1006, "n": "常山县"
    }, {
      "id": 1007, "n": "开化县"
    }, {
      "id": 1008, "n": "龙游县"
    }, {
      "id": 1009, "n": "江山市"
    }]
  }, {
    "id": 1010, "n": "舟山市", "c": [{
      "id": 1011, "n": "定海区"
    }, {
      "id": 1012, "n": "普陀区"
    }, {
      "id": 1013, "n": "岱山县"
    }, {
      "id": 1014, "n": "嵊泗县"
    }]
  }, {
    "id": 1015, "n": "台州市", "c": [{
      "id": 1016, "n": "椒江区"
    }, {
      "id": 1017, "n": "黄岩区"
    }, {
      "id": 1018, "n": "路桥区"
    }, {
      "id": 1019, "n": "玉环县"
    }, {
      "id": 1020, "n": "三门县"
    }, {
      "id": 1021, "n": "天台县"
    }, {
      "id": 1022, "n": "仙居县"
    }, {
      "id": 1023, "n": "温岭市"
    }, {
      "id": 1024, "n": "临海市"
    }]
  }, {
    "id": 1025, "n": "丽水市", "c": [{
      "id": 1026, "n": "莲都区"
    }, {
      "id": 1027, "n": "青田县"
    }, {
      "id": 1028, "n": "缙云县"
    }, {
      "id": 1029, "n": "遂昌县"
    }, {
      "id": 1030, "n": "松阳县"
    }, {
      "id": 1031, "n": "云和县"
    }, {
      "id": 1032, "n": "庆元县"
    }, {
      "id": 1033, "n": "景宁畲族自治县"
    }, {
      "id": 1034, "n": "龙泉市"
    }]
  }, {
    "id": 1035, "n": "舟山群岛新区", "c": [{
      "id": 1036, "n": "金塘岛"
    }, {
      "id": 1037, "n": "六横岛"
    }, {
      "id": 1038, "n": "衢山岛"
    }, {
      "id": 1039, "n": "舟山本岛西北部"
    }, {
      "id": 1040, "n": "岱山岛西南部"
    }, {
      "id": 1041, "n": "泗礁岛"
    }, {
      "id": 1042, "n": "朱家尖岛"
    }, {
      "id": 1043, "n": "洋山岛"
    }, {
      "id": 1044, "n": "长涂岛"
    }, {
      "id": 1045, "n": "虾峙岛"
    }]
  }]
}, {
  "id": 1046, "n": "安徽省", "c": [{
    "id": 1047, "n": "合肥市", "c": [{
      "id": 1048, "n": "瑶海区"
    }, {
      "id": 1049, "n": "庐阳区"
    }, {
      "id": 1050, "n": "蜀山区"
    }, {
      "id": 1051, "n": "包河区"
    }, {
      "id": 1052, "n": "长丰县"
    }, {
      "id": 1053, "n": "肥东县"
    }, {
      "id": 1054, "n": "肥西县"
    }, {
      "id": 1055, "n": "庐江县"
    }, {
      "id": 1056, "n": "巢湖市"
    }]
  }, {
    "id": 1057, "n": "芜湖市", "c": [{
      "id": 1058, "n": "镜湖区"
    }, {
      "id": 1059, "n": "弋江区"
    }, {
      "id": 1060, "n": "鸠江区"
    }, {
      "id": 1061, "n": "三山区"
    }, {
      "id": 1062, "n": "芜湖县"
    }, {
      "id": 1063, "n": "繁昌县"
    }, {
      "id": 1064, "n": "南陵县"
    }, {
      "id": 1065, "n": "无为县"
    }]
  }, {
    "id": 1066, "n": "蚌埠市", "c": [{
      "id": 1067, "n": "龙子湖区"
    }, {
      "id": 1068, "n": "蚌山区"
    }, {
      "id": 1069, "n": "禹会区"
    }, {
      "id": 1070, "n": "淮上区"
    }, {
      "id": 1071, "n": "怀远县"
    }, {
      "id": 1072, "n": "五河县"
    }, {
      "id": 1073, "n": "固镇县"
    }]
  }, {
    "id": 1074, "n": "淮南市", "c": [{
      "id": 1075, "n": "大通区"
    }, {
      "id": 1076, "n": "田家庵区"
    }, {
      "id": 1077, "n": "谢家集区"
    }, {
      "id": 1078, "n": "八公山区"
    }, {
      "id": 1079, "n": "潘集区"
    }, {
      "id": 1080, "n": "凤台县"
    }]
  }, {
    "id": 1081, "n": "马鞍山市", "c": [{
      "id": 1082, "n": "花山区"
    }, {
      "id": 1083, "n": "雨山区"
    }, {
      "id": 1084, "n": "博望区"
    }, {
      "id": 1085, "n": "当涂县"
    }, {
      "id": 1086, "n": "含山县"
    }, {
      "id": 1087, "n": "和县"
    }]
  }, {
    "id": 1088, "n": "淮北市", "c": [{
      "id": 1089, "n": "杜集区"
    }, {
      "id": 1090, "n": "相山区"
    }, {
      "id": 1091, "n": "烈山区"
    }, {
      "id": 1092, "n": "濉溪县"
    }]
  }, {
    "id": 1093, "n": "铜陵市", "c": [{
      "id": 1094, "n": "铜官山区"
    }, {
      "id": 1095, "n": "狮子山区"
    }, {
      "id": 1096, "n": "郊区"
    }, {
      "id": 1097, "n": "铜陵县"
    }]
  }, {
    "id": 1098, "n": "安庆市", "c": [{
      "id": 1099, "n": "迎江区"
    }, {
      "id": 1100, "n": "大观区"
    }, {
      "id": 1101, "n": "宜秀区"
    }, {
      "id": 1102, "n": "怀宁县"
    }, {
      "id": 1103, "n": "枞阳县"
    }, {
      "id": 1104, "n": "潜山县"
    }, {
      "id": 1105, "n": "太湖县"
    }, {
      "id": 1106, "n": "宿松县"
    }, {
      "id": 1107, "n": "望江县"
    }, {
      "id": 1108, "n": "岳西县"
    }, {
      "id": 1109, "n": "桐城市"
    }]
  }, {
    "id": 1110, "n": "黄山市", "c": [{
      "id": 1111, "n": "屯溪区"
    }, {
      "id": 1112, "n": "黄山区"
    }, {
      "id": 1113, "n": "徽州区"
    }, {
      "id": 1114, "n": "歙县"
    }, {
      "id": 1115, "n": "休宁县"
    }, {
      "id": 1116, "n": "黟县"
    }, {
      "id": 1117, "n": "祁门县"
    }]
  }, {
    "id": 1118, "n": "滁州市", "c": [{
      "id": 1119, "n": "琅琊区"
    }, {
      "id": 1120, "n": "南谯区"
    }, {
      "id": 1121, "n": "来安县"
    }, {
      "id": 1122, "n": "全椒县"
    }, {
      "id": 1123, "n": "定远县"
    }, {
      "id": 1124, "n": "凤阳县"
    }, {
      "id": 1125, "n": "天长市"
    }, {
      "id": 1126, "n": "明光市"
    }]
  }, {
    "id": 1127, "n": "阜阳市", "c": [{
      "id": 1128, "n": "颍州区"
    }, {
      "id": 1129, "n": "颍东区"
    }, {
      "id": 1130, "n": "颍泉区"
    }, {
      "id": 1131, "n": "临泉县"
    }, {
      "id": 1132, "n": "太和县"
    }, {
      "id": 1133, "n": "阜南县"
    }, {
      "id": 1134, "n": "颍上县"
    }, {
      "id": 1135, "n": "界首市"
    }]
  }, {
    "id": 1136, "n": "宿州市", "c": [{
      "id": 1137, "n": "埇桥区"
    }, {
      "id": 1138, "n": "砀山县"
    }, {
      "id": 1139, "n": "萧县"
    }, {
      "id": 1140, "n": "灵璧县"
    }, {
      "id": 1141, "n": "泗县"
    }]
  }, {
    "id": 1142, "n": "六安市", "c": [{
      "id": 1143, "n": "金安区"
    }, {
      "id": 1144, "n": "裕安区"
    }, {
      "id": 1145, "n": "寿县"
    }, {
      "id": 1146, "n": "霍邱县"
    }, {
      "id": 1147, "n": "舒城县"
    }, {
      "id": 1148, "n": "金寨县"
    }, {
      "id": 1149, "n": "霍山县"
    }]
  }, {
    "id": 1150, "n": "亳州市", "c": [{
      "id": 1151, "n": "谯城区"
    }, {
      "id": 1152, "n": "涡阳县"
    }, {
      "id": 1153, "n": "蒙城县"
    }, {
      "id": 1154, "n": "利辛县"
    }]
  }, {
    "id": 1155, "n": "池州市", "c": [{
      "id": 1156, "n": "贵池区"
    }, {
      "id": 1157, "n": "东至县"
    }, {
      "id": 1158, "n": "石台县"
    }, {
      "id": 1159, "n": "青阳县"
    }]
  }, {
    "id": 1160, "n": "宣城市", "c": [{
      "id": 1161, "n": "宣州区"
    }, {
      "id": 1162, "n": "郎溪县"
    }, {
      "id": 1163, "n": "广德县"
    }, {
      "id": 1164, "n": "泾县"
    }, {
      "id": 1165, "n": "绩溪县"
    }, {
      "id": 1166, "n": "旌德县"
    }, {
      "id": 1167, "n": "宁国市"
    }]
  }]
}, {
  "id": 1168, "n": "福建省", "c": [{
    "id": 1169, "n": "福州市", "c": [{
      "id": 1170, "n": "鼓楼区"
    }, {
      "id": 1171, "n": "台江区"
    }, {
      "id": 1172, "n": "仓山区"
    }, {
      "id": 1173, "n": "马尾区"
    }, {
      "id": 1174, "n": "晋安区"
    }, {
      "id": 1175, "n": "闽侯县"
    }, {
      "id": 1176, "n": "连江县"
    }, {
      "id": 1177, "n": "罗源县"
    }, {
      "id": 1178, "n": "闽清县"
    }, {
      "id": 1179, "n": "永泰县"
    }, {
      "id": 1180, "n": "平潭县"
    }, {
      "id": 1181, "n": "福清市"
    }, {
      "id": 1182, "n": "长乐市"
    }]
  }, {
    "id": 1183, "n": "厦门市", "c": [{
      "id": 1184, "n": "思明区"
    }, {
      "id": 1185, "n": "海沧区"
    }, {
      "id": 1186, "n": "湖里区"
    }, {
      "id": 1187, "n": "集美区"
    }, {
      "id": 1188, "n": "同安区"
    }, {
      "id": 1189, "n": "翔安区"
    }]
  }, {
    "id": 1190, "n": "莆田市", "c": [{
      "id": 1191, "n": "城厢区"
    }, {
      "id": 1192, "n": "涵江区"
    }, {
      "id": 1193, "n": "荔城区"
    }, {
      "id": 1194, "n": "秀屿区"
    }, {
      "id": 1195, "n": "仙游县"
    }]
  }, {
    "id": 1196, "n": "三明市", "c": [{
      "id": 1197, "n": "梅列区"
    }, {
      "id": 1198, "n": "三元区"
    }, {
      "id": 1199, "n": "明溪县"
    }, {
      "id": 1200, "n": "清流县"
    }, {
      "id": 1201, "n": "宁化县"
    }, {
      "id": 1202, "n": "大田县"
    }, {
      "id": 1203, "n": "尤溪县"
    }, {
      "id": 1204, "n": "沙县"
    }, {
      "id": 1205, "n": "将乐县"
    }, {
      "id": 1206, "n": "泰宁县"
    }, {
      "id": 1207, "n": "建宁县"
    }, {
      "id": 1208, "n": "永安市"
    }]
  }, {
    "id": 1209, "n": "泉州市", "c": [{
      "id": 1210, "n": "鲤城区"
    }, {
      "id": 1211, "n": "丰泽区"
    }, {
      "id": 1212, "n": "洛江区"
    }, {
      "id": 1213, "n": "泉港区"
    }, {
      "id": 1214, "n": "惠安县"
    }, {
      "id": 1215, "n": "安溪县"
    }, {
      "id": 1216, "n": "永春县"
    }, {
      "id": 1217, "n": "德化县"
    }, {
      "id": 1218, "n": "金门县"
    }, {
      "id": 1219, "n": "石狮市"
    }, {
      "id": 1220, "n": "晋江市"
    }, {
      "id": 1221, "n": "南安市"
    }]
  }, {
    "id": 1222, "n": "漳州市", "c": [{
      "id": 1223, "n": "芗城区"
    }, {
      "id": 1224, "n": "龙文区"
    }, {
      "id": 1225, "n": "云霄县"
    }, {
      "id": 1226, "n": "漳浦县"
    }, {
      "id": 1227, "n": "诏安县"
    }, {
      "id": 1228, "n": "长泰县"
    }, {
      "id": 1229, "n": "东山县"
    }, {
      "id": 1230, "n": "南靖县"
    }, {
      "id": 1231, "n": "平和县"
    }, {
      "id": 1232, "n": "华安县"
    }, {
      "id": 1233, "n": "龙海市"
    }]
  }, {
    "id": 1234, "n": "南平市", "c": [{
      "id": 1235, "n": "延平区"
    }, {
      "id": 1236, "n": "建阳区"
    }, {
      "id": 1237, "n": "顺昌县"
    }, {
      "id": 1238, "n": "浦城县"
    }, {
      "id": 1239, "n": "光泽县"
    }, {
      "id": 1240, "n": "松溪县"
    }, {
      "id": 1241, "n": "政和县"
    }, {
      "id": 1242, "n": "邵武市"
    }, {
      "id": 1243, "n": "武夷山市"
    }, {
      "id": 1244, "n": "建瓯市"
    }]
  }, {
    "id": 1245, "n": "龙岩市", "c": [{
      "id": 1246, "n": "新罗区"
    }, {
      "id": 1247, "n": "长汀县"
    }, {
      "id": 1248, "n": "永定区"
    }, {
      "id": 1249, "n": "上杭县"
    }, {
      "id": 1250, "n": "武平县"
    }, {
      "id": 1251, "n": "连城县"
    }, {
      "id": 1252, "n": "漳平市"
    }]
  }, {
    "id": 1253, "n": "宁德市", "c": [{
      "id": 1254, "n": "蕉城区"
    }, {
      "id": 1255, "n": "霞浦县"
    }, {
      "id": 1256, "n": "古田县"
    }, {
      "id": 1257, "n": "屏南县"
    }, {
      "id": 1258, "n": "寿宁县"
    }, {
      "id": 1259, "n": "周宁县"
    }, {
      "id": 1260, "n": "柘荣县"
    }, {
      "id": 1261, "n": "福安市"
    }, {
      "id": 1262, "n": "福鼎市"
    }]
  }]
}, {
  "id": 1263, "n": "江西省", "c": [{
    "id": 1264, "n": "南昌市", "c": [{
      "id": 1265, "n": "东湖区"
    }, {
      "id": 1266, "n": "西湖区"
    }, {
      "id": 1267, "n": "青云谱区"
    }, {
      "id": 1268, "n": "湾里区"
    }, {
      "id": 1269, "n": "青山湖区"
    }, {
      "id": 1270, "n": "南昌县"
    }, {
      "id": 1271, "n": "新建县"
    }, {
      "id": 1272, "n": "安义县"
    }, {
      "id": 1273, "n": "进贤县"
    }, {
      "id": 127301, "n": "高新区"
    }]
  }, {
    "id": 1274, "n": "景德镇市", "c": [{
      "id": 1275, "n": "昌江区"
    }, {
      "id": 1276, "n": "珠山区"
    }, {
      "id": 1277, "n": "浮梁县"
    }, {
      "id": 1278, "n": "乐平市"
    }]
  }, {
    "id": 1279, "n": "萍乡市", "c": [{
      "id": 1280, "n": "安源区"
    }, {
      "id": 1281, "n": "湘东区"
    }, {
      "id": 1282, "n": "莲花县"
    }, {
      "id": 1283, "n": "上栗县"
    }, {
      "id": 1284, "n": "芦溪县"
    }]
  }, {
    "id": 1285, "n": "九江市", "c": [{
      "id": 1286, "n": "庐山区"
    }, {
      "id": 1287, "n": "浔阳区"
    }, {
      "id": 1288, "n": "九江县"
    }, {
      "id": 1289, "n": "武宁县"
    }, {
      "id": 1290, "n": "修水县"
    }, {
      "id": 1291, "n": "永修县"
    }, {
      "id": 1292, "n": "德安县"
    }, {
      "id": 1293, "n": "星子县"
    }, {
      "id": 1294, "n": "都昌县"
    }, {
      "id": 1295, "n": "湖口县"
    }, {
      "id": 1296, "n": "彭泽县"
    }, {
      "id": 1297, "n": "瑞昌市"
    }, {
      "id": 1298, "n": "共青城市"
    }]
  }, {
    "id": 1299, "n": "新余市", "c": [{
      "id": 1300, "n": "渝水区"
    }, {
      "id": 1301, "n": "分宜县"
    }]
  }, {
    "id": 1302, "n": "鹰潭市", "c": [{
      "id": 1303, "n": "月湖区"
    }, {
      "id": 1304, "n": "余江县"
    }, {
      "id": 1305, "n": "贵溪市"
    }]
  }, {
    "id": 1306, "n": "赣州市", "c": [{
      "id": 1307, "n": "章贡区"
    }, {
      "id": 1308, "n": "南康区"
    }, {
      "id": 1309, "n": "赣县"
    }, {
      "id": 1310, "n": "信丰县"
    }, {
      "id": 1311, "n": "大余县"
    }, {
      "id": 1312, "n": "上犹县"
    }, {
      "id": 1313, "n": "崇义县"
    }, {
      "id": 1314, "n": "安远县"
    }, {
      "id": 1315, "n": "龙南县"
    }, {
      "id": 1316, "n": "定南县"
    }, {
      "id": 1317, "n": "全南县"
    }, {
      "id": 1318, "n": "宁都县"
    }, {
      "id": 1319, "n": "于都县"
    }, {
      "id": 1320, "n": "兴国县"
    }, {
      "id": 1321, "n": "会昌县"
    }, {
      "id": 1322, "n": "寻乌县"
    }, {
      "id": 1323, "n": "石城县"
    }, {
      "id": 1324, "n": "瑞金市"
    }]
  }, {
    "id": 1325, "n": "吉安市", "c": [{
      "id": 1326, "n": "吉州区"
    }, {
      "id": 1327, "n": "青原区"
    }, {
      "id": 1328, "n": "吉安县"
    }, {
      "id": 1329, "n": "吉水县"
    }, {
      "id": 1330, "n": "峡江县"
    }, {
      "id": 1331, "n": "新干县"
    }, {
      "id": 1332, "n": "永丰县"
    }, {
      "id": 1333, "n": "泰和县"
    }, {
      "id": 1334, "n": "遂川县"
    }, {
      "id": 1335, "n": "万安县"
    }, {
      "id": 1336, "n": "安福县"
    }, {
      "id": 1337, "n": "永新县"
    }, {
      "id": 1338, "n": "井冈山市"
    }]
  }, {
    "id": 1339, "n": "宜春市", "c": [{
      "id": 1340, "n": "袁州区"
    }, {
      "id": 1341, "n": "奉新县"
    }, {
      "id": 1342, "n": "万载县"
    }, {
      "id": 1343, "n": "上高县"
    }, {
      "id": 1344, "n": "宜丰县"
    }, {
      "id": 1345, "n": "靖安县"
    }, {
      "id": 1346, "n": "铜鼓县"
    }, {
      "id": 1347, "n": "丰城市"
    }, {
      "id": 1348, "n": "樟树市"
    }, {
      "id": 1349, "n": "高安市"
    }]
  }, {
    "id": 1350, "n": "抚州市", "c": [{
      "id": 1351, "n": "临川区"
    }, {
      "id": 1352, "n": "南城县"
    }, {
      "id": 1353, "n": "黎川县"
    }, {
      "id": 1354, "n": "南丰县"
    }, {
      "id": 1355, "n": "崇仁县"
    }, {
      "id": 1356, "n": "乐安县"
    }, {
      "id": 1357, "n": "宜黄县"
    }, {
      "id": 1358, "n": "金溪县"
    }, {
      "id": 1359, "n": "资溪县"
    }, {
      "id": 1360, "n": "东乡县"
    }, {
      "id": 1361, "n": "广昌县"
    }]
  }, {
    "id": 1362, "n": "上饶市", "c": [{
      "id": 1363, "n": "信州区"
    }, {
      "id": 1364, "n": "上饶县"
    }, {
      "id": 1365, "n": "广丰县"
    }, {
      "id": 1366, "n": "玉山县"
    }, {
      "id": 1367, "n": "铅山县"
    }, {
      "id": 1368, "n": "横峰县"
    }, {
      "id": 1369, "n": "弋阳县"
    }, {
      "id": 1370, "n": "余干县"
    }, {
      "id": 1371, "n": "鄱阳县"
    }, {
      "id": 1372, "n": "万年县"
    }, {
      "id": 1373, "n": "婺源县"
    }, {
      "id": 1374, "n": "德兴市"
    }]
  }]
}, {
  "id": 1375, "n": "山东省", "c": [{
    "id": 1376, "n": "济南市", "c": [{
      "id": 1377, "n": "历下区"
    }, {
      "id": 1378, "n": "市中区"
    }, {
      "id": 1379, "n": "槐荫区"
    }, {
      "id": 1380, "n": "天桥区"
    }, {
      "id": 1381, "n": "历城区"
    }, {
      "id": 1382, "n": "长清区"
    }, {
      "id": 1383, "n": "平阴县"
    }, {
      "id": 1384, "n": "济阳县"
    }, {
      "id": 1385, "n": "商河县"
    }, {
      "id": 1386, "n": "章丘市"
    }, {
      "id": 138601, "n": "高新区"
    }]
  }, {
    "id": 1387, "n": "青岛市", "c": [{
      "id": 1388, "n": "市南区"
    }, {
      "id": 1389, "n": "市北区"
    }, {
      "id": 1390, "n": "黄岛区"
    }, {
      "id": 1391, "n": "崂山区"
    }, {
      "id": 1392, "n": "李沧区"
    }, {
      "id": 1393, "n": "城阳区"
    }, {
      "id": 1394, "n": "胶州市"
    }, {
      "id": 1395, "n": "即墨市"
    }, {
      "id": 1396, "n": "平度市"
    }, {
      "id": 1397, "n": "莱西市"
    }, {
      "id": 1398, "n": "西海岸新区"
    }]
  }, {
    "id": 1399, "n": "淄博市", "c": [{
      "id": 1400, "n": "淄川区"
    }, {
      "id": 1401, "n": "张店区"
    }, {
      "id": 1402, "n": "博山区"
    }, {
      "id": 1403, "n": "临淄区"
    }, {
      "id": 1404, "n": "周村区"
    }, {
      "id": 1405, "n": "桓台县"
    }, {
      "id": 1406, "n": "高青县"
    }, {
      "id": 1407, "n": "沂源县"
    }]
  }, {
    "id": 1408, "n": "枣庄市", "c": [{
      "id": 1409, "n": "市中区"
    }, {
      "id": 1410, "n": "薛城区"
    }, {
      "id": 1411, "n": "峄城区"
    }, {
      "id": 1412, "n": "台儿庄区"
    }, {
      "id": 1413, "n": "山亭区"
    }, {
      "id": 1414, "n": "滕州市"
    }]
  }, {
    "id": 1415, "n": "东营市", "c": [{
      "id": 1416, "n": "东营区"
    }, {
      "id": 1417, "n": "河口区"
    }, {
      "id": 1418, "n": "垦利县"
    }, {
      "id": 1419, "n": "利津县"
    }, {
      "id": 1420, "n": "广饶县"
    }]
  }, {
    "id": 1421, "n": "烟台市", "c": [{
      "id": 1422, "n": "芝罘区"
    }, {
      "id": 1423, "n": "福山区"
    }, {
      "id": 1424, "n": "牟平区"
    }, {
      "id": 1425, "n": "莱山区"
    }, {
      "id": 1426, "n": "长岛县"
    }, {
      "id": 1427, "n": "龙口市"
    }, {
      "id": 1428, "n": "莱阳市"
    }, {
      "id": 1429, "n": "莱州市"
    }, {
      "id": 1430, "n": "蓬莱市"
    }, {
      "id": 1431, "n": "招远市"
    }, {
      "id": 1432, "n": "栖霞市"
    }, {
      "id": 1433, "n": "海阳市"
    }]
  }, {
    "id": 1434, "n": "潍坊市", "c": [{
      "id": 1435, "n": "潍城区"
    }, {
      "id": 1436, "n": "寒亭区"
    }, {
      "id": 1437, "n": "坊子区"
    }, {
      "id": 1438, "n": "奎文区"
    }, {
      "id": 1439, "n": "临朐县"
    }, {
      "id": 1440, "n": "昌乐县"
    }, {
      "id": 1441, "n": "青州市"
    }, {
      "id": 1442, "n": "诸城市"
    }, {
      "id": 1443, "n": "寿光市"
    }, {
      "id": 1444, "n": "安丘市"
    }, {
      "id": 1445, "n": "高密市"
    }, {
      "id": 1446, "n": "昌邑市"
    }, {
      "id": 144601, "n": "高新区"
    }]
  }, {
    "id": 1447, "n": "济宁市", "c": [{
      "id": 1448, "n": "任城区"
    }, {
      "id": 1449, "n": "兖州区"
    }, {
      "id": 1450, "n": "微山县"
    }, {
      "id": 1451, "n": "鱼台县"
    }, {
      "id": 1452, "n": "金乡县"
    }, {
      "id": 1453, "n": "嘉祥县"
    }, {
      "id": 1454, "n": "汶上县"
    }, {
      "id": 1455, "n": "泗水县"
    }, {
      "id": 1456, "n": "梁山县"
    }, {
      "id": 1457, "n": "曲阜市"
    }, {
      "id": 1458, "n": "邹城市"
    }]
  }, {
    "id": 1459, "n": "泰安市", "c": [{
      "id": 1460, "n": "泰山区"
    }, {
      "id": 1461, "n": "岱岳区"
    }, {
      "id": 1462, "n": "宁阳县"
    }, {
      "id": 1463, "n": "东平县"
    }, {
      "id": 1464, "n": "新泰市"
    }, {
      "id": 1465, "n": "肥城市"
    }]
  }, {
    "id": 1466, "n": "威海市", "c": [{
      "id": 1467, "n": "环翠区"
    }, {
      "id": 1468, "n": "文登区"
    }, {
      "id": 1469, "n": "荣成市"
    }, {
      "id": 1470, "n": "乳山市"
    }]
  }, {
    "id": 1471, "n": "日照市", "c": [{
      "id": 1472, "n": "东港区"
    }, {
      "id": 1473, "n": "岚山区"
    }, {
      "id": 1474, "n": "五莲县"
    }, {
      "id": 1475, "n": "莒县"
    }]
  }, {
    "id": 1476, "n": "莱芜市", "c": [{
      "id": 1477, "n": "莱城区"
    }, {
      "id": 1478, "n": "钢城区"
    }]
  }, {
    "id": 1479, "n": "临沂市", "c": [{
      "id": 1480, "n": "兰山区"
    }, {
      "id": 1481, "n": "罗庄区"
    }, {
      "id": 1482, "n": "河东区"
    }, {
      "id": 1483, "n": "沂南县"
    }, {
      "id": 1484, "n": "郯城县"
    }, {
      "id": 1485, "n": "沂水县"
    }, {
      "id": 1486, "n": "兰陵县"
    }, {
      "id": 1487, "n": "费县"
    }, {
      "id": 1488, "n": "平邑县"
    }, {
      "id": 1489, "n": "莒南县"
    }, {
      "id": 1490, "n": "蒙阴县"
    }, {
      "id": 1491, "n": "临沭县"
    }]
  }, {
    "id": 1492, "n": "德州市", "c": [{
      "id": 1493, "n": "德城区"
    }, {
      "id": 1494, "n": "陵城区"
    }, {
      "id": 1495, "n": "宁津县"
    }, {
      "id": 1496, "n": "庆云县"
    }, {
      "id": 1497, "n": "临邑县"
    }, {
      "id": 1498, "n": "齐河县"
    }, {
      "id": 1499, "n": "平原县"
    }, {
      "id": 1500, "n": "夏津县"
    }, {
      "id": 1501, "n": "武城县"
    }, {
      "id": 1502, "n": "乐陵市"
    }, {
      "id": 1503, "n": "禹城市"
    }]
  }, {
    "id": 1504, "n": "聊城市", "c": [{
      "id": 1505, "n": "东昌府区"
    }, {
      "id": 1506, "n": "阳谷县"
    }, {
      "id": 1507, "n": "莘县"
    }, {
      "id": 1508, "n": "茌平县"
    }, {
      "id": 1509, "n": "东阿县"
    }, {
      "id": 1510, "n": "冠县"
    }, {
      "id": 1511, "n": "高唐县"
    }, {
      "id": 1512, "n": "临清市"
    }]
  }, {
    "id": 1513, "n": "滨州市", "c": [{
      "id": 1514, "n": "滨城区"
    }, {
      "id": 1515, "n": "沾化区"
    }, {
      "id": 1516, "n": "惠民县"
    }, {
      "id": 1517, "n": "阳信县"
    }, {
      "id": 1518, "n": "无棣县"
    }, {
      "id": 1519, "n": "博兴县"
    }, {
      "id": 1520, "n": "邹平县"
    }, {
      "id": 1521, "n": "北海新区"
    }]
  }, {
    "id": 1522, "n": "菏泽市", "c": [{
      "id": 1523, "n": "牡丹区"
    }, {
      "id": 1524, "n": "曹县"
    }, {
      "id": 1525, "n": "单县"
    }, {
      "id": 1526, "n": "成武县"
    }, {
      "id": 1527, "n": "巨野县"
    }, {
      "id": 1528, "n": "郓城县"
    }, {
      "id": 1529, "n": "鄄城县"
    }, {
      "id": 1530, "n": "定陶县"
    }, {
      "id": 1531, "n": "东明县"
    }]
  }]
}, {
  "id": 1532, "n": "河南省", "c": [{
    "id": 1533, "n": "郑州市", "c": [{
      "id": 1534, "n": "中原区"
    }, {
      "id": 1535, "n": "二七区"
    }, {
      "id": 1536, "n": "管城回族区"
    }, {
      "id": 1537, "n": "金水区"
    }, {
      "id": 1538, "n": "上街区"
    }, {
      "id": 1539, "n": "惠济区"
    }, {
      "id": 1540, "n": "中牟县"
    }, {
      "id": 1541, "n": "巩义市"
    }, {
      "id": 1542, "n": "荥阳市"
    }, {
      "id": 1543, "n": "新密市"
    }, {
      "id": 1544, "n": "新郑市"
    }, {
      "id": 1545, "n": "登封市"
    }, {
      "id": 154501, "n": "郑东新区"
    }, {
      "id": 154502, "n": "航空港区"
    }, {
      "id": 154503, "n": "经济技术开发区"
    }]
  }, {
    "id": 1546, "n": "开封市", "c": [{
      "id": 1547, "n": "龙亭区"
    }, {
      "id": 1548, "n": "顺河回族区"
    }, {
      "id": 1549, "n": "鼓楼区"
    }, {
      "id": 1550, "n": "禹王台区"
    }, {
      "id": 1551, "n": "祥符区"
    }, {
      "id": 1552, "n": "杞县"
    }, {
      "id": 1553, "n": "通许县"
    }, {
      "id": 1554, "n": "尉氏县"
    }, {
      "id": 1555, "n": "兰考县"
    }]
  }, {
    "id": 1556, "n": "洛阳市", "c": [{
      "id": 1557, "n": "老城区"
    }, {
      "id": 1558, "n": "西工区"
    }, {
      "id": 1559, "n": "瀍河回族区"
    }, {
      "id": 1560, "n": "涧西区"
    }, {
      "id": 1561, "n": "吉利区"
    }, {
      "id": 1562, "n": "洛龙区"
    }, {
      "id": 1563, "n": "孟津县"
    }, {
      "id": 1564, "n": "新安县"
    }, {
      "id": 1565, "n": "栾川县"
    }, {
      "id": 1566, "n": "嵩县"
    }, {
      "id": 1567, "n": "汝阳县"
    }, {
      "id": 1568, "n": "宜阳县"
    }, {
      "id": 1569, "n": "洛宁县"
    }, {
      "id": 1570, "n": "伊川县"
    }, {
      "id": 1571, "n": "偃师市"
    }]
  }, {
    "id": 1572, "n": "平顶山市", "c": [{
      "id": 1573, "n": "新华区"
    }, {
      "id": 1574, "n": "卫东区"
    }, {
      "id": 1575, "n": "石龙区"
    }, {
      "id": 1576, "n": "湛河区"
    }, {
      "id": 1577, "n": "宝丰县"
    }, {
      "id": 1578, "n": "叶县"
    }, {
      "id": 1579, "n": "鲁山县"
    }, {
      "id": 1580, "n": "郏县"
    }, {
      "id": 1581, "n": "舞钢市"
    }, {
      "id": 1582, "n": "汝州市"
    }]
  }, {
    "id": 1583, "n": "安阳市", "c": [{
      "id": 1584, "n": "文峰区"
    }, {
      "id": 1585, "n": "北关区"
    }, {
      "id": 1586, "n": "殷都区"
    }, {
      "id": 1587, "n": "龙安区"
    }, {
      "id": 1588, "n": "安阳县"
    }, {
      "id": 1589, "n": "汤阴县"
    }, {
      "id": 1590, "n": "滑县"
    }, {
      "id": 1591, "n": "内黄县"
    }, {
      "id": 1592, "n": "林州市"
    }]
  }, {
    "id": 1593, "n": "鹤壁市", "c": [{
      "id": 1594, "n": "鹤山区"
    }, {
      "id": 1595, "n": "山城区"
    }, {
      "id": 1596, "n": "淇滨区"
    }, {
      "id": 1597, "n": "浚县"
    }, {
      "id": 1598, "n": "淇县"
    }]
  }, {
    "id": 1599, "n": "新乡市", "c": [{
      "id": 1600, "n": "红旗区"
    }, {
      "id": 1601, "n": "卫滨区"
    }, {
      "id": 1602, "n": "凤泉区"
    }, {
      "id": 1603, "n": "牧野区"
    }, {
      "id": 1604, "n": "新乡县"
    }, {
      "id": 1605, "n": "获嘉县"
    }, {
      "id": 1606, "n": "原阳县"
    }, {
      "id": 1607, "n": "延津县"
    }, {
      "id": 1608, "n": "封丘县"
    }, {
      "id": 1609, "n": "长垣县"
    }, {
      "id": 1610, "n": "卫辉市"
    }, {
      "id": 1611, "n": "辉县市"
    }]
  }, {
    "id": 1612, "n": "焦作市", "c": [{
      "id": 1613, "n": "解放区"
    }, {
      "id": 1614, "n": "中站区"
    }, {
      "id": 1615, "n": "马村区"
    }, {
      "id": 1616, "n": "山阳区"
    }, {
      "id": 1617, "n": "修武县"
    }, {
      "id": 1618, "n": "博爱县"
    }, {
      "id": 1619, "n": "武陟县"
    }, {
      "id": 1620, "n": "温县"
    }, {
      "id": 1621, "n": "沁阳市"
    }, {
      "id": 1622, "n": "孟州市"
    }]
  }, {
    "id": 1623, "n": "濮阳市", "c": [{
      "id": 1624, "n": "华龙区"
    }, {
      "id": 1625, "n": "清丰县"
    }, {
      "id": 1626, "n": "南乐县"
    }, {
      "id": 1627, "n": "范县"
    }, {
      "id": 1628, "n": "台前县"
    }, {
      "id": 1629, "n": "濮阳县"
    }]
  }, {
    "id": 1630, "n": "许昌市", "c": [{
      "id": 1631, "n": "魏都区"
    }, {
      "id": 1632, "n": "许昌县"
    }, {
      "id": 1633, "n": "鄢陵县"
    }, {
      "id": 1634, "n": "襄城县"
    }, {
      "id": 1635, "n": "禹州市"
    }, {
      "id": 1636, "n": "长葛市"
    }]
  }, {
    "id": 1637, "n": "漯河市", "c": [{
      "id": 1638, "n": "源汇区"
    }, {
      "id": 1639, "n": "郾城区"
    }, {
      "id": 1640, "n": "召陵区"
    }, {
      "id": 1641, "n": "舞阳县"
    }, {
      "id": 1642, "n": "临颍县"
    }]
  }, {
    "id": 1643, "n": "三门峡市", "c": [{
      "id": 1644, "n": "湖滨区"
    }, {
      "id": 1645, "n": "渑池县"
    }, {
      "id": 1646, "n": "陕县"
    }, {
      "id": 1647, "n": "卢氏县"
    }, {
      "id": 1648, "n": "义马市"
    }, {
      "id": 1649, "n": "灵宝市"
    }]
  }, {
    "id": 1650, "n": "南阳市", "c": [{
      "id": 1651, "n": "宛城区"
    }, {
      "id": 1652, "n": "卧龙区"
    }, {
      "id": 1653, "n": "南召县"
    }, {
      "id": 1654, "n": "方城县"
    }, {
      "id": 1655, "n": "西峡县"
    }, {
      "id": 1656, "n": "镇平县"
    }, {
      "id": 1657, "n": "内乡县"
    }, {
      "id": 1658, "n": "淅川县"
    }, {
      "id": 1659, "n": "社旗县"
    }, {
      "id": 1660, "n": "唐河县"
    }, {
      "id": 1661, "n": "新野县"
    }, {
      "id": 1662, "n": "桐柏县"
    }, {
      "id": 1663, "n": "邓州市"
    }]
  }, {
    "id": 1664, "n": "商丘市", "c": [{
      "id": 1665, "n": "梁园区"
    }, {
      "id": 1666, "n": "睢阳区"
    }, {
      "id": 1667, "n": "民权县"
    }, {
      "id": 1668, "n": "睢县"
    }, {
      "id": 1669, "n": "宁陵县"
    }, {
      "id": 1670, "n": "柘城县"
    }, {
      "id": 1671, "n": "虞城县"
    }, {
      "id": 1672, "n": "夏邑县"
    }, {
      "id": 1673, "n": "永城市"
    }]
  }, {
    "id": 1674, "n": "信阳市", "c": [{
      "id": 1675, "n": "浉河区"
    }, {
      "id": 1676, "n": "平桥区"
    }, {
      "id": 1677, "n": "罗山县"
    }, {
      "id": 1678, "n": "光山县"
    }, {
      "id": 1679, "n": "新县"
    }, {
      "id": 1680, "n": "商城县"
    }, {
      "id": 1681, "n": "固始县"
    }, {
      "id": 1682, "n": "潢川县"
    }, {
      "id": 1683, "n": "淮滨县"
    }, {
      "id": 1684, "n": "息县"
    }]
  }, {
    "id": 1685, "n": "周口市", "c": [{
      "id": 1686, "n": "川汇区"
    }, {
      "id": 1687, "n": "扶沟县"
    }, {
      "id": 1688, "n": "西华县"
    }, {
      "id": 1689, "n": "商水县"
    }, {
      "id": 1690, "n": "沈丘县"
    }, {
      "id": 1691, "n": "郸城县"
    }, {
      "id": 1692, "n": "淮阳县"
    }, {
      "id": 1693, "n": "太康县"
    }, {
      "id": 1694, "n": "鹿邑县"
    }, {
      "id": 1695, "n": "项城市"
    }]
  }, {
    "id": 1696, "n": "驻马店市", "c": [{
      "id": 1697, "n": "驿城区"
    }, {
      "id": 1698, "n": "西平县"
    }, {
      "id": 1699, "n": "上蔡县"
    }, {
      "id": 1700, "n": "平舆县"
    }, {
      "id": 1701, "n": "正阳县"
    }, {
      "id": 1702, "n": "确山县"
    }, {
      "id": 1703, "n": "泌阳县"
    }, {
      "id": 1704, "n": "汝南县"
    }, {
      "id": 1705, "n": "遂平县"
    }, {
      "id": 1706, "n": "新蔡县"
    }]
  }, {
    "id": 1707, "n": "直辖县级", "c": [{
      "id": 1708, "n": "济源市"
    }]
  }]
}, {
  "id": 1709, "n": "湖北省", "c": [{
    "id": 1710, "n": "武汉市", "c": [{
      "id": 1711, "n": "江岸区"
    }, {
      "id": 1712, "n": "江汉区"
    }, {
      "id": 1713, "n": "硚口区"
    }, {
      "id": 1714, "n": "汉阳区"
    }, {
      "id": 1715, "n": "武昌区"
    }, {
      "id": 1716, "n": "青山区"
    }, {
      "id": 1717, "n": "洪山区"
    }, {
      "id": 1718, "n": "东西湖区"
    }, {
      "id": 1719, "n": "汉南区"
    }, {
      "id": 1720, "n": "蔡甸区"
    }, {
      "id": 1721, "n": "江夏区"
    }, {
      "id": 1722, "n": "黄陂区"
    }, {
      "id": 1723, "n": "新洲区"
    }]
  }, {
    "id": 1724, "n": "黄石市", "c": [{
      "id": 1725, "n": "黄石港区"
    }, {
      "id": 1726, "n": "西塞山区"
    }, {
      "id": 1727, "n": "下陆区"
    }, {
      "id": 1728, "n": "铁山区"
    }, {
      "id": 1729, "n": "阳新县"
    }, {
      "id": 1730, "n": "大冶市"
    }]
  }, {
    "id": 1731, "n": "十堰市", "c": [{
      "id": 1732, "n": "茅箭区"
    }, {
      "id": 1733, "n": "张湾区"
    }, {
      "id": 1734, "n": "郧阳区"
    }, {
      "id": 1735, "n": "郧西县"
    }, {
      "id": 1736, "n": "竹山县"
    }, {
      "id": 1737, "n": "竹溪县"
    }, {
      "id": 1738, "n": "房县"
    }, {
      "id": 1739, "n": "丹江口市"
    }]
  }, {
    "id": 1740, "n": "宜昌市", "c": [{
      "id": 1741, "n": "西陵区"
    }, {
      "id": 1742, "n": "伍家岗区"
    }, {
      "id": 1743, "n": "点军区"
    }, {
      "id": 1744, "n": "猇亭区"
    }, {
      "id": 1745, "n": "夷陵区"
    }, {
      "id": 1746, "n": "远安县"
    }, {
      "id": 1747, "n": "兴山县"
    }, {
      "id": 1748, "n": "秭归县"
    }, {
      "id": 1749, "n": "长阳土家族自治县"
    }, {
      "id": 1750, "n": "五峰土家族自治县"
    }, {
      "id": 1751, "n": "宜都市"
    }, {
      "id": 1752, "n": "当阳市"
    }, {
      "id": 1753, "n": "枝江市"
    }]
  }, {
    "id": 1754, "n": "襄阳市", "c": [{
      "id": 1755, "n": "襄城区"
    }, {
      "id": 1756, "n": "樊城区"
    }, {
      "id": 1757, "n": "襄州区"
    }, {
      "id": 1758, "n": "南漳县"
    }, {
      "id": 1759, "n": "谷城县"
    }, {
      "id": 1760, "n": "保康县"
    }, {
      "id": 1761, "n": "老河口市"
    }, {
      "id": 1762, "n": "枣阳市"
    }, {
      "id": 1763, "n": "宜城市"
    }]
  }, {
    "id": 1764, "n": "鄂州市", "c": [{
      "id": 1765, "n": "梁子湖区"
    }, {
      "id": 1766, "n": "华容区"
    }, {
      "id": 1767, "n": "鄂城区"
    }]
  }, {
    "id": 1768, "n": "荆门市", "c": [{
      "id": 1769, "n": "东宝区"
    }, {
      "id": 1770, "n": "掇刀区"
    }, {
      "id": 1771, "n": "京山县"
    }, {
      "id": 1772, "n": "沙洋县"
    }, {
      "id": 1773, "n": "钟祥市"
    }]
  }, {
    "id": 1774, "n": "孝感市", "c": [{
      "id": 1775, "n": "孝南区"
    }, {
      "id": 1776, "n": "孝昌县"
    }, {
      "id": 1777, "n": "大悟县"
    }, {
      "id": 1778, "n": "云梦县"
    }, {
      "id": 1779, "n": "应城市"
    }, {
      "id": 1780, "n": "安陆市"
    }, {
      "id": 1781, "n": "汉川市"
    }]
  }, {
    "id": 1782, "n": "荆州市", "c": [{
      "id": 1783, "n": "沙市区"
    }, {
      "id": 1784, "n": "荆州区"
    }, {
      "id": 1785, "n": "公安县"
    }, {
      "id": 1786, "n": "监利县"
    }, {
      "id": 1787, "n": "江陵县"
    }, {
      "id": 1788, "n": "石首市"
    }, {
      "id": 1789, "n": "洪湖市"
    }, {
      "id": 1790, "n": "松滋市"
    }]
  }, {
    "id": 1791, "n": "黄冈市", "c": [{
      "id": 1792, "n": "黄州区"
    }, {
      "id": 1793, "n": "团风县"
    }, {
      "id": 1794, "n": "红安县"
    }, {
      "id": 1795, "n": "罗田县"
    }, {
      "id": 1796, "n": "英山县"
    }, {
      "id": 1797, "n": "浠水县"
    }, {
      "id": 1798, "n": "蕲春县"
    }, {
      "id": 1799, "n": "黄梅县"
    }, {
      "id": 1800, "n": "麻城市"
    }, {
      "id": 1801, "n": "武穴市"
    }]
  }, {
    "id": 1802, "n": "咸宁市", "c": [{
      "id": 1803, "n": "咸安区"
    }, {
      "id": 1804, "n": "嘉鱼县"
    }, {
      "id": 1805, "n": "通城县"
    }, {
      "id": 1806, "n": "崇阳县"
    }, {
      "id": 1807, "n": "通山县"
    }, {
      "id": 1808, "n": "赤壁市"
    }]
  }, {
    "id": 1809, "n": "随州市", "c": [{
      "id": 1810, "n": "曾都区"
    }, {
      "id": 1811, "n": "随县"
    }, {
      "id": 1812, "n": "广水市"
    }]
  }, {
    "id": 1813, "n": "恩施土家族苗族自治州", "c": [{
      "id": 1814, "n": "恩施市"
    }, {
      "id": 1815, "n": "利川市"
    }, {
      "id": 1816, "n": "建始县"
    }, {
      "id": 1817, "n": "巴东县"
    }, {
      "id": 1818, "n": "宣恩县"
    }, {
      "id": 1819, "n": "咸丰县"
    }, {
      "id": 1820, "n": "来凤县"
    }, {
      "id": 1821, "n": "鹤峰县"
    }]
  }, {
    "id": 1822, "n": "直辖县级", "c": [{
      "id": 1823, "n": "仙桃市"
    }, {
      "id": 1824, "n": "潜江市"
    }, {
      "id": 1825, "n": "天门市"
    }, {
      "id": 1826, "n": "神农架林区"
    }]
  }]
}, {
  "id": 1827, "n": "湖南省", "c": [{
    "id": 1828, "n": "长沙市", "c": [{
      "id": 1829, "n": "芙蓉区"
    }, {
      "id": 1830, "n": "天心区"
    }, {
      "id": 1831, "n": "岳麓区"
    }, {
      "id": 1832, "n": "开福区"
    }, {
      "id": 1833, "n": "雨花区"
    }, {
      "id": 1834, "n": "望城区"
    }, {
      "id": 1835, "n": "长沙县"
    }, {
      "id": 1836, "n": "宁乡县"
    }, {
      "id": 1837, "n": "浏阳市"
    }]
  }, {
    "id": 1838, "n": "株洲市", "c": [{
      "id": 1839, "n": "荷塘区"
    }, {
      "id": 1840, "n": "芦淞区"
    }, {
      "id": 1841, "n": "石峰区"
    }, {
      "id": 1842, "n": "天元区"
    }, {
      "id": 1843, "n": "株洲县"
    }, {
      "id": 1844, "n": "攸县"
    }, {
      "id": 1845, "n": "茶陵县"
    }, {
      "id": 1846, "n": "炎陵县"
    }, {
      "id": 1847, "n": "醴陵市"
    }]
  }, {
    "id": 1848, "n": "湘潭市", "c": [{
      "id": 1849, "n": "雨湖区"
    }, {
      "id": 1850, "n": "岳塘区"
    }, {
      "id": 1851, "n": "湘潭县"
    }, {
      "id": 1852, "n": "湘乡市"
    }, {
      "id": 1853, "n": "韶山市"
    }]
  }, {
    "id": 1854, "n": "衡阳市", "c": [{
      "id": 1855, "n": "珠晖区"
    }, {
      "id": 1856, "n": "雁峰区"
    }, {
      "id": 1857, "n": "石鼓区"
    }, {
      "id": 1858, "n": "蒸湘区"
    }, {
      "id": 1859, "n": "南岳区"
    }, {
      "id": 1860, "n": "衡阳县"
    }, {
      "id": 1861, "n": "衡南县"
    }, {
      "id": 1862, "n": "衡山县"
    }, {
      "id": 1863, "n": "衡东县"
    }, {
      "id": 1864, "n": "祁东县"
    }, {
      "id": 1865, "n": "耒阳市"
    }, {
      "id": 1866, "n": "常宁市"
    }]
  }, {
    "id": 1867, "n": "邵阳市", "c": [{
      "id": 1868, "n": "双清区"
    }, {
      "id": 1869, "n": "大祥区"
    }, {
      "id": 1870, "n": "北塔区"
    }, {
      "id": 1871, "n": "邵东县"
    }, {
      "id": 1872, "n": "新邵县"
    }, {
      "id": 1873, "n": "邵阳县"
    }, {
      "id": 1874, "n": "隆回县"
    }, {
      "id": 1875, "n": "洞口县"
    }, {
      "id": 1876, "n": "绥宁县"
    }, {
      "id": 1877, "n": "新宁县"
    }, {
      "id": 1878, "n": "城步苗族自治县"
    }, {
      "id": 1879, "n": "武冈市"
    }]
  }, {
    "id": 1880, "n": "岳阳市", "c": [{
      "id": 1881, "n": "岳阳楼区"
    }, {
      "id": 1882, "n": "云溪区"
    }, {
      "id": 1883, "n": "君山区"
    }, {
      "id": 1884, "n": "岳阳县"
    }, {
      "id": 1885, "n": "华容县"
    }, {
      "id": 1886, "n": "湘阴县"
    }, {
      "id": 1887, "n": "平江县"
    }, {
      "id": 1888, "n": "汨罗市"
    }, {
      "id": 1889, "n": "临湘市"
    }]
  }, {
    "id": 1890, "n": "常德市", "c": [{
      "id": 1891, "n": "武陵区"
    }, {
      "id": 1892, "n": "鼎城区"
    }, {
      "id": 1893, "n": "安乡县"
    }, {
      "id": 1894, "n": "汉寿县"
    }, {
      "id": 1895, "n": "澧县"
    }, {
      "id": 1896, "n": "临澧县"
    }, {
      "id": 1897, "n": "桃源县"
    }, {
      "id": 1898, "n": "石门县"
    }, {
      "id": 1899, "n": "津市市"
    }]
  }, {
    "id": 1900, "n": "张家界市", "c": [{
      "id": 1901, "n": "永定区"
    }, {
      "id": 1902, "n": "武陵源区"
    }, {
      "id": 1903, "n": "慈利县"
    }, {
      "id": 1904, "n": "桑植县"
    }]
  }, {
    "id": 1905, "n": "益阳市", "c": [{
      "id": 1906, "n": "资阳区"
    }, {
      "id": 1907, "n": "赫山区"
    }, {
      "id": 1908, "n": "南县"
    }, {
      "id": 1909, "n": "桃江县"
    }, {
      "id": 1910, "n": "安化县"
    }, {
      "id": 1911, "n": "沅江市"
    }]
  }, {
    "id": 1912, "n": "郴州市", "c": [{
      "id": 1913, "n": "北湖区"
    }, {
      "id": 1914, "n": "苏仙区"
    }, {
      "id": 1915, "n": "桂阳县"
    }, {
      "id": 1916, "n": "宜章县"
    }, {
      "id": 1917, "n": "永兴县"
    }, {
      "id": 1918, "n": "嘉禾县"
    }, {
      "id": 1919, "n": "临武县"
    }, {
      "id": 1920, "n": "汝城县"
    }, {
      "id": 1921, "n": "桂东县"
    }, {
      "id": 1922, "n": "安仁县"
    }, {
      "id": 1923, "n": "资兴市"
    }]
  }, {
    "id": 1924, "n": "永州市", "c": [{
      "id": 1925, "n": "零陵区"
    }, {
      "id": 1926, "n": "冷水滩区"
    }, {
      "id": 1927, "n": "祁阳县"
    }, {
      "id": 1928, "n": "东安县"
    }, {
      "id": 1929, "n": "双牌县"
    }, {
      "id": 1930, "n": "道县"
    }, {
      "id": 1931, "n": "江永县"
    }, {
      "id": 1932, "n": "宁远县"
    }, {
      "id": 1933, "n": "蓝山县"
    }, {
      "id": 1934, "n": "新田县"
    }, {
      "id": 1935, "n": "江华瑶族自治县"
    }]
  }, {
    "id": 1936, "n": "怀化市", "c": [{
      "id": 1937, "n": "鹤城区"
    }, {
      "id": 1938, "n": "中方县"
    }, {
      "id": 1939, "n": "沅陵县"
    }, {
      "id": 1940, "n": "辰溪县"
    }, {
      "id": 1941, "n": "溆浦县"
    }, {
      "id": 1942, "n": "会同县"
    }, {
      "id": 1943, "n": "麻阳苗族自治县"
    }, {
      "id": 1944, "n": "新晃侗族自治县"
    }, {
      "id": 1945, "n": "芷江侗族自治县"
    }, {
      "id": 1946, "n": "靖州苗族侗族自治县"
    }, {
      "id": 1947, "n": "通道侗族自治县"
    }, {
      "id": 1948, "n": "洪江市"
    }]
  }, {
    "id": 1949, "n": "娄底市", "c": [{
      "id": 1950, "n": "娄星区"
    }, {
      "id": 1951, "n": "双峰县"
    }, {
      "id": 1952, "n": "新化县"
    }, {
      "id": 1953, "n": "冷水江市"
    }, {
      "id": 1954, "n": "涟源市"
    }]
  }, {
    "id": 1955, "n": "湘西土家族苗族自治州", "c": [{
      "id": 1956, "n": "吉首市"
    }, {
      "id": 1957, "n": "泸溪县"
    }, {
      "id": 1958, "n": "凤凰县"
    }, {
      "id": 1959, "n": "花垣县"
    }, {
      "id": 1960, "n": "保靖县"
    }, {
      "id": 1961, "n": "古丈县"
    }, {
      "id": 1962, "n": "永顺县"
    }, {
      "id": 1963, "n": "龙山县"
    }]
  }]
}, {
  "id": 1964, "n": "广东省", "c": [{
    "id": 1965, "n": "广州市", "c": [{
      "id": 1966, "n": "荔湾区"
    }, {
      "id": 1967, "n": "越秀区"
    }, {
      "id": 1968, "n": "海珠区"
    }, {
      "id": 1969, "n": "天河区"
    }, {
      "id": 1970, "n": "白云区"
    }, {
      "id": 1971, "n": "黄埔区"
    }, {
      "id": 1972, "n": "番禺区"
    }, {
      "id": 1973, "n": "花都区"
    }, {
      "id": 1974, "n": "南沙区"
    }, {
      "id": 1975, "n": "从化区"
    }, {
      "id": 1976, "n": "增城区"
    }]
  }, {
    "id": 1977, "n": "韶关市", "c": [{
      "id": 1978, "n": "武江区"
    }, {
      "id": 1979, "n": "浈江区"
    }, {
      "id": 1980, "n": "曲江区"
    }, {
      "id": 1981, "n": "始兴县"
    }, {
      "id": 1982, "n": "仁化县"
    }, {
      "id": 1983, "n": "翁源县"
    }, {
      "id": 1984, "n": "乳源瑶族自治县"
    }, {
      "id": 1985, "n": "新丰县"
    }, {
      "id": 1986, "n": "乐昌市"
    }, {
      "id": 1987, "n": "南雄市"
    }]
  }, {
    "id": 1988, "n": "深圳市", "c": [{
      "id": 1989, "n": "罗湖区"
    }, {
      "id": 1990, "n": "福田区"
    }, {
      "id": 1991, "n": "南山区"
    }, {
      "id": 1992, "n": "宝安区"
    }, {
      "id": 1993, "n": "龙岗区"
    }, {
      "id": 1994, "n": "盐田区"
    }, {
      "id": 1995, "n": "光明新区"
    }, {
      "id": 1996, "n": "坪山新区"
    }, {
      "id": 1997, "n": "大鹏新区"
    }, {
      "id": 1998, "n": "龙华新区"
    }]
  }, {
    "id": 1999, "n": "珠海市", "c": [{
      "id": 2000, "n": "香洲区"
    }, {
      "id": 2001, "n": "斗门区"
    }, {
      "id": 2002, "n": "金湾区"
    }]
  }, {
    "id": 2003, "n": "汕头市", "c": [{
      "id": 2004, "n": "龙湖区"
    }, {
      "id": 2005, "n": "金平区"
    }, {
      "id": 2006, "n": "濠江区"
    }, {
      "id": 2007, "n": "潮阳区"
    }, {
      "id": 2008, "n": "潮南区"
    }, {
      "id": 2009, "n": "澄海区"
    }, {
      "id": 2010, "n": "南澳县"
    }]
  }, {
    "id": 2011, "n": "佛山市", "c": [{
      "id": 2012, "n": "禅城区"
    }, {
      "id": 2013, "n": "南海区"
    }, {
      "id": 2014, "n": "顺德区"
    }, {
      "id": 2015, "n": "三水区"
    }, {
      "id": 2016, "n": "高明区"
    }]
  }, {
    "id": 2017, "n": "江门市", "c": [{
      "id": 2018, "n": "蓬江区"
    }, {
      "id": 2019, "n": "江海区"
    }, {
      "id": 2020, "n": "新会区"
    }, {
      "id": 2021, "n": "台山市"
    }, {
      "id": 2022, "n": "开平市"
    }, {
      "id": 2023, "n": "鹤山市"
    }, {
      "id": 2024, "n": "恩平市"
    }]
  }, {
    "id": 2025, "n": "湛江市", "c": [{
      "id": 2026, "n": "赤坎区"
    }, {
      "id": 2027, "n": "霞山区"
    }, {
      "id": 2028, "n": "坡头区"
    }, {
      "id": 2029, "n": "麻章区"
    }, {
      "id": 2030, "n": "遂溪县"
    }, {
      "id": 2031, "n": "徐闻县"
    }, {
      "id": 2032, "n": "廉江市"
    }, {
      "id": 2033, "n": "雷州市"
    }, {
      "id": 2034, "n": "吴川市"
    }, {
      "id": 203401, "n": "经济技术开发区"
    }]
  }, {
    "id": 2035, "n": "茂名市", "c": [{
      "id": 2036, "n": "茂南区"
    }, {
      "id": 2037, "n": "电白区"
    }, {
      "id": 2038, "n": "高州市"
    }, {
      "id": 2039, "n": "化州市"
    }, {
      "id": 2040, "n": "信宜市"
    }]
  }, {
    "id": 2041, "n": "肇庆市", "c": [{
      "id": 2042, "n": "端州区"
    }, {
      "id": 2043, "n": "鼎湖区"
    }, {
      "id": 2044, "n": "广宁县"
    }, {
      "id": 2045, "n": "怀集县"
    }, {
      "id": 2046, "n": "封开县"
    }, {
      "id": 2047, "n": "德庆县"
    }, {
      "id": 2048, "n": "高要市"
    }, {
      "id": 2049, "n": "四会市"
    }]
  }, {
    "id": 2050, "n": "惠州市", "c": [{
      "id": 2051, "n": "惠城区"
    }, {
      "id": 2052, "n": "惠阳区"
    }, {
      "id": 2053, "n": "博罗县"
    }, {
      "id": 2054, "n": "惠东县"
    }, {
      "id": 2055, "n": "龙门县"
    }]
  }, {
    "id": 2056, "n": "梅州市", "c": [{
      "id": 2057, "n": "梅江区"
    }, {
      "id": 2058, "n": "梅县区"
    }, {
      "id": 2059, "n": "大埔县"
    }, {
      "id": 2060, "n": "丰顺县"
    }, {
      "id": 2061, "n": "五华县"
    }, {
      "id": 2062, "n": "平远县"
    }, {
      "id": 2063, "n": "蕉岭县"
    }, {
      "id": 2064, "n": "兴宁市"
    }]
  }, {
    "id": 2065, "n": "汕尾市", "c": [{
      "id": 2066, "n": "城区"
    }, {
      "id": 2067, "n": "海丰县"
    }, {
      "id": 2068, "n": "陆河县"
    }, {
      "id": 2069, "n": "陆丰市"
    }]
  }, {
    "id": 2070, "n": "河源市", "c": [{
      "id": 2071, "n": "源城区"
    }, {
      "id": 2072, "n": "紫金县"
    }, {
      "id": 2073, "n": "龙川县"
    }, {
      "id": 2074, "n": "连平县"
    }, {
      "id": 2075, "n": "和平县"
    }, {
      "id": 2076, "n": "东源县"
    }]
  }, {
    "id": 2077, "n": "阳江市", "c": [{
      "id": 2078, "n": "江城区"
    }, {
      "id": 2079, "n": "阳东区"
    }, {
      "id": 2080, "n": "阳西县"
    }, {
      "id": 2081, "n": "阳春市"
    }]
  }, {
    "id": 2082, "n": "清远市", "c": [{
      "id": 2083, "n": "清城区"
    }, {
      "id": 2084, "n": "清新区"
    }, {
      "id": 2085, "n": "佛冈县"
    }, {
      "id": 2086, "n": "阳山县"
    }, {
      "id": 2087, "n": "连山壮族瑶族自治县"
    }, {
      "id": 2088, "n": "连南瑶族自治县"
    }, {
      "id": 2089, "n": "英德市"
    }, {
      "id": 2090, "n": "连州市"
    }]
  }, {
    "id": 2091, "n": "东莞市", "c": [{
      "id": 2092, "n": "莞城区"
    }, {
      "id": 2093, "n": "南城区"
    }, {
      "id": 2094, "n": "万江区"
    }, {
      "id": 2095, "n": "石碣镇"
    }, {
      "id": 2096, "n": "石龙镇"
    }, {
      "id": 2097, "n": "茶山镇"
    }, {
      "id": 2098, "n": "石排镇"
    }, {
      "id": 2099, "n": "企石镇"
    }, {
      "id": 2100, "n": "横沥镇"
    }, {
      "id": 2101, "n": "桥头镇"
    }, {
      "id": 2102, "n": "谢岗镇"
    }, {
      "id": 2103, "n": "东坑镇"
    }, {
      "id": 2104, "n": "常平镇"
    }, {
      "id": 2105, "n": "寮步镇"
    }, {
      "id": 2106, "n": "大朗镇"
    }, {
      "id": 2107, "n": "麻涌镇"
    }, {
      "id": 2108, "n": "中堂镇"
    }, {
      "id": 2109, "n": "高埗镇"
    }, {
      "id": 2110, "n": "樟木头镇"
    }, {
      "id": 2111, "n": "大岭山镇"
    }, {
      "id": 2112, "n": "望牛墩镇"
    }, {
      "id": 2113, "n": "黄江镇"
    }, {
      "id": 2114, "n": "洪梅镇"
    }, {
      "id": 2115, "n": "清溪镇"
    }, {
      "id": 2116, "n": "沙田镇"
    }, {
      "id": 2117, "n": "道滘镇"
    }, {
      "id": 2118, "n": "塘厦镇"
    }, {
      "id": 2119, "n": "虎门镇"
    }, {
      "id": 2120, "n": "厚街镇"
    }, {
      "id": 2121, "n": "凤岗镇"
    }, {
      "id": 2122, "n": "长安镇"
    }]
  }, {
    "id": 2123, "n": "中山市", "c": [{
      "id": 2124, "n": "石岐区"
    }, {
      "id": 2125, "n": "南区"
    }, {
      "id": 2126, "n": "五桂山区"
    }, {
      "id": 2127, "n": "火炬开发区"
    }, {
      "id": 2128, "n": "黄圃镇"
    }, {
      "id": 2129, "n": "南头镇"
    }, {
      "id": 2130, "n": "东凤镇"
    }, {
      "id": 2131, "n": "阜沙镇"
    }, {
      "id": 2132, "n": "小榄镇"
    }, {
      "id": 2133, "n": "东升镇"
    }, {
      "id": 2134, "n": "古镇镇"
    }, {
      "id": 2135, "n": "横栏镇"
    }, {
      "id": 2136, "n": "三角镇"
    }, {
      "id": 2137, "n": "民众镇"
    }, {
      "id": 2138, "n": "南朗镇"
    }, {
      "id": 2139, "n": "港口镇"
    }, {
      "id": 2140, "n": "大涌镇"
    }, {
      "id": 2141, "n": "沙溪镇"
    }, {
      "id": 2142, "n": "三乡镇"
    }, {
      "id": 2143, "n": "板芙镇"
    }, {
      "id": 2144, "n": "神湾镇"
    }, {
      "id": 2145, "n": "坦洲镇"
    }]
  }, {
    "id": 2146, "n": "潮州市", "c": [{
      "id": 2147, "n": "湘桥区"
    }, {
      "id": 2148, "n": "潮安区"
    }, {
      "id": 2149, "n": "饶平县"
    }]
  }, {
    "id": 2150, "n": "揭阳市", "c": [{
      "id": 2151, "n": "榕城区"
    }, {
      "id": 2152, "n": "揭东区"
    }, {
      "id": 2153, "n": "揭西县"
    }, {
      "id": 2154, "n": "惠来县"
    }, {
      "id": 2155, "n": "普宁市"
    }]
  }, {
    "id": 2156, "n": "云浮市", "c": [{
      "id": 2157, "n": "云城区"
    }, {
      "id": 2158, "n": "云安区"
    }, {
      "id": 2159, "n": "新兴县"
    }, {
      "id": 2160, "n": "郁南县"
    }, {
      "id": 2161, "n": "罗定市"
    }]
  }]
}, {
  "id": 2162, "n": "广西壮族自治区", "c": [{
    "id": 2163, "n": "南宁市", "c": [{
      "id": 2164, "n": "兴宁区"
    }, {
      "id": 2165, "n": "青秀区"
    }, {
      "id": 2166, "n": "江南区"
    }, {
      "id": 2167, "n": "西乡塘区"
    }, {
      "id": 2168, "n": "良庆区"
    }, {
      "id": 2169, "n": "邕宁区"
    }, {
      "id": 2170, "n": "武鸣县"
    }, {
      "id": 2171, "n": "隆安县"
    }, {
      "id": 2172, "n": "马山县"
    }, {
      "id": 2173, "n": "上林县"
    }, {
      "id": 2174, "n": "宾阳县"
    }, {
      "id": 2175, "n": "横县"
    }, {
      "id": 2176, "n": "埌东新区"
    }]
  }, {
    "id": 2177, "n": "柳州市", "c": [{
      "id": 2178, "n": "城中区"
    }, {
      "id": 2179, "n": "鱼峰区"
    }, {
      "id": 2180, "n": "柳南区"
    }, {
      "id": 2181, "n": "柳北区"
    }, {
      "id": 2182, "n": "柳江县"
    }, {
      "id": 2183, "n": "柳城县"
    }, {
      "id": 2184, "n": "鹿寨县"
    }, {
      "id": 2185, "n": "融安县"
    }, {
      "id": 2186, "n": "融水苗族自治县"
    }, {
      "id": 2187, "n": "三江侗族自治县"
    }, {
      "id": 2188, "n": "柳东新区"
    }]
  }, {
    "id": 2189, "n": "桂林市", "c": [{
      "id": 2190, "n": "秀峰区"
    }, {
      "id": 2191, "n": "叠彩区"
    }, {
      "id": 2192, "n": "象山区"
    }, {
      "id": 2193, "n": "七星区"
    }, {
      "id": 2194, "n": "雁山区"
    }, {
      "id": 2195, "n": "临桂区"
    }, {
      "id": 2196, "n": "阳朔县"
    }, {
      "id": 2197, "n": "灵川县"
    }, {
      "id": 2198, "n": "全州县"
    }, {
      "id": 2199, "n": "兴安县"
    }, {
      "id": 2200, "n": "永福县"
    }, {
      "id": 2201, "n": "灌阳县"
    }, {
      "id": 2202, "n": "龙胜各族自治县"
    }, {
      "id": 2203, "n": "资源县"
    }, {
      "id": 2204, "n": "平乐县"
    }, {
      "id": 2205, "n": "荔浦县"
    }, {
      "id": 2206, "n": "恭城瑶族自治县"
    }]
  }, {
    "id": 2207, "n": "梧州市", "c": [{
      "id": 2208, "n": "万秀区"
    }, {
      "id": 2209, "n": "长洲区"
    }, {
      "id": 2210, "n": "龙圩区"
    }, {
      "id": 2211, "n": "苍梧县"
    }, {
      "id": 2212, "n": "藤县"
    }, {
      "id": 2213, "n": "蒙山县"
    }, {
      "id": 2214, "n": "岑溪市"
    }]
  }, {
    "id": 2215, "n": "北海市", "c": [{
      "id": 2216, "n": "海城区"
    }, {
      "id": 2217, "n": "银海区"
    }, {
      "id": 2218, "n": "铁山港区"
    }, {
      "id": 2219, "n": "合浦县"
    }]
  }, {
    "id": 2220, "n": "防城港市", "c": [{
      "id": 2221, "n": "港口区"
    }, {
      "id": 2222, "n": "防城区"
    }, {
      "id": 2223, "n": "上思县"
    }, {
      "id": 2224, "n": "东兴市"
    }]
  }, {
    "id": 2225, "n": "钦州市", "c": [{
      "id": 2226, "n": "钦南区"
    }, {
      "id": 2227, "n": "钦北区"
    }, {
      "id": 2228, "n": "灵山县"
    }, {
      "id": 2229, "n": "浦北县"
    }]
  }, {
    "id": 2230, "n": "贵港市", "c": [{
      "id": 2231, "n": "港北区"
    }, {
      "id": 2232, "n": "港南区"
    }, {
      "id": 2233, "n": "覃塘区"
    }, {
      "id": 2234, "n": "平南县"
    }, {
      "id": 2235, "n": "桂平市"
    }]
  }, {
    "id": 2236, "n": "玉林市", "c": [{
      "id": 2237, "n": "玉州区"
    }, {
      "id": 2238, "n": "福绵区"
    }, {
      "id": 2239, "n": "玉东新区"
    }, {
      "id": 2240, "n": "容县"
    }, {
      "id": 2241, "n": "陆川县"
    }, {
      "id": 2242, "n": "博白县"
    }, {
      "id": 2243, "n": "兴业县"
    }, {
      "id": 2244, "n": "北流市"
    }]
  }, {
    "id": 2245, "n": "百色市", "c": [{
      "id": 2246, "n": "右江区"
    }, {
      "id": 2247, "n": "田阳县"
    }, {
      "id": 2248, "n": "田东县"
    }, {
      "id": 2249, "n": "平果县"
    }, {
      "id": 2250, "n": "德保县"
    }, {
      "id": 2251, "n": "靖西县"
    }, {
      "id": 2252, "n": "那坡县"
    }, {
      "id": 2253, "n": "凌云县"
    }, {
      "id": 2254, "n": "乐业县"
    }, {
      "id": 2255, "n": "田林县"
    }, {
      "id": 2256, "n": "西林县"
    }, {
      "id": 2257, "n": "隆林各族自治县"
    }]
  }, {
    "id": 2258, "n": "贺州市", "c": [{
      "id": 2259, "n": "八步区"
    }, {
      "id": 2260, "n": "昭平县"
    }, {
      "id": 2261, "n": "钟山县"
    }, {
      "id": 2262, "n": "富川瑶族自治县"
    }, {
      "id": 2263, "n": "平桂管理区"
    }]
  }, {
    "id": 2264, "n": "河池市", "c": [{
      "id": 2265, "n": "金城江区"
    }, {
      "id": 2266, "n": "南丹县"
    }, {
      "id": 2267, "n": "天峨县"
    }, {
      "id": 2268, "n": "凤山县"
    }, {
      "id": 2269, "n": "东兰县"
    }, {
      "id": 2270, "n": "罗城仫佬族自治县"
    }, {
      "id": 2271, "n": "环江毛南族自治县"
    }, {
      "id": 2272, "n": "巴马瑶族自治县"
    }, {
      "id": 2273, "n": "都安瑶族自治县"
    }, {
      "id": 2274, "n": "大化瑶族自治县"
    }, {
      "id": 2275, "n": "宜州市"
    }]
  }, {
    "id": 2276, "n": "来宾市", "c": [{
      "id": 2277, "n": "兴宾区"
    }, {
      "id": 2278, "n": "忻城县"
    }, {
      "id": 2279, "n": "象州县"
    }, {
      "id": 2280, "n": "武宣县"
    }, {
      "id": 2281, "n": "金秀瑶族自治县"
    }, {
      "id": 2282, "n": "合山市"
    }]
  }, {
    "id": 2283, "n": "崇左市", "c": [{
      "id": 2284, "n": "江州区"
    }, {
      "id": 2285, "n": "扶绥县"
    }, {
      "id": 2286, "n": "宁明县"
    }, {
      "id": 2287, "n": "龙州县"
    }, {
      "id": 2288, "n": "大新县"
    }, {
      "id": 2289, "n": "天等县"
    }, {
      "id": 2290, "n": "凭祥市"
    }]
  }]
}, {
  "id": 2291, "n": "海南省", "c": [{
    "id": 2292, "n": "海口市", "c": [{
      "id": 2293, "n": "秀英区"
    }, {
      "id": 2294, "n": "龙华区"
    }, {
      "id": 2295, "n": "琼山区"
    }, {
      "id": 2296, "n": "美兰区"
    }]
  }, {
    "id": 2297, "n": "三亚市", "c": [{
      "id": 2298, "n": "海棠区"
    }, {
      "id": 2299, "n": "吉阳区"
    }, {
      "id": 2300, "n": "天涯区"
    }, {
      "id": 2301, "n": "崖州区"
    }]
  }, {
    "id": 2302, "n": "三沙市", "c": [{
      "id": 2303, "n": "西沙群岛"
    }, {
      "id": 2304, "n": "南沙群岛"
    }, {
      "id": 2305, "n": "中沙群岛"
    }]
  }, {
    "id": 2306, "n": "直辖县级", "c": [{
      "id": 2307, "n": "五指山市"
    }, {
      "id": 2308, "n": "琼海市"
    }, {
      "id": 2309, "n": "儋州市"
    }, {
      "id": 2310, "n": "文昌市"
    }, {
      "id": 2311, "n": "万宁市"
    }, {
      "id": 2312, "n": "东方市"
    }, {
      "id": 2313, "n": "定安县"
    }, {
      "id": 2314, "n": "屯昌县"
    }, {
      "id": 2315, "n": "澄迈县"
    }, {
      "id": 2316, "n": "临高县"
    }, {
      "id": 2317, "n": "白沙黎族自治县"
    }, {
      "id": 2318, "n": "昌江黎族自治县"
    }, {
      "id": 2319, "n": "乐东黎族自治县"
    }, {
      "id": 2320, "n": "陵水黎族自治县"
    }, {
      "id": 2321, "n": "保亭黎族苗族自治县"
    }, {
      "id": 2322, "n": "琼中黎族苗族自治县"
    }]
  }]
}, {
  "id": 2323, "n": "重庆", "c": [{
    "id": 2324, "n": "重庆市", "c": [{
      "id": 2325, "n": "万州区"
    }, {
      "id": 2326, "n": "涪陵区"
    }, {
      "id": 2327, "n": "渝中区"
    }, {
      "id": 2328, "n": "大渡口区"
    }, {
      "id": 2329, "n": "江北区"
    }, {
      "id": 2330, "n": "沙坪坝区"
    }, {
      "id": 2331, "n": "九龙坡区"
    }, {
      "id": 2332, "n": "南岸区"
    }, {
      "id": 2333, "n": "北碚区"
    }, {
      "id": 2334, "n": "綦江区"
    }, {
      "id": 2335, "n": "大足区"
    }, {
      "id": 2336, "n": "渝北区"
    }, {
      "id": 2337, "n": "巴南区"
    }, {
      "id": 2338, "n": "黔江区"
    }, {
      "id": 2339, "n": "长寿区"
    }, {
      "id": 2340, "n": "江津区"
    }, {
      "id": 2341, "n": "合川区"
    }, {
      "id": 2342, "n": "永川区"
    }, {
      "id": 2343, "n": "南川区"
    }, {
      "id": 2344, "n": "璧山区"
    }, {
      "id": 2345, "n": "铜梁区"
    }, {
      "id": 2346, "n": "潼南县"
    }, {
      "id": 2347, "n": "荣昌县"
    }, {
      "id": 2348, "n": "梁平县"
    }, {
      "id": 2349, "n": "城口县"
    }, {
      "id": 2350, "n": "丰都县"
    }, {
      "id": 2351, "n": "垫江县"
    }, {
      "id": 2352, "n": "武隆县"
    }, {
      "id": 2353, "n": "忠县"
    }, {
      "id": 2354, "n": "开县"
    }, {
      "id": 2355, "n": "云阳县"
    }, {
      "id": 2356, "n": "奉节县"
    }, {
      "id": 2357, "n": "巫山县"
    }, {
      "id": 2358, "n": "巫溪县"
    }, {
      "id": 2359, "n": "石柱土家族自治县"
    }, {
      "id": 2360, "n": "秀山土家族苗族自治县"
    }, {
      "id": 2361, "n": "酉阳土家族苗族自治县"
    }, {
      "id": 2362, "n": "彭水苗族土家族自治县"
    }]
  }, {
    "id": 2363, "n": "两江新区", "c": [{
      "id": 2364, "n": "北部新区"
    }, {
      "id": 2365, "n": "保税港区"
    }, {
      "id": 2366, "n": "工业园区"
    }]
  }]
}, {
  "id": 2367, "n": "四川省", "c": [{
    "id": 2368, "n": "成都市", "c": [{
      "id": 2369, "n": "锦江区"
    }, {
      "id": 2370, "n": "青羊区"
    }, {
      "id": 2371, "n": "金牛区"
    }, {
      "id": 2372, "n": "武侯区"
    }, {
      "id": 2373, "n": "成华区"
    }, {
      "id": 2374, "n": "龙泉驿区"
    }, {
      "id": 2375, "n": "青白江区"
    }, {
      "id": 2376, "n": "新都区"
    }, {
      "id": 2377, "n": "温江区"
    }, {
      "id": 2378, "n": "金堂县"
    }, {
      "id": 2379, "n": "双流县"
    }, {
      "id": 2380, "n": "郫县"
    }, {
      "id": 2381, "n": "大邑县"
    }, {
      "id": 2382, "n": "蒲江县"
    }, {
      "id": 2383, "n": "新津县"
    }, {
      "id": 2384, "n": "都江堰市"
    }, {
      "id": 2385, "n": "彭州市"
    }, {
      "id": 2386, "n": "邛崃市"
    }, {
      "id": 2387, "n": "崇州市"
    }]
  }, {
    "id": 2388, "n": "自贡市", "c": [{
      "id": 2389, "n": "自流井区"
    }, {
      "id": 2390, "n": "贡井区"
    }, {
      "id": 2391, "n": "大安区"
    }, {
      "id": 2392, "n": "沿滩区"
    }, {
      "id": 2393, "n": "荣县"
    }, {
      "id": 2394, "n": "富顺县"
    }]
  }, {
    "id": 2395, "n": "攀枝花市", "c": [{
      "id": 2396, "n": "东区"
    }, {
      "id": 2397, "n": "西区"
    }, {
      "id": 2398, "n": "仁和区"
    }, {
      "id": 2399, "n": "米易县"
    }, {
      "id": 2400, "n": "盐边县"
    }]
  }, {
    "id": 2401, "n": "泸州市", "c": [{
      "id": 2402, "n": "江阳区"
    }, {
      "id": 2403, "n": "纳溪区"
    }, {
      "id": 2404, "n": "龙马潭区"
    }, {
      "id": 2405, "n": "泸县"
    }, {
      "id": 2406, "n": "合江县"
    }, {
      "id": 2407, "n": "叙永县"
    }, {
      "id": 2408, "n": "古蔺县"
    }]
  }, {
    "id": 2409, "n": "德阳市", "c": [{
      "id": 2410, "n": "旌阳区"
    }, {
      "id": 2411, "n": "中江县"
    }, {
      "id": 2412, "n": "罗江县"
    }, {
      "id": 2413, "n": "广汉市"
    }, {
      "id": 2414, "n": "什邡市"
    }, {
      "id": 2415, "n": "绵竹市"
    }]
  }, {
    "id": 2416, "n": "绵阳市", "c": [{
      "id": 2417, "n": "涪城区"
    }, {
      "id": 2418, "n": "游仙区"
    }, {
      "id": 2419, "n": "三台县"
    }, {
      "id": 2420, "n": "盐亭县"
    }, {
      "id": 2421, "n": "安县"
    }, {
      "id": 2422, "n": "梓潼县"
    }, {
      "id": 2423, "n": "北川羌族自治县"
    }, {
      "id": 2424, "n": "平武县"
    }, {
      "id": 2425, "n": "江油市"
    }]
  }, {
    "id": 2426, "n": "广元市", "c": [{
      "id": 2427, "n": "利州区"
    }, {
      "id": 2428, "n": "昭化区"
    }, {
      "id": 2429, "n": "朝天区"
    }, {
      "id": 2430, "n": "旺苍县"
    }, {
      "id": 2431, "n": "青川县"
    }, {
      "id": 2432, "n": "剑阁县"
    }, {
      "id": 2433, "n": "苍溪县"
    }]
  }, {
    "id": 2434, "n": "遂宁市", "c": [{
      "id": 2435, "n": "船山区"
    }, {
      "id": 2436, "n": "安居区"
    }, {
      "id": 2437, "n": "蓬溪县"
    }, {
      "id": 2438, "n": "射洪县"
    }, {
      "id": 2439, "n": "大英县"
    }]
  }, {
    "id": 2440, "n": "内江市", "c": [{
      "id": 2441, "n": "市中区"
    }, {
      "id": 2442, "n": "东兴区"
    }, {
      "id": 2443, "n": "威远县"
    }, {
      "id": 2444, "n": "资中县"
    }, {
      "id": 2445, "n": "隆昌县"
    }]
  }, {
    "id": 2446, "n": "乐山市", "c": [{
      "id": 2447, "n": "市中区"
    }, {
      "id": 2448, "n": "沙湾区"
    }, {
      "id": 2449, "n": "五通桥区"
    }, {
      "id": 2450, "n": "金口河区"
    }, {
      "id": 2451, "n": "犍为县"
    }, {
      "id": 2452, "n": "井研县"
    }, {
      "id": 2453, "n": "夹江县"
    }, {
      "id": 2454, "n": "沐川县"
    }, {
      "id": 2455, "n": "峨边彝族自治县"
    }, {
      "id": 2456, "n": "马边彝族自治县"
    }, {
      "id": 2457, "n": "峨眉山市"
    }]
  }, {
    "id": 2458, "n": "南充市", "c": [{
      "id": 2459, "n": "顺庆区"
    }, {
      "id": 2460, "n": "高坪区"
    }, {
      "id": 2461, "n": "嘉陵区"
    }, {
      "id": 2462, "n": "南部县"
    }, {
      "id": 2463, "n": "营山县"
    }, {
      "id": 2464, "n": "蓬安县"
    }, {
      "id": 2465, "n": "仪陇县"
    }, {
      "id": 2466, "n": "西充县"
    }, {
      "id": 2467, "n": "阆中市"
    }]
  }, {
    "id": 2468, "n": "眉山市", "c": [{
      "id": 2469, "n": "东坡区"
    }, {
      "id": 2470, "n": "彭山区"
    }, {
      "id": 2471, "n": "仁寿县"
    }, {
      "id": 2472, "n": "洪雅县"
    }, {
      "id": 2473, "n": "丹棱县"
    }, {
      "id": 2474, "n": "青神县"
    }]
  }, {
    "id": 2475, "n": "宜宾市", "c": [{
      "id": 2476, "n": "翠屏区"
    }, {
      "id": 2477, "n": "南溪区"
    }, {
      "id": 2478, "n": "宜宾县"
    }, {
      "id": 2479, "n": "江安县"
    }, {
      "id": 2480, "n": "长宁县"
    }, {
      "id": 2481, "n": "高县"
    }, {
      "id": 2482, "n": "珙县"
    }, {
      "id": 2483, "n": "筠连县"
    }, {
      "id": 2484, "n": "兴文县"
    }, {
      "id": 2485, "n": "屏山县"
    }]
  }, {
    "id": 2486, "n": "广安市", "c": [{
      "id": 2487, "n": "广安区"
    }, {
      "id": 2488, "n": "前锋区"
    }, {
      "id": 2489, "n": "岳池县"
    }, {
      "id": 2490, "n": "武胜县"
    }, {
      "id": 2491, "n": "邻水县"
    }, {
      "id": 2492, "n": "华蓥市"
    }]
  }, {
    "id": 2493, "n": "达州市", "c": [{
      "id": 2494, "n": "通川区"
    }, {
      "id": 2495, "n": "达川区"
    }, {
      "id": 2496, "n": "宣汉县"
    }, {
      "id": 2497, "n": "开江县"
    }, {
      "id": 2498, "n": "大竹县"
    }, {
      "id": 2499, "n": "渠县"
    }, {
      "id": 2500, "n": "万源市"
    }]
  }, {
    "id": 2501, "n": "雅安市", "c": [{
      "id": 2502, "n": "雨城区"
    }, {
      "id": 2503, "n": "名山区"
    }, {
      "id": 2504, "n": "荥经县"
    }, {
      "id": 2505, "n": "汉源县"
    }, {
      "id": 2506, "n": "石棉县"
    }, {
      "id": 2507, "n": "天全县"
    }, {
      "id": 2508, "n": "芦山县"
    }, {
      "id": 2509, "n": "宝兴县"
    }]
  }, {
    "id": 2510, "n": "巴中市", "c": [{
      "id": 2511, "n": "巴州区"
    }, {
      "id": 2512, "n": "恩阳区"
    }, {
      "id": 2513, "n": "通江县"
    }, {
      "id": 2514, "n": "南江县"
    }, {
      "id": 2515, "n": "平昌县"
    }]
  }, {
    "id": 2516, "n": "资阳市", "c": [{
      "id": 2517, "n": "雁江区"
    }, {
      "id": 2518, "n": "安岳县"
    }, {
      "id": 2519, "n": "乐至县"
    }, {
      "id": 2520, "n": "简阳市"
    }]
  }, {
    "id": 2521, "n": "阿坝藏族羌族自治州", "c": [{
      "id": 2522, "n": "汶川县"
    }, {
      "id": 2523, "n": "理县"
    }, {
      "id": 2524, "n": "茂县"
    }, {
      "id": 2525, "n": "松潘县"
    }, {
      "id": 2526, "n": "九寨沟县"
    }, {
      "id": 2527, "n": "金川县"
    }, {
      "id": 2528, "n": "小金县"
    }, {
      "id": 2529, "n": "黑水县"
    }, {
      "id": 2530, "n": "马尔康县"
    }, {
      "id": 2531, "n": "壤塘县"
    }, {
      "id": 2532, "n": "阿坝县"
    }, {
      "id": 2533, "n": "若尔盖县"
    }, {
      "id": 2534, "n": "红原县"
    }]
  }, {
    "id": 2535, "n": "甘孜藏族自治州", "c": [{
      "id": 2536, "n": "康定县"
    }, {
      "id": 2537, "n": "泸定县"
    }, {
      "id": 2538, "n": "丹巴县"
    }, {
      "id": 2539, "n": "九龙县"
    }, {
      "id": 2540, "n": "雅江县"
    }, {
      "id": 2541, "n": "道孚县"
    }, {
      "id": 2542, "n": "炉霍县"
    }, {
      "id": 2543, "n": "甘孜县"
    }, {
      "id": 2544, "n": "新龙县"
    }, {
      "id": 2545, "n": "德格县"
    }, {
      "id": 2546, "n": "白玉县"
    }, {
      "id": 2547, "n": "石渠县"
    }, {
      "id": 2548, "n": "色达县"
    }, {
      "id": 2549, "n": "理塘县"
    }, {
      "id": 2550, "n": "巴塘县"
    }, {
      "id": 2551, "n": "乡城县"
    }, {
      "id": 2552, "n": "稻城县"
    }, {
      "id": 2553, "n": "得荣县"
    }]
  }, {
    "id": 2554, "n": "凉山彝族自治州", "c": [{
      "id": 2555, "n": "西昌市"
    }, {
      "id": 2556, "n": "木里藏族自治县"
    }, {
      "id": 2557, "n": "盐源县"
    }, {
      "id": 2558, "n": "德昌县"
    }, {
      "id": 2559, "n": "会理县"
    }, {
      "id": 2560, "n": "会东县"
    }, {
      "id": 2561, "n": "宁南县"
    }, {
      "id": 2562, "n": "普格县"
    }, {
      "id": 2563, "n": "布拖县"
    }, {
      "id": 2564, "n": "金阳县"
    }, {
      "id": 2565, "n": "昭觉县"
    }, {
      "id": 2566, "n": "喜德县"
    }, {
      "id": 2567, "n": "冕宁县"
    }, {
      "id": 2568, "n": "越西县"
    }, {
      "id": 2569, "n": "甘洛县"
    }, {
      "id": 2570, "n": "美姑县"
    }, {
      "id": 2571, "n": "雷波县"
    }]
  }]
}, {
  "id": 2572, "n": "贵州省", "c": [{
    "id": 2573, "n": "贵阳市", "c": [{
      "id": 2574, "n": "南明区"
    }, {
      "id": 2575, "n": "云岩区"
    }, {
      "id": 2576, "n": "花溪区"
    }, {
      "id": 2577, "n": "乌当区"
    }, {
      "id": 2578, "n": "白云区"
    }, {
      "id": 2579, "n": "观山湖区"
    }, {
      "id": 2580, "n": "开阳县"
    }, {
      "id": 2581, "n": "息烽县"
    }, {
      "id": 2582, "n": "修文县"
    }, {
      "id": 2583, "n": "清镇市"
    }]
  }, {
    "id": 2584, "n": "六盘水市", "c": [{
      "id": 2585, "n": "钟山区"
    }, {
      "id": 2586, "n": "六枝特区"
    }, {
      "id": 2587, "n": "水城县"
    }, {
      "id": 2588, "n": "盘县"
    }]
  }, {
    "id": 2589, "n": "遵义市", "c": [{
      "id": 2590, "n": "红花岗区"
    }, {
      "id": 2591, "n": "汇川区"
    }, {
      "id": 2592, "n": "遵义县"
    }, {
      "id": 2593, "n": "桐梓县"
    }, {
      "id": 2594, "n": "绥阳县"
    }, {
      "id": 2595, "n": "正安县"
    }, {
      "id": 2596, "n": "道真仡佬族苗族自治县"
    }, {
      "id": 2597, "n": "务川仡佬族苗族自治县"
    }, {
      "id": 2598, "n": "凤冈县"
    }, {
      "id": 2599, "n": "湄潭县"
    }, {
      "id": 2600, "n": "余庆县"
    }, {
      "id": 2601, "n": "习水县"
    }, {
      "id": 2602, "n": "赤水市"
    }, {
      "id": 2603, "n": "仁怀市"
    }]
  }, {
    "id": 2604, "n": "安顺市", "c": [{
      "id": 2605, "n": "西秀区"
    }, {
      "id": 2606, "n": "平坝区"
    }, {
      "id": 2607, "n": "普定县"
    }, {
      "id": 2608, "n": "镇宁布依族苗族自治县"
    }, {
      "id": 2609, "n": "关岭布依族苗族自治县"
    }, {
      "id": 2610, "n": "紫云苗族布依族自治县"
    }]
  }, {
    "id": 2611, "n": "毕节市", "c": [{
      "id": 2612, "n": "七星关区"
    }, {
      "id": 2613, "n": "大方县"
    }, {
      "id": 2614, "n": "黔西县"
    }, {
      "id": 2615, "n": "金沙县"
    }, {
      "id": 2616, "n": "织金县"
    }, {
      "id": 2617, "n": "纳雍县"
    }, {
      "id": 2618, "n": "威宁彝族回族苗族自治县"
    }, {
      "id": 2619, "n": "赫章县"
    }]
  }, {
    "id": 2620, "n": "铜仁市", "c": [{
      "id": 2621, "n": "碧江区"
    }, {
      "id": 2622, "n": "万山区"
    }, {
      "id": 2623, "n": "江口县"
    }, {
      "id": 2624, "n": "玉屏侗族自治县"
    }, {
      "id": 2625, "n": "石阡县"
    }, {
      "id": 2626, "n": "思南县"
    }, {
      "id": 2627, "n": "印江土家族苗族自治县"
    }, {
      "id": 2628, "n": "德江县"
    }, {
      "id": 2629, "n": "沿河土家族自治县"
    }, {
      "id": 2630, "n": "松桃苗族自治县"
    }]
  }, {
    "id": 2631, "n": "黔西南布依族苗族自治州", "c": [{
      "id": 2632, "n": "兴义市 "
    }, {
      "id": 2633, "n": "兴仁县"
    }, {
      "id": 2634, "n": "普安县"
    }, {
      "id": 2635, "n": "晴隆县"
    }, {
      "id": 2636, "n": "贞丰县"
    }, {
      "id": 2637, "n": "望谟县"
    }, {
      "id": 2638, "n": "册亨县"
    }, {
      "id": 2639, "n": "安龙县"
    }]
  }, {
    "id": 2640, "n": "黔东南苗族侗族自治州", "c": [{
      "id": 2641, "n": "凯里市"
    }, {
      "id": 2642, "n": "黄平县"
    }, {
      "id": 2643, "n": "施秉县"
    }, {
      "id": 2644, "n": "三穗县"
    }, {
      "id": 2645, "n": "镇远县"
    }, {
      "id": 2646, "n": "岑巩县"
    }, {
      "id": 2647, "n": "天柱县"
    }, {
      "id": 2648, "n": "锦屏县"
    }, {
      "id": 2649, "n": "剑河县"
    }, {
      "id": 2650, "n": "台江县"
    }, {
      "id": 2651, "n": "黎平县"
    }, {
      "id": 2652, "n": "榕江县"
    }, {
      "id": 2653, "n": "从江县"
    }, {
      "id": 2654, "n": "雷山县"
    }, {
      "id": 2655, "n": "麻江县"
    }, {
      "id": 2656, "n": "丹寨县"
    }]
  }, {
    "id": 2657, "n": "黔南布依族苗族自治州", "c": [{
      "id": 2658, "n": "都匀市"
    }, {
      "id": 2659, "n": "福泉市"
    }, {
      "id": 2660, "n": "荔波县"
    }, {
      "id": 2661, "n": "贵定县"
    }, {
      "id": 2662, "n": "瓮安县"
    }, {
      "id": 2663, "n": "独山县"
    }, {
      "id": 2664, "n": "平塘县"
    }, {
      "id": 2665, "n": "罗甸县"
    }, {
      "id": 2666, "n": "长顺县"
    }, {
      "id": 2667, "n": "龙里县"
    }, {
      "id": 2668, "n": "惠水县"
    }, {
      "id": 2669, "n": "三都水族自治县"
    }]
  }]
}, {
  "id": 2670, "n": "云南省", "c": [{
    "id": 2671, "n": "昆明市", "c": [{
      "id": 2672, "n": "五华区"
    }, {
      "id": 2673, "n": "盘龙区"
    }, {
      "id": 2674, "n": "官渡区"
    }, {
      "id": 2675, "n": "西山区"
    }, {
      "id": 2676, "n": "东川区"
    }, {
      "id": 2677, "n": "呈贡区"
    }, {
      "id": 2678, "n": "晋宁县"
    }, {
      "id": 2679, "n": "富民县"
    }, {
      "id": 2680, "n": "宜良县"
    }, {
      "id": 2681, "n": "石林彝族自治县"
    }, {
      "id": 2682, "n": "嵩明县"
    }, {
      "id": 2683, "n": "禄劝彝族苗族自治县"
    }, {
      "id": 2684, "n": "寻甸回族彝族自治县 "
    }, {
      "id": 2685, "n": "安宁市"
    }]
  }, {
    "id": 2686, "n": "曲靖市", "c": [{
      "id": 2687, "n": "麒麟区"
    }, {
      "id": 2688, "n": "马龙县"
    }, {
      "id": 2689, "n": "陆良县"
    }, {
      "id": 2690, "n": "师宗县"
    }, {
      "id": 2691, "n": "罗平县"
    }, {
      "id": 2692, "n": "富源县"
    }, {
      "id": 2693, "n": "会泽县"
    }, {
      "id": 2694, "n": "沾益县"
    }, {
      "id": 2695, "n": "宣威市"
    }]
  }, {
    "id": 2696, "n": "玉溪市", "c": [{
      "id": 2697, "n": "红塔区"
    }, {
      "id": 2698, "n": "江川县"
    }, {
      "id": 2699, "n": "澄江县"
    }, {
      "id": 2700, "n": "通海县"
    }, {
      "id": 2701, "n": "华宁县"
    }, {
      "id": 2702, "n": "易门县"
    }, {
      "id": 2703, "n": "峨山彝族自治县"
    }, {
      "id": 2704, "n": "新平彝族傣族自治县"
    }, {
      "id": 2705, "n": "元江哈尼族彝族傣族自治县"
    }]
  }, {
    "id": 2706, "n": "保山市", "c": [{
      "id": 2707, "n": "隆阳区"
    }, {
      "id": 2708, "n": "施甸县"
    }, {
      "id": 2709, "n": "腾冲县"
    }, {
      "id": 2710, "n": "龙陵县"
    }, {
      "id": 2711, "n": "昌宁县"
    }]
  }, {
    "id": 2712, "n": "昭通市", "c": [{
      "id": 2713, "n": "昭阳区"
    }, {
      "id": 2714, "n": "鲁甸县"
    }, {
      "id": 2715, "n": "巧家县"
    }, {
      "id": 2716, "n": "盐津县"
    }, {
      "id": 2717, "n": "大关县"
    }, {
      "id": 2718, "n": "永善县"
    }, {
      "id": 2719, "n": "绥江县"
    }, {
      "id": 2720, "n": "镇雄县"
    }, {
      "id": 2721, "n": "彝良县"
    }, {
      "id": 2722, "n": "威信县"
    }, {
      "id": 2723, "n": "水富县"
    }]
  }, {
    "id": 2724, "n": "丽江市", "c": [{
      "id": 2725, "n": "古城区"
    }, {
      "id": 2726, "n": "玉龙纳西族自治县"
    }, {
      "id": 2727, "n": "永胜县"
    }, {
      "id": 2728, "n": "华坪县"
    }, {
      "id": 2729, "n": "宁蒗彝族自治县"
    }]
  }, {
    "id": 2730, "n": "普洱市", "c": [{
      "id": 2731, "n": "思茅区"
    }, {
      "id": 2732, "n": "宁洱哈尼族彝族自治县"
    }, {
      "id": 2733, "n": "墨江哈尼族自治县"
    }, {
      "id": 2734, "n": "景东彝族自治县"
    }, {
      "id": 2735, "n": "景谷傣族彝族自治县"
    }, {
      "id": 2736, "n": "镇沅彝族哈尼族拉祜族自治县"
    }, {
      "id": 2737, "n": "江城哈尼族彝族自治县"
    }, {
      "id": 2738, "n": "孟连傣族拉祜族佤族自治县"
    }, {
      "id": 2739, "n": "澜沧拉祜族自治县"
    }, {
      "id": 2740, "n": "西盟佤族自治县"
    }]
  }, {
    "id": 2741, "n": "临沧市", "c": [{
      "id": 2742, "n": "临翔区"
    }, {
      "id": 2743, "n": "凤庆县"
    }, {
      "id": 2744, "n": "云县"
    }, {
      "id": 2745, "n": "永德县"
    }, {
      "id": 2746, "n": "镇康县"
    }, {
      "id": 2747, "n": "双江拉祜族佤族布朗族傣族自治县"
    }, {
      "id": 2748, "n": "耿马傣族佤族自治县"
    }, {
      "id": 2749, "n": "沧源佤族自治县"
    }]
  }, {
    "id": 2750, "n": "楚雄彝族自治州", "c": [{
      "id": 2751, "n": "楚雄市"
    }, {
      "id": 2752, "n": "双柏县"
    }, {
      "id": 2753, "n": "牟定县"
    }, {
      "id": 2754, "n": "南华县"
    }, {
      "id": 2755, "n": "姚安县"
    }, {
      "id": 2756, "n": "大姚县"
    }, {
      "id": 2757, "n": "永仁县"
    }, {
      "id": 2758, "n": "元谋县"
    }, {
      "id": 2759, "n": "武定县"
    }, {
      "id": 2760, "n": "禄丰县"
    }]
  }, {
    "id": 2761, "n": "红河哈尼族彝族自治州", "c": [{
      "id": 2762, "n": "个旧市"
    }, {
      "id": 2763, "n": "开远市"
    }, {
      "id": 2764, "n": "蒙自市"
    }, {
      "id": 2765, "n": "弥勒市"
    }, {
      "id": 2766, "n": "屏边苗族自治县"
    }, {
      "id": 2767, "n": "建水县"
    }, {
      "id": 2768, "n": "石屏县"
    }, {
      "id": 2769, "n": "泸西县"
    }, {
      "id": 2770, "n": "元阳县"
    }, {
      "id": 2771, "n": "红河县"
    }, {
      "id": 2772, "n": "金平苗族瑶族傣族自治县"
    }, {
      "id": 2773, "n": "绿春县"
    }, {
      "id": 2774, "n": "河口瑶族自治县"
    }]
  }, {
    "id": 2775, "n": "文山壮族苗族自治州", "c": [{
      "id": 2776, "n": "文山市"
    }, {
      "id": 2777, "n": "砚山县"
    }, {
      "id": 2778, "n": "西畴县"
    }, {
      "id": 2779, "n": "麻栗坡县"
    }, {
      "id": 2780, "n": "马关县"
    }, {
      "id": 2781, "n": "丘北县"
    }, {
      "id": 2782, "n": "广南县"
    }, {
      "id": 2783, "n": "富宁县"
    }]
  }, {
    "id": 2784, "n": "西双版纳傣族自治州", "c": [{
      "id": 2785, "n": "景洪市"
    }, {
      "id": 2786, "n": "勐海县"
    }, {
      "id": 2787, "n": "勐腊县"
    }]
  }, {
    "id": 2788, "n": "大理白族自治州", "c": [{
      "id": 2789, "n": "大理市"
    }, {
      "id": 2790, "n": "漾濞彝族自治县"
    }, {
      "id": 2791, "n": "祥云县"
    }, {
      "id": 2792, "n": "宾川县"
    }, {
      "id": 2793, "n": "弥渡县"
    }, {
      "id": 2794, "n": "南涧彝族自治县"
    }, {
      "id": 2795, "n": "巍山彝族回族自治县"
    }, {
      "id": 2796, "n": "永平县"
    }, {
      "id": 2797, "n": "云龙县"
    }, {
      "id": 2798, "n": "洱源县"
    }, {
      "id": 2799, "n": "剑川县"
    }, {
      "id": 2800, "n": "鹤庆县"
    }]
  }, {
    "id": 2801, "n": "德宏傣族景颇族自治州", "c": [{
      "id": 2802, "n": "瑞丽市"
    }, {
      "id": 2803, "n": "芒市"
    }, {
      "id": 2804, "n": "梁河县"
    }, {
      "id": 2805, "n": "盈江县"
    }, {
      "id": 2806, "n": "陇川县"
    }]
  }, {
    "id": 2807, "n": "怒江傈僳族自治州", "c": [{
      "id": 2808, "n": "泸水县"
    }, {
      "id": 2809, "n": "福贡县"
    }, {
      "id": 2810, "n": "贡山独龙族怒族自治县"
    }, {
      "id": 2811, "n": "兰坪白族普米族自治县"
    }]
  }, {
    "id": 2812, "n": "迪庆藏族自治州", "c": [{
      "id": 2813, "n": "香格里拉市"
    }, {
      "id": 2814, "n": "德钦县"
    }, {
      "id": 2815, "n": "维西傈僳族自治县"
    }]
  }]
}, {
  "id": 2816, "n": "西藏自治区", "c": [{
    "id": 2817, "n": "拉萨市", "c": [{
      "id": 2818, "n": "城关区"
    }, {
      "id": 2819, "n": "林周县"
    }, {
      "id": 2820, "n": "当雄县"
    }, {
      "id": 2821, "n": "尼木县"
    }, {
      "id": 2822, "n": "曲水县"
    }, {
      "id": 2823, "n": "堆龙德庆县"
    }, {
      "id": 2824, "n": "达孜县"
    }, {
      "id": 2825, "n": "墨竹工卡县"
    }]
  }, {
    "id": 2826, "n": "日喀则市", "c": [{
      "id": 2827, "n": "桑珠孜区"
    }, {
      "id": 2828, "n": "南木林县"
    }, {
      "id": 2829, "n": "江孜县"
    }, {
      "id": 2830, "n": "定日县"
    }, {
      "id": 2831, "n": "萨迦县"
    }, {
      "id": 2832, "n": "拉孜县"
    }, {
      "id": 2833, "n": "昂仁县"
    }, {
      "id": 2834, "n": "谢通门县"
    }, {
      "id": 2835, "n": "白朗县"
    }, {
      "id": 2836, "n": "仁布县"
    }, {
      "id": 2837, "n": "康马县"
    }, {
      "id": 2838, "n": "定结县"
    }, {
      "id": 2839, "n": "仲巴县"
    }, {
      "id": 2840, "n": "亚东县"
    }, {
      "id": 2841, "n": "吉隆县"
    }, {
      "id": 2842, "n": "聂拉木县"
    }, {
      "id": 2843, "n": "萨嘎县"
    }, {
      "id": 2844, "n": "岗巴县"
    }]
  }, {
    "id": 2845, "n": "昌都市", "c": [{
      "id": 2846, "n": "卡若区"
    }, {
      "id": 2847, "n": "江达县"
    }, {
      "id": 2848, "n": "贡觉县"
    }, {
      "id": 2849, "n": "类乌齐县"
    }, {
      "id": 2850, "n": "丁青县"
    }, {
      "id": 2851, "n": "察雅县"
    }, {
      "id": 2852, "n": "八宿县"
    }, {
      "id": 2853, "n": "左贡县"
    }, {
      "id": 2854, "n": "芒康县"
    }, {
      "id": 2855, "n": "洛隆县"
    }, {
      "id": 2856, "n": "边坝县"
    }]
  }, {
    "id": 2857, "n": "山南地区", "c": [{
      "id": 2858, "n": "乃东县"
    }, {
      "id": 2859, "n": "扎囊县"
    }, {
      "id": 2860, "n": "贡嘎县"
    }, {
      "id": 2861, "n": "桑日县"
    }, {
      "id": 2862, "n": "琼结县"
    }, {
      "id": 2863, "n": "曲松县"
    }, {
      "id": 2864, "n": "措美县"
    }, {
      "id": 2865, "n": "洛扎县"
    }, {
      "id": 2866, "n": "加查县"
    }, {
      "id": 2867, "n": "隆子县"
    }, {
      "id": 2868, "n": "错那县"
    }, {
      "id": 2869, "n": "浪卡子县"
    }]
  }, {
    "id": 2870, "n": "那曲地区", "c": [{
      "id": 2871, "n": "那曲县"
    }, {
      "id": 2872, "n": "嘉黎县"
    }, {
      "id": 2873, "n": "比如县"
    }, {
      "id": 2874, "n": "聂荣县"
    }, {
      "id": 2875, "n": "安多县"
    }, {
      "id": 2876, "n": "申扎县"
    }, {
      "id": 2877, "n": "索县"
    }, {
      "id": 2878, "n": "班戈县"
    }, {
      "id": 2879, "n": "巴青县"
    }, {
      "id": 2880, "n": "尼玛县"
    }, {
      "id": 2881, "n": "双湖县"
    }]
  }, {
    "id": 2882, "n": "阿里地区", "c": [{
      "id": 2883, "n": "普兰县"
    }, {
      "id": 2884, "n": "札达县"
    }, {
      "id": 2885, "n": "噶尔县"
    }, {
      "id": 2886, "n": "日土县"
    }, {
      "id": 2887, "n": "革吉县"
    }, {
      "id": 2888, "n": "改则县"
    }, {
      "id": 2889, "n": "措勤县"
    }]
  }, {
    "id": 2890, "n": "林芝地区", "c": [{
      "id": 2891, "n": "林芝县"
    }, {
      "id": 2892, "n": "工布江达县"
    }, {
      "id": 2893, "n": "米林县"
    }, {
      "id": 2894, "n": "墨脱县"
    }, {
      "id": 2895, "n": "波密县"
    }, {
      "id": 2896, "n": "察隅县"
    }, {
      "id": 2897, "n": "朗县"
    }]
  }]
}, {
  "id": 2898, "n": "陕西省", "c": [{
    "id": 2899, "n": "西安市", "c": [{
      "id": 2900, "n": "新城区"
    }, {
      "id": 2901, "n": "碑林区"
    }, {
      "id": 2902, "n": "莲湖区"
    }, {
      "id": 2903, "n": "灞桥区"
    }, {
      "id": 2904, "n": "未央区"
    }, {
      "id": 2905, "n": "雁塔区"
    }, {
      "id": 2906, "n": "阎良区"
    }, {
      "id": 2907, "n": "临潼区"
    }, {
      "id": 2908, "n": "长安区"
    }, {
      "id": 2909, "n": "蓝田县"
    }, {
      "id": 2910, "n": "周至县"
    }, {
      "id": 2911, "n": "户县"
    }, {
      "id": 2912, "n": "高陵区"
    }]
  }, {
    "id": 2913, "n": "铜川市", "c": [{
      "id": 2914, "n": "王益区"
    }, {
      "id": 2915, "n": "印台区"
    }, {
      "id": 2916, "n": "耀州区"
    }, {
      "id": 2917, "n": "宜君县"
    }]
  }, {
    "id": 2918, "n": "宝鸡市", "c": [{
      "id": 2919, "n": "渭滨区"
    }, {
      "id": 2920, "n": "金台区"
    }, {
      "id": 2921, "n": "陈仓区"
    }, {
      "id": 2922, "n": "凤翔县"
    }, {
      "id": 2923, "n": "岐山县"
    }, {
      "id": 2924, "n": "扶风县"
    }, {
      "id": 2925, "n": "眉县"
    }, {
      "id": 2926, "n": "陇县"
    }, {
      "id": 2927, "n": "千阳县"
    }, {
      "id": 2928, "n": "麟游县"
    }, {
      "id": 2929, "n": "凤县"
    }, {
      "id": 2930, "n": "太白县"
    }]
  }, {
    "id": 2931, "n": "咸阳市", "c": [{
      "id": 2932, "n": "秦都区"
    }, {
      "id": 2933, "n": "杨陵区"
    }, {
      "id": 2934, "n": "渭城区"
    }, {
      "id": 2935, "n": "三原县"
    }, {
      "id": 2936, "n": "泾阳县"
    }, {
      "id": 2937, "n": "乾县"
    }, {
      "id": 2938, "n": "礼泉县"
    }, {
      "id": 2939, "n": "永寿县"
    }, {
      "id": 2940, "n": "彬县"
    }, {
      "id": 2941, "n": "长武县"
    }, {
      "id": 2942, "n": "旬邑县"
    }, {
      "id": 2943, "n": "淳化县"
    }, {
      "id": 2944, "n": "武功县"
    }, {
      "id": 2945, "n": "兴平市"
    }]
  }, {
    "id": 2946, "n": "渭南市", "c": [{
      "id": 2947, "n": "临渭区"
    }, {
      "id": 2948, "n": "华县"
    }, {
      "id": 2949, "n": "潼关县"
    }, {
      "id": 2950, "n": "大荔县"
    }, {
      "id": 2951, "n": "合阳县"
    }, {
      "id": 2952, "n": "澄城县"
    }, {
      "id": 2953, "n": "蒲城县"
    }, {
      "id": 2954, "n": "白水县"
    }, {
      "id": 2955, "n": "富平县"
    }, {
      "id": 2956, "n": "韩城市"
    }, {
      "id": 2957, "n": "华阴市"
    }]
  }, {
    "id": 2958, "n": "延安市", "c": [{
      "id": 2959, "n": "宝塔区"
    }, {
      "id": 2960, "n": "延长县"
    }, {
      "id": 2961, "n": "延川县"
    }, {
      "id": 2962, "n": "子长县"
    }, {
      "id": 2963, "n": "安塞县"
    }, {
      "id": 2964, "n": "志丹县"
    }, {
      "id": 2965, "n": "吴起县"
    }, {
      "id": 2966, "n": "甘泉县"
    }, {
      "id": 2967, "n": "富县"
    }, {
      "id": 2968, "n": "洛川县"
    }, {
      "id": 2969, "n": "宜川县"
    }, {
      "id": 2970, "n": "黄龙县"
    }, {
      "id": 2971, "n": "黄陵县"
    }]
  }, {
    "id": 2972, "n": "汉中市", "c": [{
      "id": 2973, "n": "汉台区"
    }, {
      "id": 2974, "n": "南郑县"
    }, {
      "id": 2975, "n": "城固县"
    }, {
      "id": 2976, "n": "洋县"
    }, {
      "id": 2977, "n": "西乡县"
    }, {
      "id": 2978, "n": "勉县"
    }, {
      "id": 2979, "n": "宁强县"
    }, {
      "id": 2980, "n": "略阳县"
    }, {
      "id": 2981, "n": "镇巴县"
    }, {
      "id": 2982, "n": "留坝县"
    }, {
      "id": 2983, "n": "佛坪县"
    }]
  }, {
    "id": 2984, "n": "榆林市", "c": [{
      "id": 2985, "n": "榆阳区"
    }, {
      "id": 2986, "n": "神木县"
    }, {
      "id": 2987, "n": "府谷县"
    }, {
      "id": 2988, "n": "横山县"
    }, {
      "id": 2989, "n": "靖边县"
    }, {
      "id": 2990, "n": "定边县"
    }, {
      "id": 2991, "n": "绥德县"
    }, {
      "id": 2992, "n": "米脂县"
    }, {
      "id": 2993, "n": "佳县"
    }, {
      "id": 2994, "n": "吴堡县"
    }, {
      "id": 2995, "n": "清涧县"
    }, {
      "id": 2996, "n": "子洲县"
    }]
  }, {
    "id": 2997, "n": "安康市", "c": [{
      "id": 2998, "n": "汉滨区"
    }, {
      "id": 2999, "n": "汉阴县"
    }, {
      "id": 3000, "n": "石泉县"
    }, {
      "id": 3001, "n": "宁陕县"
    }, {
      "id": 3002, "n": "紫阳县"
    }, {
      "id": 3003, "n": "岚皋县"
    }, {
      "id": 3004, "n": "平利县"
    }, {
      "id": 3005, "n": "镇坪县"
    }, {
      "id": 3006, "n": "旬阳县"
    }, {
      "id": 3007, "n": "白河县"
    }]
  }, {
    "id": 3008, "n": "商洛市", "c": [{
      "id": 3009, "n": "商州区"
    }, {
      "id": 3010, "n": "洛南县"
    }, {
      "id": 3011, "n": "丹凤县"
    }, {
      "id": 3012, "n": "商南县"
    }, {
      "id": 3013, "n": "山阳县"
    }, {
      "id": 3014, "n": "镇安县"
    }, {
      "id": 3015, "n": "柞水县"
    }]
  }, {
    "id": 3016, "n": "西咸新区", "c": [{
      "id": 3017, "n": "空港新城"
    }, {
      "id": 3018, "n": "沣东新城"
    }, {
      "id": 3019, "n": "秦汉新城"
    }, {
      "id": 3020, "n": "沣西新城"
    }, {
      "id": 3021, "n": "泾河新城"
    }]
  }]
}, {
  "id": 3022, "n": "甘肃省", "c": [{
    "id": 3023, "n": "兰州市", "c": [{
      "id": 3024, "n": "城关区"
    }, {
      "id": 3025, "n": "七里河区"
    }, {
      "id": 3026, "n": "西固区"
    }, {
      "id": 3027, "n": "安宁区"
    }, {
      "id": 3028, "n": "红古区"
    }, {
      "id": 3029, "n": "永登县"
    }, {
      "id": 3030, "n": "皋兰县"
    }, {
      "id": 3031, "n": "榆中县"
    }]
  }, {
    "id": 3032, "n": "嘉峪关市", "c": [{
      "id": 3033, "n": "雄关区"
    }, {
      "id": 3034, "n": "长城区"
    }, {
      "id": 3035, "n": "镜铁区"
    }]
  }, {
    "id": 3036, "n": "金昌市", "c": [{
      "id": 3037, "n": "金川区"
    }, {
      "id": 3038, "n": "永昌县"
    }]
  }, {
    "id": 3039, "n": "白银市", "c": [{
      "id": 3040, "n": "白银区"
    }, {
      "id": 3041, "n": "平川区"
    }, {
      "id": 3042, "n": "靖远县"
    }, {
      "id": 3043, "n": "会宁县"
    }, {
      "id": 3044, "n": "景泰县"
    }]
  }, {
    "id": 3045, "n": "天水市", "c": [{
      "id": 3046, "n": "秦州区"
    }, {
      "id": 3047, "n": "麦积区"
    }, {
      "id": 3048, "n": "清水县"
    }, {
      "id": 3049, "n": "秦安县"
    }, {
      "id": 3050, "n": "甘谷县"
    }, {
      "id": 3051, "n": "武山县"
    }, {
      "id": 3052, "n": "张家川回族自治县"
    }]
  }, {
    "id": 3053, "n": "武威市", "c": [{
      "id": 3054, "n": "凉州区"
    }, {
      "id": 3055, "n": "民勤县"
    }, {
      "id": 3056, "n": "古浪县"
    }, {
      "id": 3057, "n": "天祝藏族自治县"
    }]
  }, {
    "id": 3058, "n": "张掖市", "c": [{
      "id": 3059, "n": "甘州区"
    }, {
      "id": 3060, "n": "肃南裕固族自治县"
    }, {
      "id": 3061, "n": "民乐县"
    }, {
      "id": 3062, "n": "临泽县"
    }, {
      "id": 3063, "n": "高台县"
    }, {
      "id": 3064, "n": "山丹县"
    }]
  }, {
    "id": 3065, "n": "平凉市", "c": [{
      "id": 3066, "n": "崆峒区"
    }, {
      "id": 3067, "n": "泾川县"
    }, {
      "id": 3068, "n": "灵台县"
    }, {
      "id": 3069, "n": "崇信县"
    }, {
      "id": 3070, "n": "华亭县"
    }, {
      "id": 3071, "n": "庄浪县"
    }, {
      "id": 3072, "n": "静宁县"
    }]
  }, {
    "id": 3073, "n": "酒泉市", "c": [{
      "id": 3074, "n": "肃州区"
    }, {
      "id": 3075, "n": "金塔县"
    }, {
      "id": 3076, "n": "瓜州县"
    }, {
      "id": 3077, "n": "肃北蒙古族自治县"
    }, {
      "id": 3078, "n": "阿克塞哈萨克族自治县"
    }, {
      "id": 3079, "n": "玉门市"
    }, {
      "id": 3080, "n": "敦煌市"
    }]
  }, {
    "id": 3081, "n": "庆阳市", "c": [{
      "id": 3082, "n": "西峰区"
    }, {
      "id": 3083, "n": "庆城县"
    }, {
      "id": 3084, "n": "环县"
    }, {
      "id": 3085, "n": "华池县"
    }, {
      "id": 3086, "n": "合水县"
    }, {
      "id": 3087, "n": "正宁县"
    }, {
      "id": 3088, "n": "宁县"
    }, {
      "id": 3089, "n": "镇原县"
    }]
  }, {
    "id": 3090, "n": "定西市", "c": [{
      "id": 3091, "n": "安定区"
    }, {
      "id": 3092, "n": "通渭县"
    }, {
      "id": 3093, "n": "陇西县"
    }, {
      "id": 3094, "n": "渭源县"
    }, {
      "id": 3095, "n": "临洮县"
    }, {
      "id": 3096, "n": "漳县"
    }, {
      "id": 3097, "n": "岷县"
    }]
  }, {
    "id": 3098, "n": "陇南市", "c": [{
      "id": 3099, "n": "武都区"
    }, {
      "id": 3100, "n": "成县"
    }, {
      "id": 3101, "n": "文县"
    }, {
      "id": 3102, "n": "宕昌县"
    }, {
      "id": 3103, "n": "康县"
    }, {
      "id": 3104, "n": "西和县"
    }, {
      "id": 3105, "n": "礼县"
    }, {
      "id": 3106, "n": "徽县"
    }, {
      "id": 3107, "n": "两当县"
    }]
  }, {
    "id": 3108, "n": "临夏回族自治州", "c": [{
      "id": 3109, "n": "临夏市"
    }, {
      "id": 3110, "n": "临夏县"
    }, {
      "id": 3111, "n": "康乐县"
    }, {
      "id": 3112, "n": "永靖县"
    }, {
      "id": 3113, "n": "广河县"
    }, {
      "id": 3114, "n": "和政县"
    }, {
      "id": 3115, "n": "东乡族自治县"
    }, {
      "id": 3116, "n": "积石山保安族东乡族撒拉族自治县"
    }]
  }, {
    "id": 3117, "n": "甘南藏族自治州", "c": [{
      "id": 3118, "n": "合作市"
    }, {
      "id": 3119, "n": "临潭县"
    }, {
      "id": 3120, "n": "卓尼县"
    }, {
      "id": 3121, "n": "舟曲县"
    }, {
      "id": 3122, "n": "迭部县"
    }, {
      "id": 3123, "n": "玛曲县"
    }, {
      "id": 3124, "n": "碌曲县"
    }, {
      "id": 3125, "n": "夏河县"
    }]
  }]
}, {
  "id": 3126, "n": "青海省", "c": [{
    "id": 3127, "n": "西宁市", "c": [{
      "id": 3128, "n": "城东区"
    }, {
      "id": 3129, "n": "城中区"
    }, {
      "id": 3130, "n": "城西区"
    }, {
      "id": 3131, "n": "城北区"
    }, {
      "id": 3132, "n": "大通回族土族自治县"
    }, {
      "id": 3133, "n": "湟中县"
    }, {
      "id": 3134, "n": "湟源县"
    }]
  }, {
    "id": 3135, "n": "海东市", "c": [{
      "id": 3136, "n": "乐都区"
    }, {
      "id": 3137, "n": "平安县"
    }, {
      "id": 3138, "n": "民和回族土族自治县"
    }, {
      "id": 3139, "n": "互助土族自治县"
    }, {
      "id": 3140, "n": "化隆回族自治县"
    }, {
      "id": 3141, "n": "循化撒拉族自治县"
    }]
  }, {
    "id": 3142, "n": "海北藏族自治州", "c": [{
      "id": 3143, "n": "门源回族自治县"
    }, {
      "id": 3144, "n": "祁连县"
    }, {
      "id": 3145, "n": "海晏县"
    }, {
      "id": 3146, "n": "刚察县"
    }]
  }, {
    "id": 3147, "n": "黄南藏族自治州", "c": [{
      "id": 3148, "n": "同仁县"
    }, {
      "id": 3149, "n": "尖扎县"
    }, {
      "id": 3150, "n": "泽库县"
    }, {
      "id": 3151, "n": "河南蒙古族自治县"
    }]
  }, {
    "id": 3152, "n": "海南藏族自治州", "c": [{
      "id": 3153, "n": "共和县"
    }, {
      "id": 3154, "n": "同德县"
    }, {
      "id": 3155, "n": "贵德县"
    }, {
      "id": 3156, "n": "兴海县"
    }, {
      "id": 3157, "n": "贵南县"
    }]
  }, {
    "id": 3158, "n": "果洛藏族自治州", "c": [{
      "id": 3159, "n": "玛沁县"
    }, {
      "id": 3160, "n": "班玛县"
    }, {
      "id": 3161, "n": "甘德县"
    }, {
      "id": 3162, "n": "达日县"
    }, {
      "id": 3163, "n": "久治县"
    }, {
      "id": 3164, "n": "玛多县"
    }]
  }, {
    "id": 3165, "n": "玉树藏族自治州", "c": [{
      "id": 3166, "n": "玉树市"
    }, {
      "id": 3167, "n": "杂多县"
    }, {
      "id": 3168, "n": "称多县"
    }, {
      "id": 3169, "n": "治多县"
    }, {
      "id": 3170, "n": "囊谦县"
    }, {
      "id": 3171, "n": "曲麻莱县"
    }]
  }, {
    "id": 3172, "n": "海西蒙古族藏族自治州", "c": [{
      "id": 3173, "n": "格尔木市"
    }, {
      "id": 3174, "n": "德令哈市"
    }, {
      "id": 3175, "n": "乌兰县"
    }, {
      "id": 3176, "n": "都兰县"
    }, {
      "id": 3177, "n": "天峻县"
    }]
  }]
}, {
  "id": 3178, "n": "宁夏回族自治区", "c": [{
    "id": 3179, "n": "银川市", "c": [{
      "id": 3180, "n": "兴庆区"
    }, {
      "id": 3181, "n": "西夏区"
    }, {
      "id": 3182, "n": "金凤区"
    }, {
      "id": 3183, "n": "永宁县"
    }, {
      "id": 3184, "n": "贺兰县"
    }, {
      "id": 3185, "n": "灵武市"
    }]
  }, {
    "id": 3186, "n": "石嘴山市", "c": [{
      "id": 3187, "n": "大武口区"
    }, {
      "id": 3188, "n": "惠农区"
    }, {
      "id": 3189, "n": "平罗县"
    }]
  }, {
    "id": 3190, "n": "吴忠市", "c": [{
      "id": 3191, "n": "利通区"
    }, {
      "id": 3192, "n": "红寺堡区"
    }, {
      "id": 3193, "n": "盐池县"
    }, {
      "id": 3194, "n": "同心县"
    }, {
      "id": 3195, "n": "青铜峡市"
    }]
  }, {
    "id": 3196, "n": "固原市", "c": [{
      "id": 3197, "n": "原州区"
    }, {
      "id": 3198, "n": "西吉县"
    }, {
      "id": 3199, "n": "隆德县"
    }, {
      "id": 3200, "n": "泾源县"
    }, {
      "id": 3201, "n": "彭阳县"
    }]
  }, {
    "id": 3202, "n": "中卫市", "c": [{
      "id": 3203, "n": "沙坡头区"
    }, {
      "id": 3204, "n": "中宁县"
    }, {
      "id": 3205, "n": "海原县"
    }]
  }]
}, {
  "id": 3206, "n": "新疆维吾尔自治区", "c": [{
    "id": 3207, "n": "乌鲁木齐市", "c": [{
      "id": 3208, "n": "天山区"
    }, {
      "id": 3209, "n": "沙依巴克区"
    }, {
      "id": 3210, "n": "新市区"
    }, {
      "id": 3211, "n": "水磨沟区"
    }, {
      "id": 3212, "n": "头屯河区"
    }, {
      "id": 3213, "n": "达坂城区"
    }, {
      "id": 3214, "n": "米东区"
    }, {
      "id": 3215, "n": "乌鲁木齐县"
    }]
  }, {
    "id": 3216, "n": "克拉玛依市", "c": [{
      "id": 3217, "n": "独山子区"
    }, {
      "id": 3218, "n": "克拉玛依区"
    }, {
      "id": 3219, "n": "白碱滩区"
    }, {
      "id": 3220, "n": "乌尔禾区"
    }]
  }, {
    "id": 3221, "n": "吐鲁番地区", "c": [{
      "id": 3222, "n": "吐鲁番市"
    }, {
      "id": 3223, "n": "鄯善县"
    }, {
      "id": 3224, "n": "托克逊县"
    }]
  }, {
    "id": 3225, "n": "哈密地区", "c": [{
      "id": 3226, "n": "哈密市"
    }, {
      "id": 3227, "n": "巴里坤哈萨克自治县"
    }, {
      "id": 3228, "n": "伊吾县"
    }]
  }, {
    "id": 3229, "n": "昌吉回族自治州", "c": [{
      "id": 3230, "n": "昌吉市"
    }, {
      "id": 3231, "n": "阜康市"
    }, {
      "id": 3232, "n": "呼图壁县"
    }, {
      "id": 3233, "n": "玛纳斯县"
    }, {
      "id": 3234, "n": "奇台县"
    }, {
      "id": 3235, "n": "吉木萨尔县"
    }, {
      "id": 3236, "n": "木垒哈萨克自治县"
    }]
  }, {
    "id": 3237, "n": "博尔塔拉蒙古自治州", "c": [{
      "id": 3238, "n": "博乐市"
    }, {
      "id": 3239, "n": "阿拉山口市"
    }, {
      "id": 3240, "n": "精河县"
    }, {
      "id": 3241, "n": "温泉县"
    }]
  }, {
    "id": 3242, "n": "巴音郭楞蒙古自治州", "c": [{
      "id": 3243, "n": "库尔勒市"
    }, {
      "id": 3244, "n": "轮台县"
    }, {
      "id": 3245, "n": "尉犁县"
    }, {
      "id": 3246, "n": "若羌县"
    }, {
      "id": 3247, "n": "且末县"
    }, {
      "id": 3248, "n": "焉耆回族自治县"
    }, {
      "id": 3249, "n": "和静县"
    }, {
      "id": 3250, "n": "和硕县"
    }, {
      "id": 3251, "n": "博湖县"
    }]
  }, {
    "id": 3252, "n": "阿克苏地区", "c": [{
      "id": 3253, "n": "阿克苏市"
    }, {
      "id": 3254, "n": "温宿县"
    }, {
      "id": 3255, "n": "库车县"
    }, {
      "id": 3256, "n": "沙雅县"
    }, {
      "id": 3257, "n": "新和县"
    }, {
      "id": 3258, "n": "拜城县"
    }, {
      "id": 3259, "n": "乌什县"
    }, {
      "id": 3260, "n": "阿瓦提县"
    }, {
      "id": 3261, "n": "柯坪县"
    }]
  }, {
    "id": 3262, "n": "克孜勒苏柯尔克孜自治州", "c": [{
      "id": 3263, "n": "阿图什市"
    }, {
      "id": 3264, "n": "阿克陶县"
    }, {
      "id": 3265, "n": "阿合奇县"
    }, {
      "id": 3266, "n": "乌恰县"
    }]
  }, {
    "id": 3267, "n": "喀什地区", "c": [{
      "id": 3268, "n": "喀什市"
    }, {
      "id": 3269, "n": "疏附县"
    }, {
      "id": 3270, "n": "疏勒县"
    }, {
      "id": 3271, "n": "英吉沙县"
    }, {
      "id": 3272, "n": "泽普县"
    }, {
      "id": 3273, "n": "莎车县"
    }, {
      "id": 3274, "n": "叶城县"
    }, {
      "id": 3275, "n": "麦盖提县"
    }, {
      "id": 3276, "n": "岳普湖县"
    }, {
      "id": 3277, "n": "伽师县"
    }, {
      "id": 3278, "n": "巴楚县"
    }, {
      "id": 3279, "n": "塔什库尔干塔吉克自治县"
    }]
  }, {
    "id": 3280, "n": "和田地区", "c": [{
      "id": 3281, "n": "和田市"
    }, {
      "id": 3282, "n": "和田县"
    }, {
      "id": 3283, "n": "墨玉县"
    }, {
      "id": 3284, "n": "皮山县"
    }, {
      "id": 3285, "n": "洛浦县"
    }, {
      "id": 3286, "n": "策勒县"
    }, {
      "id": 3287, "n": "于田县"
    }, {
      "id": 3288, "n": "民丰县"
    }]
  }, {
    "id": 3289, "n": "伊犁哈萨克自治州", "c": [{
      "id": 3290, "n": "伊宁市"
    }, {
      "id": 3291, "n": "奎屯市"
    }, {
      "id": 3292, "n": "霍尔果斯市"
    }, {
      "id": 3293, "n": "伊宁县"
    }, {
      "id": 3294, "n": "察布查尔锡伯自治县"
    }, {
      "id": 3295, "n": "霍城县"
    }, {
      "id": 3296, "n": "巩留县"
    }, {
      "id": 3297, "n": "新源县"
    }, {
      "id": 3298, "n": "昭苏县"
    }, {
      "id": 3299, "n": "特克斯县"
    }, {
      "id": 3300, "n": "尼勒克县"
    }]
  }, {
    "id": 3301, "n": "塔城地区", "c": [{
      "id": 3302, "n": "塔城市"
    }, {
      "id": 3303, "n": "乌苏市"
    }, {
      "id": 3304, "n": "额敏县"
    }, {
      "id": 3305, "n": "沙湾县"
    }, {
      "id": 3306, "n": "托里县"
    }, {
      "id": 3307, "n": "裕民县"
    }, {
      "id": 3308, "n": "和布克赛尔蒙古自治县"
    }]
  }, {
    "id": 3309, "n": "阿勒泰地区", "c": [{
      "id": 3310, "n": "阿勒泰市"
    }, {
      "id": 3311, "n": "布尔津县"
    }, {
      "id": 3312, "n": "富蕴县"
    }, {
      "id": 3313, "n": "福海县"
    }, {
      "id": 3314, "n": "哈巴河县"
    }, {
      "id": 3315, "n": "青河县"
    }, {
      "id": 3316, "n": "吉木乃县"
    }]
  }, {
    "id": 3317, "n": "直辖县级", "c": [{
      "id": 3318, "n": "石河子市"
    }, {
      "id": 3319, "n": "阿拉尔市"
    }, {
      "id": 3320, "n": "图木舒克市"
    }, {
      "id": 3321, "n": "五家渠市"
    }, {
      "id": 3322, "n": "北屯市"
    }, {
      "id": 3323, "n": "铁门关市"
    }, {
      "id": 3324, "n": "双河市"
    }]
  }]
}, {
  "id": 3325, "n": "台湾", "c": [{
    "id": 3326, "n": "台北市", "c": [{
      "id": 3327, "n": "松山区"
    }, {
      "id": 3328, "n": "信义区"
    }, {
      "id": 3329, "n": "大安区"
    }, {
      "id": 3330, "n": "中山区"
    }, {
      "id": 3331, "n": "中正区"
    }, {
      "id": 3332, "n": "大同区"
    }, {
      "id": 3333, "n": "万华区"
    }, {
      "id": 3334, "n": "文山区"
    }, {
      "id": 3335, "n": "南港区"
    }, {
      "id": 3336, "n": "内湖区"
    }, {
      "id": 3337, "n": "士林区"
    }, {
      "id": 3338, "n": "北投区"
    }]
  }, {
    "id": 3339, "n": "高雄市", "c": [{
      "id": 3340, "n": "盐埕区"
    }, {
      "id": 3341, "n": "鼓山区"
    }, {
      "id": 3342, "n": "左营区"
    }, {
      "id": 3343, "n": "楠梓区"
    }, {
      "id": 3344, "n": "三民区"
    }, {
      "id": 3345, "n": "新兴区"
    }, {
      "id": 3346, "n": "前金区"
    }, {
      "id": 3347, "n": "苓雅区"
    }, {
      "id": 3348, "n": "前镇区"
    }, {
      "id": 3349, "n": "旗津区"
    }, {
      "id": 3350, "n": "小港区"
    }, {
      "id": 3351, "n": "凤山区"
    }, {
      "id": 3352, "n": "林园区"
    }, {
      "id": 3353, "n": "大寮区"
    }, {
      "id": 3354, "n": "大树区"
    }, {
      "id": 3355, "n": "大社区"
    }, {
      "id": 3356, "n": "仁武区"
    }, {
      "id": 3357, "n": "鸟松区"
    }, {
      "id": 3358, "n": "冈山区"
    }, {
      "id": 3359, "n": "桥头区"
    }, {
      "id": 3360, "n": "燕巢区"
    }, {
      "id": 3361, "n": "田寮区"
    }, {
      "id": 3362, "n": "阿莲区"
    }, {
      "id": 3363, "n": "路竹区"
    }, {
      "id": 3364, "n": "湖内区"
    }, {
      "id": 3365, "n": "茄萣区"
    }, {
      "id": 3366, "n": "永安区"
    }, {
      "id": 3367, "n": "弥陀区"
    }, {
      "id": 3368, "n": "梓官区"
    }, {
      "id": 3369, "n": "旗山区"
    }, {
      "id": 3370, "n": "美浓区"
    }, {
      "id": 3371, "n": "六龟区"
    }, {
      "id": 3372, "n": "甲仙区"
    }, {
      "id": 3373, "n": "杉林区"
    }, {
      "id": 3374, "n": "内门区"
    }, {
      "id": 3375, "n": "茂林区"
    }, {
      "id": 3376, "n": "桃源区"
    }, {
      "id": 3377, "n": "那玛夏区"
    }]
  }, {
    "id": 3378, "n": "基隆市", "c": [{
      "id": 3379, "n": "中正区"
    }, {
      "id": 3380, "n": "七堵区"
    }, {
      "id": 3381, "n": "暖暖区"
    }, {
      "id": 3382, "n": "仁爱区"
    }, {
      "id": 3383, "n": "中山区"
    }, {
      "id": 3384, "n": "安乐区"
    }, {
      "id": 3385, "n": "信义区"
    }]
  }, {
    "id": 3386, "n": "台中市", "c": [{
      "id": 3387, "n": "中区"
    }, {
      "id": 3388, "n": "东区"
    }, {
      "id": 3389, "n": "南区"
    }, {
      "id": 3390, "n": "西区"
    }, {
      "id": 3391, "n": "北区"
    }, {
      "id": 3392, "n": "西屯区"
    }, {
      "id": 3393, "n": "南屯区"
    }, {
      "id": 3394, "n": "北屯区"
    }, {
      "id": 3395, "n": "丰原区"
    }, {
      "id": 3396, "n": "东势区"
    }, {
      "id": 3397, "n": "大甲区"
    }, {
      "id": 3398, "n": "清水区"
    }, {
      "id": 3399, "n": "沙鹿区"
    }, {
      "id": 3400, "n": "梧栖区"
    }, {
      "id": 3401, "n": "后里区"
    }, {
      "id": 3402, "n": "神冈区"
    }, {
      "id": 3403, "n": "潭子区"
    }, {
      "id": 3404, "n": "大雅区"
    }, {
      "id": 3405, "n": "新社区"
    }, {
      "id": 3406, "n": "石冈区"
    }, {
      "id": 3407, "n": "外埔区"
    }, {
      "id": 3408, "n": "大安区"
    }, {
      "id": 3409, "n": "乌日区"
    }, {
      "id": 3410, "n": "大肚区"
    }, {
      "id": 3411, "n": "龙井区"
    }, {
      "id": 3412, "n": "雾峰区"
    }, {
      "id": 3413, "n": "太平区"
    }, {
      "id": 3414, "n": "大里区"
    }, {
      "id": 3415, "n": "和平区"
    }]
  }, {
    "id": 3416, "n": "台南市", "c": [{
      "id": 3417, "n": "东区"
    }, {
      "id": 3418, "n": "南区"
    }, {
      "id": 3419, "n": "北区"
    }, {
      "id": 3420, "n": "安南区"
    }, {
      "id": 3421, "n": "安平区"
    }, {
      "id": 3422, "n": "中西区"
    }, {
      "id": 3423, "n": "新营区"
    }, {
      "id": 3424, "n": "盐水区"
    }, {
      "id": 3425, "n": "白河区"
    }, {
      "id": 3426, "n": "柳营区"
    }, {
      "id": 3427, "n": "后壁区"
    }, {
      "id": 3428, "n": "东山区"
    }, {
      "id": 3429, "n": "麻豆区"
    }, {
      "id": 3430, "n": "下营区"
    }, {
      "id": 3431, "n": "六甲区"
    }, {
      "id": 3432, "n": "官田区"
    }, {
      "id": 3433, "n": "大内区"
    }, {
      "id": 3434, "n": "佳里区"
    }, {
      "id": 3435, "n": "学甲区"
    }, {
      "id": 3436, "n": "西港区"
    }, {
      "id": 3437, "n": "七股区"
    }, {
      "id": 3438, "n": "将军区"
    }, {
      "id": 3439, "n": "北门区"
    }, {
      "id": 3440, "n": "新化区"
    }, {
      "id": 3441, "n": "善化区"
    }, {
      "id": 3442, "n": "新市区"
    }, {
      "id": 3443, "n": "安定区"
    }, {
      "id": 3444, "n": "山上区"
    }, {
      "id": 3445, "n": "玉井区"
    }, {
      "id": 3446, "n": "楠西区"
    }, {
      "id": 3447, "n": "南化区"
    }, {
      "id": 3448, "n": "左镇区"
    }, {
      "id": 3449, "n": "仁德区"
    }, {
      "id": 3450, "n": "归仁区"
    }, {
      "id": 3451, "n": "关庙区"
    }, {
      "id": 3452, "n": "龙崎区"
    }, {
      "id": 3453, "n": "永康区"
    }]
  }, {
    "id": 3454, "n": "新竹市", "c": [{
      "id": 3455, "n": "东区"
    }, {
      "id": 3456, "n": "北区"
    }, {
      "id": 3457, "n": "香山区"
    }]
  }, {
    "id": 3458, "n": "嘉义市", "c": [{
      "id": 3459, "n": "东区"
    }, {
      "id": 3460, "n": "西区"
    }]
  }, {
    "id": 3461, "n": "新北市", "c": [{
      "id": 3462, "n": "板桥区"
    }, {
      "id": 3463, "n": "三重区"
    }, {
      "id": 3464, "n": "中和区"
    }, {
      "id": 3465, "n": "永和区"
    }, {
      "id": 3466, "n": "新庄区"
    }, {
      "id": 3467, "n": "新店区"
    }, {
      "id": 3468, "n": "树林区"
    }, {
      "id": 3469, "n": "莺歌区"
    }, {
      "id": 3470, "n": "三峡区"
    }, {
      "id": 3471, "n": "淡水区"
    }, {
      "id": 3472, "n": "汐止区"
    }, {
      "id": 3473, "n": "瑞芳区"
    }, {
      "id": 3474, "n": "土城区"
    }, {
      "id": 3475, "n": "芦洲区"
    }, {
      "id": 3476, "n": "五股区"
    }, {
      "id": 3477, "n": "泰山区"
    }, {
      "id": 3478, "n": "林口区"
    }, {
      "id": 3479, "n": "深坑区"
    }, {
      "id": 3480, "n": "石碇区"
    }, {
      "id": 3481, "n": "坪林区"
    }, {
      "id": 3482, "n": "三芝区"
    }, {
      "id": 3483, "n": "石门区"
    }, {
      "id": 3484, "n": "八里区"
    }, {
      "id": 3485, "n": "平溪区"
    }, {
      "id": 3486, "n": "双溪区"
    }, {
      "id": 3487, "n": "贡寮区"
    }, {
      "id": 3488, "n": "金山区"
    }, {
      "id": 3489, "n": "万里区"
    }, {
      "id": 3490, "n": "乌来区"
    }]
  }, {
    "id": 3491, "n": "宜兰县", "c": [{
      "id": 3492, "n": "宜兰市"
    }, {
      "id": 3493, "n": "罗东镇"
    }, {
      "id": 3494, "n": "苏澳镇"
    }, {
      "id": 3495, "n": "头城镇"
    }, {
      "id": 3496, "n": "礁溪乡"
    }, {
      "id": 3497, "n": "壮围乡"
    }, {
      "id": 3498, "n": "员山乡"
    }, {
      "id": 3499, "n": "冬山乡"
    }, {
      "id": 3500, "n": "五结乡"
    }, {
      "id": 3501, "n": "三星乡"
    }, {
      "id": 3502, "n": "大同乡"
    }, {
      "id": 3503, "n": "南澳乡"
    }]
  }, {
    "id": 3504, "n": "桃园县", "c": [{
      "id": 3505, "n": "桃园市"
    }, {
      "id": 3506, "n": "中坜市"
    }, {
      "id": 3507, "n": "平镇市"
    }, {
      "id": 3508, "n": "八德市"
    }, {
      "id": 3509, "n": "杨梅市"
    }, {
      "id": 3510, "n": "芦竹市"
    }, {
      "id": 3511, "n": "大溪镇"
    }, {
      "id": 3512, "n": "大园乡"
    }, {
      "id": 3513, "n": "龟山乡"
    }, {
      "id": 3514, "n": "龙潭乡"
    }, {
      "id": 3515, "n": "新屋乡"
    }, {
      "id": 3516, "n": "观音乡"
    }, {
      "id": 3517, "n": "复兴乡"
    }]
  }, {
    "id": 3518, "n": "新竹县", "c": [{
      "id": 3519, "n": "竹北市"
    }, {
      "id": 3520, "n": "竹东镇"
    }, {
      "id": 3521, "n": "新埔镇"
    }, {
      "id": 3522, "n": "关西镇"
    }, {
      "id": 3523, "n": "湖口乡"
    }, {
      "id": 3524, "n": "新丰乡"
    }, {
      "id": 3525, "n": "芎林乡"
    }, {
      "id": 3526, "n": "横山乡"
    }, {
      "id": 3527, "n": "北埔乡"
    }, {
      "id": 3528, "n": "宝山乡"
    }, {
      "id": 3529, "n": "峨眉乡"
    }, {
      "id": 3530, "n": "尖石乡"
    }, {
      "id": 3531, "n": "五峰乡"
    }]
  }, {
    "id": 3532, "n": "苗栗县", "c": [{
      "id": 3533, "n": "苗栗市"
    }, {
      "id": 3534, "n": "苑里镇"
    }, {
      "id": 3535, "n": "通霄镇"
    }, {
      "id": 3536, "n": "竹南镇"
    }, {
      "id": 3537, "n": "头份镇"
    }, {
      "id": 3538, "n": "后龙镇"
    }, {
      "id": 3539, "n": "卓兰镇"
    }, {
      "id": 3540, "n": "大湖乡"
    }, {
      "id": 3541, "n": "公馆乡"
    }, {
      "id": 3542, "n": "铜锣乡"
    }, {
      "id": 3543, "n": "南庄乡"
    }, {
      "id": 3544, "n": "头屋乡"
    }, {
      "id": 3545, "n": "三义乡"
    }, {
      "id": 3546, "n": "西湖乡"
    }, {
      "id": 3547, "n": "造桥乡"
    }, {
      "id": 3548, "n": "三湾乡"
    }, {
      "id": 3549, "n": "狮潭乡"
    }, {
      "id": 3550, "n": "泰安乡"
    }]
  }, {
    "id": 3551, "n": "彰化县", "c": [{
      "id": 3552, "n": "彰化市"
    }, {
      "id": 3553, "n": "鹿港镇"
    }, {
      "id": 3554, "n": "和美镇"
    }, {
      "id": 3555, "n": "线西乡"
    }, {
      "id": 3556, "n": "伸港乡"
    }, {
      "id": 3557, "n": "福兴乡"
    }, {
      "id": 3558, "n": "秀水乡"
    }, {
      "id": 3559, "n": "花坛乡"
    }, {
      "id": 3560, "n": "芬园乡"
    }, {
      "id": 3561, "n": "员林镇"
    }, {
      "id": 3562, "n": "溪湖镇"
    }, {
      "id": 3563, "n": "田中镇"
    }, {
      "id": 3564, "n": "大村乡"
    }, {
      "id": 3565, "n": "埔盐乡"
    }, {
      "id": 3566, "n": "埔心乡"
    }, {
      "id": 3567, "n": "永靖乡"
    }, {
      "id": 3568, "n": "社头乡"
    }, {
      "id": 3569, "n": "二水乡"
    }, {
      "id": 3570, "n": "北斗镇"
    }, {
      "id": 3571, "n": "二林镇"
    }, {
      "id": 3572, "n": "田尾乡"
    }, {
      "id": 3573, "n": "埤头乡"
    }, {
      "id": 3574, "n": "芳苑乡"
    }, {
      "id": 3575, "n": "大城乡"
    }, {
      "id": 3576, "n": "竹塘乡"
    }, {
      "id": 3577, "n": "溪州乡"
    }]
  }, {
    "id": 3578, "n": "南投县", "c": [{
      "id": 3579, "n": "南投市"
    }, {
      "id": 3580, "n": "埔里镇"
    }, {
      "id": 3581, "n": "草屯镇"
    }, {
      "id": 3582, "n": "竹山镇"
    }, {
      "id": 3583, "n": "集集镇"
    }, {
      "id": 3584, "n": "名间乡"
    }, {
      "id": 3585, "n": "鹿谷乡"
    }, {
      "id": 3586, "n": "中寮乡"
    }, {
      "id": 3587, "n": "鱼池乡"
    }, {
      "id": 3588, "n": "国姓乡"
    }, {
      "id": 3589, "n": "水里乡"
    }, {
      "id": 3590, "n": "信义乡"
    }, {
      "id": 3591, "n": "仁爱乡"
    }]
  }, {
    "id": 3592, "n": "云林县", "c": [{
      "id": 3593, "n": "斗六市"
    }, {
      "id": 3594, "n": "斗南镇"
    }, {
      "id": 3595, "n": "虎尾镇"
    }, {
      "id": 3596, "n": "西螺镇"
    }, {
      "id": 3597, "n": "土库镇"
    }, {
      "id": 3598, "n": "北港镇"
    }, {
      "id": 3599, "n": "古坑乡"
    }, {
      "id": 3600, "n": "大埤乡"
    }, {
      "id": 3601, "n": "莿桐乡"
    }, {
      "id": 3602, "n": "林内乡"
    }, {
      "id": 3603, "n": "二仑乡"
    }, {
      "id": 3604, "n": "仑背乡"
    }, {
      "id": 3605, "n": "麦寮乡"
    }, {
      "id": 3606, "n": "东势乡"
    }, {
      "id": 3607, "n": "褒忠乡"
    }, {
      "id": 3608, "n": "台西乡"
    }, {
      "id": 3609, "n": "元长乡"
    }, {
      "id": 3610, "n": "四湖乡"
    }, {
      "id": 3611, "n": "口湖乡"
    }, {
      "id": 3612, "n": "水林乡"
    }]
  }, {
    "id": 3613, "n": "嘉义县", "c": [{
      "id": 3614, "n": "太保市"
    }, {
      "id": 3615, "n": "朴子市"
    }, {
      "id": 3616, "n": "布袋镇"
    }, {
      "id": 3617, "n": "大林镇"
    }, {
      "id": 3618, "n": "民雄乡"
    }, {
      "id": 3619, "n": "溪口乡"
    }, {
      "id": 3620, "n": "新港乡"
    }, {
      "id": 3621, "n": "六脚乡"
    }, {
      "id": 3622, "n": "东石乡"
    }, {
      "id": 3623, "n": "义竹乡"
    }, {
      "id": 3624, "n": "鹿草乡"
    }, {
      "id": 3625, "n": "水上乡"
    }, {
      "id": 3626, "n": "中埔乡"
    }, {
      "id": 3627, "n": "竹崎乡"
    }, {
      "id": 3628, "n": "梅山乡"
    }, {
      "id": 3629, "n": "番路乡"
    }, {
      "id": 3630, "n": "大埔乡"
    }, {
      "id": 3631, "n": "阿里山乡"
    }]
  }, {
    "id": 3632, "n": "屏东县", "c": [{
      "id": 3633, "n": "屏东市"
    }, {
      "id": 3634, "n": "潮州镇"
    }, {
      "id": 3635, "n": "东港镇"
    }, {
      "id": 3636, "n": "恒春镇"
    }, {
      "id": 3637, "n": "万丹乡"
    }, {
      "id": 3638, "n": "长治乡"
    }, {
      "id": 3639, "n": "麟洛乡"
    }, {
      "id": 3640, "n": "九如乡"
    }, {
      "id": 3641, "n": "里港乡"
    }, {
      "id": 3642, "n": "盐埔乡"
    }, {
      "id": 3643, "n": "高树乡"
    }, {
      "id": 3644, "n": "万峦乡"
    }, {
      "id": 3645, "n": "内埔乡"
    }, {
      "id": 3646, "n": "竹田乡"
    }, {
      "id": 3647, "n": "新埤乡"
    }, {
      "id": 3648, "n": "枋寮乡"
    }, {
      "id": 3649, "n": "新园乡"
    }, {
      "id": 3650, "n": "崁顶乡"
    }, {
      "id": 3651, "n": "林边乡"
    }, {
      "id": 3652, "n": "南州乡"
    }, {
      "id": 3653, "n": "佳冬乡"
    }, {
      "id": 3654, "n": "琉球乡"
    }, {
      "id": 3655, "n": "车城乡"
    }, {
      "id": 3656, "n": "满州乡"
    }, {
      "id": 3657, "n": "枋山乡"
    }, {
      "id": 3658, "n": "三地门乡"
    }, {
      "id": 3659, "n": "雾台乡"
    }, {
      "id": 3660, "n": "玛家乡"
    }, {
      "id": 3661, "n": "泰武乡"
    }, {
      "id": 3662, "n": "来义乡"
    }, {
      "id": 3663, "n": "春日乡"
    }, {
      "id": 3664, "n": "狮子乡"
    }, {
      "id": 3665, "n": "牡丹乡"
    }]
  }, {
    "id": 3666, "n": "台东县", "c": [{
      "id": 3667, "n": "台东市"
    }, {
      "id": 3668, "n": "成功镇"
    }, {
      "id": 3669, "n": "关山镇"
    }, {
      "id": 3670, "n": "卑南乡"
    }, {
      "id": 3671, "n": "鹿野乡"
    }, {
      "id": 3672, "n": "池上乡"
    }, {
      "id": 3673, "n": "东河乡"
    }, {
      "id": 3674, "n": "长滨乡"
    }, {
      "id": 3675, "n": "太麻里乡"
    }, {
      "id": 3676, "n": "大武乡"
    }, {
      "id": 3677, "n": "绿岛乡"
    }, {
      "id": 3678, "n": "海端乡"
    }, {
      "id": 3679, "n": "延平乡"
    }, {
      "id": 3680, "n": "金峰乡"
    }, {
      "id": 3681, "n": "达仁乡"
    }, {
      "id": 3682, "n": "兰屿乡"
    }]
  }, {
    "id": 3683, "n": "花莲县", "c": [{
      "id": 3684, "n": "花莲市"
    }, {
      "id": 3685, "n": "凤林镇"
    }, {
      "id": 3686, "n": "玉里镇"
    }, {
      "id": 3687, "n": "新城乡"
    }, {
      "id": 3688, "n": "吉安乡"
    }, {
      "id": 3689, "n": "寿丰乡"
    }, {
      "id": 3690, "n": "光复乡"
    }, {
      "id": 3691, "n": "丰滨乡"
    }, {
      "id": 3692, "n": "瑞穗乡"
    }, {
      "id": 3693, "n": "富里乡"
    }, {
      "id": 3694, "n": "秀林乡"
    }, {
      "id": 3695, "n": "万荣乡"
    }, {
      "id": 3696, "n": "卓溪乡"
    }]
  }, {
    "id": 3697, "n": "澎湖县", "c": [{
      "id": 3698, "n": "马公市"
    }, {
      "id": 3699, "n": "湖西乡"
    }, {
      "id": 3700, "n": "白沙乡"
    }, {
      "id": 3701, "n": "西屿乡"
    }, {
      "id": 3702, "n": "望安乡"
    }, {
      "id": 3703, "n": "七美乡"
    }]
  }, {
    "id": 3704, "n": "金门县", "c": [{
      "id": 3705, "n": "金城镇"
    }, {
      "id": 3706, "n": "金湖镇"
    }, {
      "id": 3707, "n": "金沙镇"
    }, {
      "id": 3708, "n": "金宁乡"
    }, {
      "id": 3709, "n": "烈屿乡"
    }, {
      "id": 3710, "n": "乌丘乡"
    }]
  }, {
    "id": 3711, "n": "连江县", "c": [{
      "id": 3712, "n": "南竿乡"
    }, {
      "id": 3713, "n": "北竿乡"
    }, {
      "id": 3714, "n": "莒光乡"
    }, {
      "id": 3715, "n": "东引乡"
    }]
  }]
}, {
  "id": 3716, "n": "香港特别行政区", "c": [{
    "id": 3717, "n": "香港岛", "c": [{
      "id": 3718, "n": "中西区"
    }, {
      "id": 3719, "n": "湾仔区"
    }, {
      "id": 3720, "n": "东区"
    }, {
      "id": 3721, "n": "南区"
    }]
  }, {
    "id": 3722, "n": "九龙", "c": [{
      "id": 3723, "n": "油尖旺区"
    }, {
      "id": 3724, "n": "深水埗区"
    }, {
      "id": 3725, "n": "九龙城区"
    }, {
      "id": 3726, "n": "黄大仙区"
    }, {
      "id": 3727, "n": "观塘区"
    }]
  }, {
    "id": 3728, "n": "新界", "c": [{
      "id": 3729, "n": "荃湾区"
    }, {
      "id": 3730, "n": "屯门区"
    }, {
      "id": 3731, "n": "元朗区"
    }, {
      "id": 3732, "n": "北区"
    }, {
      "id": 3733, "n": "大埔区"
    }, {
      "id": 3734, "n": "西贡区"
    }, {
      "id": 3735, "n": "沙田区"
    }, {
      "id": 3736, "n": "葵青区"
    }, {
      "id": 3737, "n": "离岛区"
    }]
  }]
}, {
  "id": 3738, "n": "澳门特别行政区", "c": [{
    "id": 3739, "n": "澳门半岛", "c": [{
      "id": 3740, "n": "花地玛堂区"
    }, {
      "id": 3741, "n": "圣安多尼堂区"
    }, {
      "id": 3742, "n": "大堂区"
    }, {
      "id": 3743, "n": "望德堂区"
    }, {
      "id": 3744, "n": "风顺堂区"
    }]
  }, {
    "id": 3745, "n": "氹仔岛", "c": [{
      "id": 3746, "n": "嘉模堂区"
    }]
  }, {
    "id": 3747, "n": "路环岛", "c": [{
      "id": 3748, "n": "圣方济各堂区"
    }]
  }]
}];
